import { supportEmailaddr } from "../constants";

export const gESAppsString =
{
    "OK": "OK",
    "Cancel": "Cancelar",
    "Yes": "Sí",
    "No": "No",
    "Reset": "Reiniciar",
    "Search": "Buscar",
    "Add": "Añadir",
    "Delete": "Eliminar",
    "Rename": "Renombrar",
    "Up": "Arriba",
    "Down": "Abajo",
    "To": "A",
    "results": "Resultados",
    "Edit": "Editar",
    "Arrange": "Acomodo",
    "Rules": "Reglas",
    "Default": "Predeterminado",
    "Open": "Abrir",
    "Save": "Guardar",
    "Duplicate": "Duplicar",
    "Min": "Mínimo",
    "Max": "Máximo",
    "min": "MIN",
    "max": "MAX",
    "Role": "Función",
    "Name": "Nombre",
    "Title": "Titulo",
    "Subtract": "Sustraer",
    "Multiply": "Multiplicar",
    "Divide": "Dividir",
    "Average": "Promedio",
    "Count": "Contar",
    "Sum": "Suma",
    "Split": "División",
    "topbox": "Cuadro superior",
    "Span": "Lapso",
    "Location": "Localización",
    "Department": "Departamento",
    "WorkPhone": "Teléfono de trabajo",
    "Orphan": "Huérfano",
    "TopOfSubChart": "Inicio sub organigrama",
    "Level": "Nivel",
    "SubChartLevel": "Nivel del organigrama",
    "SpanOfControl": "Ámbito de control",
    "Subordinates": "Subordinados",
    "Headcount": "Conteo plantilla",
    "ReportsTo": "Reporte A",
    "ReportsToName": "Nombre de jefe",
    "NewSuperID": "ID super nuevo",
    "complexpass": "Requiere contraseñas complejas",
    "forcepass": "Forzar cambio de contraseña después de reinicio",
    "smspass": "Usar SMS para recuperar contraseña",
    "contentlock": "Bloquear contenido",
    "layoutlock": "Bloquear diseño",
    "hierlock": "Bloqueo de subordinado a gerente",
    "persistlock": "No eliminar (Para cuadros añadidos manualmente)",
    "lockmsg": "Actualización de datos no actualizara elementos bloqueados.",
    "Locking": "Bloquear",
    "New": "Nueva",
    "Import": "Importar",
    "refreshorg": "Actualizar organigrama",
    "Configure": "Configurar",
    "clickhidden": "Haga clic aquí para mostrar los elementos ocultos",
    "FILE": "ARCHIVO",
    "DOCUMENT": "Documento",
    "EDIT": "EDITAR",
    "EDITM": "MAESTRO DE EDICIÓN",
    "INSERT": "INSERTAR",
    "DATA": "DATOS",
    "VIEW": "VISTA",
    "IMPORT": "IMPORTAR DATOS",
    "REFRESH": "Actualizar",
    "SHARE": "COMPARTIR",
    "HELP": "Ayuda",
    "Launch": "Ejecutar",
    "Access": "Acceso",
    "Scheduler": "Programador",
    "enablesched": "Actualización automática de organigrama",
    "frequency": "Frecuencia",
    "Daily": "Diariamente",
    "Weekly": "Semanalmente",
    "Bi-Weekly": "Quincenal",
    "Quarterly": "Trimestral",
    "First Day": "Primer día",
    "Last Day": "Último día",
    "Annually": "Anual",
    "gmttime": "Horario (GMT)",
    "dayofweek": "Dia",
    "emailnote": "Notificación de correo",
    "emailtxt": "Ingrese lista delimitada por comas",
    "schedulerna": "Programador no disponible en prueba gratuita.",
    "Position": "Posición",
    "Assistant": "Asistente",
    "Root": "Raíz",
    "AutoText": "Texto automático",
    "Image": "Imagen",
    "Table": "Tabla",
    "Legend": "Leyenda",
    "Select": "Seleccionar",
    "Pan": "Panorámica",
    "Move": "Mover",
    "moveobj": "Mover organigrama u objeto",
    "movebox": "Mover cuadro o rama",
    "addsub": "Añadir cuadro de sub.",
    "addassist": "Añadir cuadro de asistente",
    "addsubtool": "Añadir cuadro",
    "moveboxtool": "Mover cuadro",
    "moveobjtool": "Mover objeto",
    "Cut": "Cortar",
    "Copy": "Copiar",
    "Paste": "Pegar",
    "copyformat": "Copiar formato",
    "insertbreak": "Insertar división de sub.",
    "removebreak": "Remover división de sub.",
    "maketop": "Convertir inicio de página",
    "branchstyles": "Estilo de rama",
    "selbranchstyle": "Seleccionar estilo de rama",
    "resizeimage": "Cambiar el tamaño de la imagen",
    "imageinfo": "Propiedades de imagen",
    "branchstyleerr1": "Selección de rama no permitido.",
    "branchstyleerr2": "un mínimo de 2 cuadros seleccionados.",
    "branchstyleerr3": "Selección invalida. Todas los cuadros deben de tener el mismo gerente.",
    "branchstyleerr4": "Selección invalida. División de organigramas no permitida.",
    "addboxerr1": "Adición invalida. Profundizar para añadir cuadro.",
    "addboxerr2": "Adición invalida. Añadir al primer miembro del grupo del gerente adjunto.",
    "Header1": "Encabezado1",
    "Header2": "Encabezado2",
    "nousertemps": "Todas las vistas han sido utilizadas (o no han sido definidas). Utilice el panel de vistas para crear vistas adicionales.",
    "Insert": "Insertar",
    "Remove": "Remover",
    "Lock": "Bloquear",
    "Locked": "Bloqueado",
    "Persist": "Persistente",
    "filelocked": "Usted no tiene permiso para modificar el archivo. Archivo o carpetas bloqueado.",
    "folderlocked": "No tiene permiso para cambiar el nombre o eliminar la carpeta.",
    "Wizard": "Asistente",
    "Normal": "Normal",
    "Master": "Maestro",
    "Apply": "Aplicar",
    "nofill": "Sin relleno",
    "customcolor": "Color personalizado",
    "enterrgb": "RRGGBB",
    "colorvalmin": "Color invalido",
    "hexcolor": "Ingresar color HEX",
    "solidfill": "Relleno sólido",
    "gradientfill": "Relleno degradado",
    "Gradient": "Degradado",
    "Linear Gradient": "Degradado lineal",
    "Radial Gradient": "Degradado radial",
    "dashline": "Línea punteada",
    "triangle": "Triangulo",
    "separator": "Separador",
    "solidborder": "Borde sólido",
    "dashedborder": "Borde punteado",
    "solidline": "Solido",
    "dashedline": "Punteado",
    "hideline": "Ocultar",
    "moreoptions": "Mas opciones...",
    "linegroup": "Grupo de líneas",
    "linesubgroup": "Subgrupo de líneas",
    "clearsubgroup": "Limpiar subgrupo",
    "nomask": "Sin mascara",
    "cirmask": "Mascara circular",
    "noborder": "Sin borde",
    "singleborder": "Borde único",
    "dblborder": "Borde doble",
    "Label": "Etiqueta",
    "labelvalue": "Etiqueta:Valor",
    "Next": "Siguiente",
    "Prev": "Previo",
    "Next (short)": "Sig.",
    "Prev (short)": "Prev.",
    "Previous": "Previo",
    "findwhat": "Buscar",
    "selectmatches": "Selecc. Coincid",
    "replacewith": "Buscar remplazar",
    "Replace": "Remplazar",
    "replaceall": "Remplazar todo",
    "box": "cuadro",
    "boxes": "cuadros",
    "Box": "Cuadro",
    "Boxes": "Cuadros",
    "Layout": "Diseño",
    "Setup": "Configurar",
    "Template": "Vista",
    "Copyright": "Derechos reservados",
    "Version": "Versión",
    "Allrights": "Todos los derechos reservados.",
    "Edition": "Edición",
    "SupportMsg": "si el problema persiste contáctenos",
    "SalesMsg": "Para mayor información contactarnos",
    "comingsoon": "Próximamente!",
    "Help": "Ayuda",
    "Profile": "Perfil",
    "Templates": "Vistas",
    "Parking": "En espera",
    "Box Styles": "Est. cuadro",
    "Box Style": "Estilo de cuadro",
    "applychanges": "Aplicar cambios a",
    "howto": "¿Cómo?",
    "Tutorials": "Tutoriales",
    "Videos": "Videos",
    "OnlineDocs": "Documentos en línea",
    "Guide": "Guía",
    "iwizselectmsg1": "El asistente de importación crea automáticamente un organigrama desde un archivo exel.",
    "iwizselectmsg2": "Si usted necesita crear un archivo exel, descargue la hoja de cálculo de ejemplo y modifíquela a sus necesidades.",
    "iwizselectmsg3": "Todos los archivos de datos deben de ser cargados a su cuenta de almacenamiento en la nube antes de ser utilizados.",
    "iwizselectmsg4": "Haga clic en el botón 'Importación de datos' para importar un archivo desde almacenamiento en la nube.",
    "iwizselectsample": "Ejemplo",
    "iwizselectupload": "Cargar archivos",
    "iwizselectimport": "Importar datos",
    "iwizselectSAPmsg1": "El asistente de importación crea automáticamente un organigrama desde un archivo SAP XML.",
    "iwizselectSAPmsg2": "favor de contactar al soporte técnico para asistencia sobre exportación de datos desde sistema SAP.",
    "iwizselectSAPmsg3": "Todos los archivos de datos deben de ser cargados a su cuenta de almacenamiento en la nube antes de ser utilizados.",
    "iwizselectSAPmsg4": "Haga clic en el botón 'Importación de datos' para importar un archivo desde su almacenamiento en la nube.",
    "iwizfiltermsg1": "Opcionalmente, usted puede filtrar su fuente de datos.",
    "iwizfiltermsg2": "únicamente los registros que coinciden con los filtros específicos serán importados.",
    "iwizfilterchk": "Especifique el filtro de datos",
    "iwizautobreakchk": "Divide automáticamente paginas amplias",
    "buildhier1": "Favor de identificar los campos requeridos y los opcionales.",
    "buildhier2": "Si su base de datos no cuenta con los campos de jerarquía (ID de persona y ID de supervisor), usted puede hacerlo manualmente",
    "buildhier3": "tome y arrastre cuadros para modificar el organigrama después de que sus datos hayan sido importados.",
    "buildhier4": "los datos contienen campos jerárquicos",
    "assistwiz1": "Configurar estilos de ramas del asistente basados en reglas o datos.",
    "stdassistantrule": "Utilizar reglas para identificar un asistente estándar",
    "peerassistantrule": "Utilizar reglas para identificar asistente",
    "assistonleft": "Favor de poner el primer asistente a la izquierda del gerente",
    "combinerecords": "Subgrupo por un campo",
    "checkall": "Seleccionar todo",
    "uncheckall": "Deseleccionar todo",
    "levelchartcb": "Crear nivel de organigrama",
    "PersonID": "ID de persona",
    "SupervisorID": "ID de supervisor",
    "iwizerr0": "Cargando vistas. Por favor intente de nuevo.",
    "iwizerr1": "El filtro no encontró ningún registro.",
    "iwizerr2": "Referencia cíclica encontrada. Utilizar la opción 'Especificar cuadro superior' o repare sus datos.",
    "iwizerr3": "Campos ID de personas y/o ID de supervisor no fueron encontrados en la fuente de datos.",
    "iwizerr4": "Demasiados registros para una sola página. Ajuste las opciones del organigrama y vuelva a intentar.",
    "iwizsc1": "Si su organigrama contiene tantas cuadros como para alojarlas en una sola página, usted puede dividir su organigrama en múltiples páginas.",
    "matchonly": "Únicamente coincidencias",
    "directsubs": "Incluir subordinados directos",
    "allsubs": "Incluir todos los subordinados",
    "miniscarrow": "Flecha-miniatura",
    "whitescarrow": "Flecha blanca",
    "blackscarrow": "Flecha negra",
    "autoopenlogin": "Después de acceder:",
    "noautoopen": "No realizar acción",
    "autoopen": "Apertura-automática del organigrama especificado",
    "autoopencur": "Apertura-automática del organigrama actual",
    "genreport": "Generar el reporte de diagnóstico",
    "piccache": "Volver a cargar las fotografías de los empleados",
    "optbs": "Optimizar estilos de ramas",
    "optimizebranch": "Optimizar relación-aspecto:",
    "allowsort": "Reordene los cuadros para ahorrar espacios",
    "prefstyle": "Estilo favorito",
    "tree": "Árbol",
    "twocolumn": "Dos columnas",
    "fourcolumn": "Cuatro columnas",
    "Optimize": "Optimizar",
    "treesingles": "Utilizar estilos de árbol para registros únicos",
    "optimizeall": "Optimizar suborganigrama",
    "interactive": "Modo interactivo",
    "useinches": "Mostrar unidades en pulgadas",
    "usemetric": "Mostrar unidades en centímetros",
    "Back": "Atrás",
    "Field": "Campos",
    "Comparison": "Comparación",
    "Value": "Valor",
    "Upload": "Cargar",
    "Download": "Descargar",
    "Files": "Archivos",
    "files": "archivo",
    "filemgr": "Gestor de archivos",
    "Folders": "Carpetas",
    "Directory": "Directorio",
    "File": "Archivo",
    "Samples": "Ejemplos",
    "Trash": "Papelera",
    "Charts": "Organigramas",
    "orgcharts": "Organigramas",
    "Create": "Crear",
    "Settings": "Ajustes",
    "Cloud": "Nube",
    "sysstyles": "Est. sistema",
    "userstyles": "Est. de usuarios",
    "sharedstyles": "Est. de compartidos",
    "Field Properties": "Propiedades de campos",
    "successupload": "carga exitosa",
    "uploadcncl": "Carga cancelada",
    "uploadfail": "carga fallida",
    "successrupload": "Remplazado con éxito",
    "uploadfailtoobig": "importación abortada – archivo muy grande",
    "uploadfailfiletype": "importación abortada – tipo de archivo inválido",
    "System": "Sistema",
    "Shared": "Compartidos",
    "User": "Usuario",
    "charttemplate": "Vista de organigrama.",
    "optpage": "Optimizar página",
    "showscnum": "Mostrar suborganigrama #",
    "Complex Rule": "Regla compleja",
    "deffilter": "Editar regla...",
    "enterrule": "Introducir regla",
    "testrule": "Probar regla",
    "testmath": "Probar",
    "rulevalid": "Validar regla.",
    "mathvalid": "Validar cálculo.",
    "limitfields": "Restringir la consulta de los campos",
    "nobreaks": "No insertar división",
    "breakbylevel": "Dividir por niveles",
    "breakbyfield": "Dividir por campo",
    "assistrulemanual": "Establecer manualmente estilos de rama para asistentes",
    "assistrulefield": "Utilice el campo 'isAssistant' para establecer el estilo de rama de asistentes",
    "assistruledef": "Utilice las reglas para establecer los estilos de rama de los asistentes",
    "sapouoptions": "Opciones de organigrama para SAP orgUnit",
    "sapoption1": "Convertir desde posición a posición",
    "sapoption2": "Combinar orgUnits y posiciones de jefe",
    "sapoption3": "Separar orgUnits y posiciones",
    "entirechart": "Organigrama completo",
    "selection": "Selección",
    "scopechart": "Utilizar superior del organigrama",
    "scopebranch": "Utilizar rama superior",
    "countif": "CONTAR SI",
    "concatenate": "CONCATENAR",
    "lookup": "BUSCAR",
    "lookupmsg": "Buscar otro valor desde otro registro.",
    "LookupField": "Clave de búsqueda:",
    "LookupValue": "Resultado de búsqueda:",
    "sum": "ACERCAR",
    "average": "PROMEDIO",
    "map": "MAPA",
    "math": "CALCULO",
    "countifdesc": "Contar sólo si el registro coincide con los criterios definidos.",
    "rightcalc": "DERECHA",
    "leftcalc": "IZQUIERDA",
    "leftblank": "El valor no puede estar en blanco.",
    "leftmsg": "Retomar las características a la IZQUIERDA.",
    "rightmsg": "Retomar las características a la DERECHA.",
    "rightleftmsg": "Ingrese # o dividir organigrama",
    "fieldblank2": "Seleccionar campo.",
    "summsg": "Seleccione el campo para acercar.",
    "averagemsg": "Seleccione el campo para promedio.",
    "fieldblank": "Seleccione ampos de búsqueda.",
    "concatblank": "El texto no puede estar en blanco.",
    "concatmsg": "Ingrese texto y campos para concatenar. Encerrar campos entre corchetes.",
    "concatmsg2": "Ejemplo: '[FirstName] [LastName]'",
    "mathmsg": "Ingrese cálculo. Encerrar camps entre corchetes.",
    "mathmsg2": "Ejemplo: '[FieldA]/[FieldB]*100'",
    "mapmsg": "Ingrese mapeo.",
    "mapmsg2": "Ejemplo: '94121':'Richmond', '94122':'Sunset'",
    "boxwidth": "Ancho de cuadro",
    "Fixed": "Fijo",
    "Auto": "Auto",
    "boxheight": "Altura de cuadro",
    "Gutter": "Canal",
    "Options": "Opciones",
    "Properties": "Propiedades",
    "Cell": "Celda",
    "Custom": "Personalizado(a)",
    "aligncells": "Alinear celdas",
    "Preview": "Previsualización",
    "setasdef": "Establecer como formato por defecto",
    "Standard": "Estándar",
    "Dense": "Denso",
    "Manual": "Manual",
    "spacingmode": "Selecc. espaciamiento",
    "adjboxmarg": "Ajustar márgenes de cuadro",
    "adjboxspace": "Ajustar espaciamiento de cuadro",
    "adjboxsubs": "Ajustar espaciamiento de subordinado",
    "enterval": "Ingrese valor",
    "fieldeditor": "Administrador de campos",
    "andor": "Y/O",
    "Height": "Altura",
    "Width": "Ancho",
    "curpagesize": "Tamaño de página actual",
    "minpagesize": "Tamaño mín. de página",
    "showmarg": "Mostrar líneas de márgenes",
    "Margins": "Márgenes",
    "Orientation": "Orientación",
    "headfoot": "Encabezado y pie de página",
    "showheadfoot": "Mostrar líneas de encabezado y pie de página",
    "Top": "Superior",
    "Bottom": "Inferior",
    "Right": "Derecha",
    "Left": "Izquierda",
    "Footer": "Pie de página",
    "letterps": "Carta",
    "legalps": "Oficio",
    "tabloidps": "Tabloide",
    "a0ps": "A0",
    "a1ps": "A1",
    "a2ps": "A2",
    "a3ps": "A3",
    "a4ps": "A4",
    "ppt1ps": "PowerPoint 4:3",
    "ppt2ps": "PowerPoint 16:9",
    "ppt3ps": "PowerPoint 16:10",
    "customps": "Personalizado",
    "widem": "Ancho",
    "extrawidem": "Extra ancho",
    "standardm": "Estándar",
    "narrowm": "Ajustado",
    "customm": "Personalizado",
    "landscape": "Horizontal",
    "portrait": "Vertical",
    "standardh": "Encabezado estándar",
    "noheader": "Sin encabezado",
    "customh": "Personalizado",
    "standardf": "Pie de página estándar",
    "nofooter": "Sin pie de página",
    "customf": "Personalizado",
    "breakfield": "Corte en el campo:",
    "breakevery": "Corte cada:",
    "minbreak": "Suborganigrama mínimo para corte:",
    "selecttemplate": "Seleccione una vista para aplicar al organigrama. Después de crear el organigrama, puede usar el panel de vistas para cambiar a otra vista",
    "createchart": "Crear organigrama",
    "importerr": "El archivo de datos seleccionado no puede ser importado. El siguiente problema require ser resuelto antes de que el archivo sea importado:",
    "unknownerr": "<Error desconocido>",
    "Retry": "Reintentar",
    "importwiz": "Asistente de importación",
    "selectimportfile": "Seleccione el archivo de datos a importar",
    "selectimportsapfile": "Seleccione el archivo select SAP XML a importar",
    "filterdata": "Filtrar datos",
    "buildhier": "Definir campos",
    "assistwiz": "Detección de asistentes",
    "subchartbr": "Asistente de suborganigrama",
    "selectctemplate": "Seleccione una vista de organigrama",
    "unableimport": "No se pueden importar datos",
    "unablebuildhier": "No se puede construir jerarquía",
    "wirehiererr": "No se han definido campos ID persona y/o ID supervisor.",
    "Levels": "Niveles",
    "and": "y",
    "or": "o",
    "Middle": "Medio",
    "ruleorder": "Regla (aplicadas en el orden mostrado)",
    "equals": "igual",
    "notequal": "no es igual",
    "startswith": "inicia con",
    "contains": "contiene",
    "doesnotcontain": "no contiene",
    "isempty": "está vacío",
    "isnotempty": "no está vacío",
    "greater": "mayor a",
    "less": "menor a",
    "Formatting": "Formateo",
    "greaterequal": "mayor o igual a",
    "lessequal": "menor o igual a",
    "inlist": "en la lista",
    "notinlist": "no en la lista",
    "pagenum": "Página #",
    "totalpages": "Total de páginas",
    "pagex": "Página x",
    "pagexy": "Páginas x de y",
    "today": "Hoy",
    "refreshdate": "Fecha act.",
    "lastrefresh": "Última actualización",
    "lastrefreshdatetime": "{date}, a las {time}",
    "subchartname": "Nombre suborganigrama",
    "subchartnum": "Suborganigrama #",
    "subchartpath": "Ruta suborganigrama",
    "filename": "Nombre de archivo",
    "includechain": "Incluir cadena de mando",
    "autofixhier": "Manejar múltiples cabezas de departamento",
    "addexecteam": "Agregar 'Equipo ejecutivo'",
    "january": "Enero",
    "february": "Febrero",
    "march": "Marzo",
    "april": "Abril",
    "may": "Mayo",
    "june": "Junio",
    "july": "Julio",
    "august": "Agosto",
    "september": "Septiembre",
    "october": "Octubre",
    "november": "Noviembre",
    "december": "Diciembre",
    "jan": "Ene",
    "feb": "Feb",
    "mar": "Mar",
    "apr": "Abr",
    "jun": "Jun",
    "jul": "Jul",
    "aug": "Ago",
    "sep": "Sep",
    "oct": "Oct",
    "nov": "Nov",
    "dec": "Dic",
    "Monday": "Lunes",
    "Tuesday": "Martes",
    "Wednesday": "Miércoles",
    "Thursday": "Jueves",
    "Friday": "Viernes",
    "Saturday": "Sábado",
    "Sunday": "Domingo",
    "alignleft": "Alinear a la izquierda",
    "aligncenter": "Alinear centrado",
    "alignright": "Alinear a la derecha",
    "aligntop": "Alinear arriba",
    "alignmiddle": "Alinear enmedio",
    "alignbottom": "Alinear abajo",
    "bringtofront": "Traer al frente",
    "sendtoback": "Enviar al fondo",
    "bringforward": "Traer adelante",
    "sendbackward": "Enviar detrás",
    "pinoff": "Contraer",
    "pinoptions": "Posicionar",
    "stickleft": "Mantener a la izquierda",
    "stickright": "Mantener a la derecha",
    "sticktop": "Mantener arriba",
    "stickbottom": "Mantener abajo",
    "managefields": "Administrar campos",
    "Formulas": "Fórmulas",
    "of": "de",
    "Untitled": "Sin título",
    "allboxes": "Todas los cuadros",
    "allmgr": "Todos los gerentes",
    "allassist": "Todos los asistentes",
    "allnonmgr": "Todos los no-gerentes",
    "allconn": "Todos los conectores",
    "Peers": "Compañeros",
    "Branch": "Rama",
    "boxsame": "Cuadros c/ mismo formato",
    "boxsimiliar": "Cuadros con/ formato similar",
    "textboxes": "Cuadros de texto",
    "textbox": "Cuadro de texto",
    "summary": "Resumen",
    "lockedboxes": "Cuadros bloqueados",
    "Clipboard": "Portapapeles",
    "Tools": "Herramientas",
    "Alignment": "Alineamiento",
    "Line": "Linea",
    "Chart": "Organigrama",
    "Editing": "Editar",
    "Page": "Página",
    "Document": "Documento",
    "Utilities": "Utilerías",
    "Data": "Data",
    "Missing": "Faltante",
    "Unzip": "Descompactar",
    "comparedirs": "Compare directorios",
    "compare": "Comparar",
    "rowscols": "Renglones y columnas",
    "Merge": "Combinar",
    "cellborder": "Borde de celda",
    "closeeditor": "Cerrar editor",
    "Views": "Vistas",
    "Navigation Sidebar": "Barra lateral de navegación",
    "Extras": "Extras",
    "Subcharts": "Suborganigramas",
    "comgr": "Gerentes adj",
    "createcomgr": "Crear grupo de gerentes adjuntos",
    "removecomgr": "Eliminar grupo de gerentes adjuntos",
    "datarefresh": "Actualización de datos",
    "Fields": "Campos",
    "Connectors": "Conectores",
    "Export": "Exportar",
    "refreshmsg": "Los cambios serán aplicados en la siguiente actualización de datoas.",
    "Web": "Web",
    "openfile": "Abrir organigrama",
    "saveas": "Guardar como",
    "saveas (short)": "Guardar como",
    "Auto-save": "Guardado auto.",
    "uploadfile": "Cargar/Descargar archivos",
    "selectimport": "Seleccionar archivo de datos a importar",
    "bsapply": "Estilo de cuadro a aplicar:",
    "notset": "<No definido>",
    "selectbs": "Seleccione un estilo de cuadro por favor",
    "selectboxprop": "Defina al menos una propiedad de cuadro por favor",
    "selectfieldprop": "Seleccione el campo y por lo menos una propiedad de campo",
    "ctloaderr": "Error al cargar las vistas de organigrama. Inténtalo de nuevo.",
    "helploaderr": "Error al cargar el archivo de ayuda. Por favor, intente de nuevo.",
    "bsloaderr": "Error al cargar los estilos de cuadro. Por favor, intente de nuevo.",
    "fileloaderr": "Error al cargar el archivo. Por favor, intente de nuevo.",
    "fileloaderr2": "No es posible cargar datos",
    "fileloaderr3": "Archivo inexistente o de formato inválido.",
    "accesserr1": "Usted no tiene permiso para abrir este archivo.",
    "unlinkerr1": "Elimine los suborganigramas antes de desvincular la rama.",
    "nameinuse": "El nombre ya existe en uso o está reservado.",
    "nameblank": "El nombre no puede estar blanco/vacío.",
    "Publisher": "Publicador",
    "Publish": "Publicar",
    "createpreview": "Creando previsualización...",
    "createxml": "Creando XML...",
    "createpdf": "Creando PDF...",
    "renderpdf": "Página de representación",
    "createsvg": "Creando SVG...",
    "Creating": "Creando",
    "Bkgrnd": "Fondo",
    "Crop": "Recortar",
    "Exit": "Salir",
    "Close": "Cerrar",
    "exporto": "Exportar a",
    "folderadderr": "No es posible agregar carpeta. Por favor, intente otra vez.",
    "permdel": "¿Está seguro de eliminar permanentemente los archivos seleccionados?",
    "deleteallmsg": "¿Está seguro de eliminar permanentemente todos los archivos dentro de esta carpeta?",
    "deleteallpermmsg": "¿Está seguro de que desea eliminar permanentemente {fileCount} archivos en la papelera?",
    "deleteerr": "No es posible eliminar los archivos seleccionados. Por favor, intente otra vez.",
    "deletefoldererr": "No es posible eliminar carpeta. Por favor, intente otra vez.",
    "deleteall": "Eliminar todos los archivos",
    "duperr": "No es posible duplicar los archivos seleccionados. Por favor, intente otra vez.",
    "moveerr": "No es posible mover todos los archivos seleccionados. Por favor, intente otra vez.",
    "filenotfound": "Archivo no encontrado. Por favor, ingrese un nombre de archive válido.",
    "saveerror": "Error al guardar archivo. Por favor, intente otra vez.",
    "uploaderror": "No es posible cargar el archivo. Por favor, intente otra vez.",
    "bssaveerror": "Error al guardar estilo de cuadro. Por favor, intente otra vez.",
    "bsreload1": "¿Está seguro de volver a cargar los estilos de cuadro?",
    "bsreload2": "Todos los cambios serán descartados.",
    "ctsaveerror": "Error al guardar las vistas del organigrama. Inténtelo de nuevo.",
    "ctreload1": "¿Está seguro de que desea volver a cargar sus vistas de organigrama?",
    "ctreload2": "Todos los cambios serán descartados.",
    "deletect": "¿Está seguro de que desea eliminar las vistas de organigrama seleccionadas?",
    "unziperr": "No es posible desempaquetar el archivo. Verifique el archivo zip e intente otra vez.",
    "unzipping": "Desempaquetando...",
    "optimizing": "Optimizando...",
    "copypuberr": "No es posible copiar salida a la carpeta seleccionada. Por favor, intente otra vez.",
    "copypubfolder": "Guardando a",
    "pubdest": "Seleccione destino de publicación",
    "savefolder": "Carpeta de cuenta",
    "nofolderselect": "No se ha seleccionado carpeta",
    "selectfolder": "Seleccione carpeta",
    "outwhat": "Salida qué",
    "replacemsg": "El archivo ya existe. ¿Desea reemplazarlo?",
    "delbsmsg1": "¿Está seguro de eliminar los estilos de cuadro seleccionados?",
    "delbsmsg2": "Advertencia: algunos estilos de cuadros son utilizados en vistas de organigrama",
    "delctmsg1": "¿Está seguro de que desea eliminar las vistas de organigrama seleccionadas?",
    "delviewmsg1": "¿Está seguro de eliminar las vistas seleccionadas?",
    "viewdeldmsg": "Las vistas seleccionadas han sido eliminadas. Por favor, contacte a su administrador del sistema.",
    "saveconfirm1": "¿Desea guardar los cambios de",
    "saveconfirm2": "¿?",
    "ql1": "Creación manual de nueva organigrama.",
    "ql2": "Abrir organigrama existente.",
    "ql3": "Descargar datos ejemplo en Excel.",
    "ql4": "Cargar un archivo Excel.",
    "ql5": "Ejecutar el asistente de importación.",
    "ql6": "Publicar la organigrama actual a PNG, SVG o PDF.",
    "ql7": "Ejecutar a través de los tutoriales.",
    "ql8": "Revisar los archivos ejemplo.",
    "ql9": "Revisar los videos 'Cómo hacer'.",
    "ql10": "Descargar la guía de inicio.",
    "Links": "Enlaces",
    "quicklinks": "Enlaces rápidos",
    "showql": "Mostrar enlaces rápidos después de firmarse",
    "freetrialtl1": "Su versión de prueba gratis tiene",
    "freetrialtl2": "restante.",
    "freetrial1": "Prueba gratis",
    "freetrial2": "Gracias por su evaluación",
    "freetrial4": "Su cuenta de prueba le permite importar hasta 1000 registros. Contáctenos en el caso de que necesite mayor capacidad de procesamiento.",
    "freetrial5": "Al final del periodo de prueba, se cambiarán los atributos de su cuenta a una de lectura exclusivamente y permanecerá activo el acceso a todos sus documentos.",
    "freetrial6": "No hay obligación para usted.",
    "quickstart": ">>>Haga clic aquí para abrir la guia de inicio rápido <<<",
    "freetrial4a": "le permite crear organigramas directamente desde ADP workforce now ó vantage.",
    "quickstarta": ">>> configure su conexión ADP <<<",
    "quickstartb": ">>> abrir la guía de inicio rápido <<<",
    "Day": "Día",
    "Days": "Días",
    "signout": "Desconexión",
    "Continue": "Continuar",
    "Purchase": "Compra",
    "acctdisable1": "Cuenta inhabilitada",
    "acctdisable2": "Su cuenta está inhabilitada.",
    "acctdisable3": "Por favor, envíe un email a",
    "acctdisable4": "si desea reactivar su cuenta.",
    "acctexpired1": "Periodo de prueba completo",
    "acctexpired2": "Gracias por su prueba",
    "acctexpired3": "Su periodo de prueba gratis está completo.",
    "acctexpired4": "Se han cambiado los atributos de su cuenta para lectura exclusivamente. El acceso a todos sus documentos permanece activo.",
    "msgpostlogin": "Mostrar este mensaje en mi próximo ingreso.",
    "oldpass": "Contraseña antigua",
    "newpass": "Nueva contraseña",
    "passinvalid": "Contraseña antigua invalida.",
    "passnomatch": "No coinciden las contraseñas.",
    "passmin": "La longitud mínima es",
    "passmin2": "caracteres",
    "passmsg": "La contraseña debe ser de al menos ",
    "passmsg2": "caracteres y debe contener un número, una letra mayúscula y un carácter especial (!#@*+?).",
    "newpassinvalid": "Nueva contraseña inválida.",
    "resetpass": "Por favor, reinicie la contraseña.",
    "photoqueue": "Cargando fotos",
    "reenteremail": "Ingrese email válido por favor.",
    "forgotpw": "Restablecer contraseña",
    "reqaccessacct": "Solicitar acceso a cuenta existente.",
    "requestaccess": "Solicitar acceso",
    "requestaccessmsg": "Contacte a su administrador si no encuentra la dirección de correo.",
    "needid": "Iniciar prueba gratuita",
    "welcometo": "Bienvenido a",
    "usernamet": "Ingrese nombre de usuario",
    "passwordt": "Ingrese contraseña",
    "autologon": "Iniciar sesión automáticamente",
    "Log in": "Iniciar sesión",
    "loginfail": "Inicio de sesión fallida. Por favor, intente otra vez.",
    "logintoomany": "Demasiados intentos de inicio de sesión. La cuenta ha sido bloqueda por 5 minutos.",
    "passexpired": "La contraseña ha expirado. Use el enlace de contraseña olvidada para restablecerla.",
    "acctexpired": "Subscripción expirada. Haga clic aquí para obtener detalles.",
    "pwemail": "Ingrese dirección de correo electrónico",
    "Reset Password": "Restablecer contraseña",
    "backlogin": "Regresar a pantalla de inicio de sesión",
    "resetpwsuccess": "Verifique su correo para obtener sus credenciales.",
    "resetpwfail": "No se pudo encontrar un usuario con esta dirección de correo electrónico. Contacte al administrador del sistema para obtener detalles de inicio de sesión.",
    "loaderr1": "El formato del archivo de datos es inválido.",
    "loaderr2": "El primer renglón del archivo de datos debe contener nombres de campos.",
    "loaderr2b": "El primer renglón del archivo de datos contiene un nombre de campos en blanco/vacío.",
    "loaderr2c": "Verificar columna",
    "loaderr3": "El campo 'ID' está reservado para uso interno y no puede ser usado como un nombre de campo.",
    "loaderr4a": "Los nombres de los campos deben ser únicos. El campo",
    "loaderr4b": "es usado en más de uno en el archivo de datos.",
    "loaderr4c": "está reservado por un cálculo predefinido. Por favor, cambie el nombre del campo en la fuente de datos.",
    "loaderr5": "El archivo no contiene ningún dato.",
    "loaderr6a": "Usted está limitado a importer un máximo de",
    "loaderr6b": "registros. Requiere de actualizar su cuenta para importar más registros.",
    "loaderr7": "El número de elementos de datos en un renglón debe de coincidir con el número de campos (Verifique renglón:",
    "loaderr8": "Faltan definiciones de campo.",
    "loaderr9": "Formato de fotografía inválido (convertir fotos a jpg).",
    "removebreaks": "Eliminar todos los cortes",
    "renamebreaks": "Renombrar los cortes",
    "renamesinglesc": "Renombrar seleccionados",
    "renameallsc": "Renombrar",
    "Letter": "Carta",
    "Legal": "Oficio",
    "Tabloid": "Tabloide",
    "A0": "A0",
    "A1": "A1",
    "A2": "A2",
    "A3": "A3",
    "A4": "A4",
    "namescusing": "Nombre usado en campo:",
    "nomaster": "Fondo en blanco",
    "currentmaster": "Fondo actual",
    "stdmaster": "Fondo estándar",
    "custommaster": "Fondo personalizado",
    "subchartwiz": "Asistente de suborganigramas",
    "selectcmasterIW": "Fondo",
    "selectcmasterSA": "Opciones de fondo",
    "advancedoptions": "Opciones avanzadas",
    "selectmasterfile": "Seleccionar fondo",
    "Change Password": "Cambiar contraseña",
    "companyname": "Nombre de compañía",
    "scarrowstyle": "Conectores suborganigrama",
    "datarefreshoptions": "Opciones de actualización de datos",
    "datarefreshinfo": "Actualizar la organigrama actual consultando la fuente de datos nuevamente.",
    "Refresh": "Actualizar",
    "entercompany": "Ingrese nombre de compañía",
    "enteraccessgroup": "Ingrese nombre de grupo de acceso",
    "accessgroup": "Grupo de acceso",
    "Access groups": "Grupos de acceso",
    "Manage users": "Gestionar usuarios",
    "UI profiles": "Perfiles de UI",
    "Chart management": "Gestion de organigramas",
    "nogroup": "No se ha seleccionado grupo",
    "orginfochgfail": "Actualización fallida,. Por favor, intente otra vez.",
    "Subchart": "Suborganigrama",
    "mpdoc": "No disponible. El documento actual es un fondo.",
    "selectmaster": "Los elementos del fondo aparecerán en todas las páginas de su organigrama.",
    "savemaster": "Fondo",
    "Update": "Actualizar",
    "manageusers": "Administrar usuarios",
    "reloadusers": "Nueva carga",
    "ufuserfeed": "Carpeta userFeed",
    "ufsystem": "Carpeta de sistema",
    "manageaccessgroups": "Administrar grupo de accesos",
    "managegroups": "Administrar grupos",
    "enableexporte": "Exportación a Excel habilitada",
    "searchdir": "Búsqueda",
    "orgprefs": "Preferencias",
    "sysadmin": "Administrador del sistema",
    "genlayout": "Generar diseño",
    "perfreport": "Registro de desempeño",
    "savewhat": "Guardar que",
    "currentbranch": "Rama actual",
    "orphanrecords": "Todos los regristros desconectados",
    "toporphans": "Ramas desconectadas",
    "entirechartplus": "Organigrama total (extendido)",
    "redeployed": "Sólo redespliegue",
    "headerrow": "Texto libre - 1 columna",
    "headerrow2": "Texto libre - 2 columnas",
    "groupfolders": "Carpetas",
    "useringroup": "los miembros del grupo pueden acceder a las carpetas:",
    "boxlayouteditor": "Editor de formato de cuadro",
    "Box Properties": "Propiedades de cuadro",
    "tableprops": "Editor de tabla",
    "legendprops": "Editor de leyenda",
    "SelectP": "Seleccionar...",
    "SortP": "Ordenar...",
    "OptionsP": "Opciones...",
    "RestrictP": "Restringir...",
    "restrictblank": "La lista no puede estar vacía",
    "agroupnamemin": "El nombre del grupo de acceso no puede estar en blanco.",
    "agroupnameused": "El nombre del grupo de acceso debe ser único.",
    "agroupnofolders": "El grupo de acceso contiene todas las carpetas.",
    "agroupdirerr": "Transacción fallida (GROUPDIRFAIL).",
    "fullaccess": "Acceso total",
    "orgnamemin": "El nombre de la compañía no puede estar en blanco/vacío.",
    "changeimportfile": "Seleccionar fuente de datos",
    "currentimportfile": "Importar datos desde:",
    "rpdatasource": "Datos",
    "rpfilter": "Filtrar datos",
    "rpreqfields": "Definir campos",
    "rpassistwiz": "Asistentes",
    "rpsubcharts": "Suborganigramas",
    "rptemplate": "Vista de organigrama.",
    "rpmaster": "Fondo",
    "rpadvoptions": "Avanzadas",
    "refreshnow": "Actualizar datos ahora",
    "loading": "[1] cargando...",
    "buildingchart": "[2] cargando...",
    "saving": "[1] guardando...",
    "saving2": "[2] guardando...",
    "retrievingkey": "Obteniendo claves...",
    "retrievingdata": "Obteniendo datos...",
    "loadingdata": "Cargando datos...",
    "creatingchart": "Creando organigrama...",
    "smartstartlevel": "Iniciar cortes en:",
    "nomatches": "No se encontraron coincidencias.",
    "onematch": "1 coincidencia encontrada.",
    "matchesfound": "coincidencias encontradas.",
    "nowrap": "Ajuste de texto desactivado",
    "oneline": "Limitado a 1 línea",
    "twolines": "Limitado a 2 líneas",
    "threelines": "Limitado a 3 líneas",
    "fourlines": "Limitado a 4 líneas",
    "unlimited": "Ajuste de texto ilimitado",
    "freetext": "Texto libre",
    "fieldcompblank": "Los campos y comparaciones no pueden estan en blanco/vaciós.",
    "cursubchart": "Suborganigrama actual",
    "currentpage": "Página actual",
    "autoself": "Auto (Propio)",
    "autosmart": "Auto (Inteligente)",
    "selectimagefile": "Seleccionar imagen",
    "comparecurfile": "Seleccionar archivo de comparación",
    "action": "Acción",
    "validfile": "Por favor, seleccione un tipo de archivo válido.",
    "maxfilesize": "El tamaño máximo de archivo es:",
    "maximagesize": "El tamaño máximo para archivo de imagen es 1MB.",
    "fieldtype": "Tipo de campo",
    "fieldlabel": "Etiqueta de campo",
    "decimalplaces": "Dígitos decimales",
    "Text": "Texto",
    "Number": "Número",
    "Date": "Fecha",
    "RefText": "Resumen",
    "Photo": "Foto",
    "textwrapchars": "Dividir organigramas",
    "Performance": "Desempeño",
    "Potential": "Potencial",
    "ninebox": "Cuadro de nueve",
    "Blank": "Vacío",
    "Null - Not configured": "Null - Sin configurar",
    "Link Type": "Tipo de enlace",
    "nobreakstoomany": "No insertar divisiones (Deshabilitado – demasiados registros)",
    "removebreakstoomany": "Eliminar todas las divisiones (Deshabilitado – demasiados registros)",
    "Match": "Asociar",
    "Build": "Construir",
    "Matches": "Asociaciones",
    "clearsearch": "Limpar",
    "selfsubs": "Gerente + subordinados",
    "subsonly": "Subordinados",
    "selfdirreports": "Gerente + reportes directos",
    "dirreports": "Reportes directos",
    "Range": "Rango",
    "clearprops": "Limpiar propiedades",
    "useradderr": "ID de usuario en uso. Por favor, intente con otro ID.",
    "maxseats": "Todos los usuarios de lectura/escritura están en uso.",
    "readonlyuser": "Usuario de sólo lectura",
    "readwriteuser": "Usuario de lectura/Escritura",
    "readonly": "Sólo lectura",
    "readwrite": "Lectura/Escritura",
    "adminuser": "Administrador",
    "logindisabled": "Ingreso deshabilitado",
    "privatefolder": "Agregar carpeta privada",
    "deleteself": "El usuario actual no puede ser eliminado.",
    "disablecuruser": "Usted no puede desactivar su propia cuenta.",
    "curusersysadmin": "El tipo de usuario no puede ser modificado por el usuario actual.",
    "curuserchgid": "El ID de su usuario actual no puede ser cambiado.",
    "deluserserr": "Transacción fallida. Por favor, intente nuevamente (USERDELFAIL).",
    "userlisterr": "Transacción fallida. (USERLISTFAIL).",
    "grouplisterr": "Transacción fallida. (GROUPLISTFAIL).",
    "groupupdateerr": "Transacción fallida. (GROUPUPDATEFAIL).",
    "applyingtemplate": "Aplicando vista…",
    "buildinghierarchy": "Construyendo jerarquía...",
    "API": "API",
    "apikey": "Clave API",
    "orgname": "Nombre org",
    "username": "Nombre de usuario",
    "mobile": "Móvil (Opcional)",
    "userid": "ID de usuario",
    "Email address": "Email",
    "Email": "Email",
    "skype": "Skype",
    "phone": "teléfono",
    "file2": "Archivo",
    "validuserid": "El ID de usuario requiere 6 caracteres mínimo.",
    "initialpass": "Contraseña inicial",
    "docopy": "Copiar texto",
    "doemail": "Enviar email",
    "docall": "Hablar por teléfono",
    "doskype": "Hablar por skype",
    "dohyperlink": "Abrir enlace",
    "dofile": "Abrir archivo",
    "seatsused": "usuarios disponibles de lectura/escritura utilizados.",
    "Password": "Contraseña",
    "Output": "Salida",
    "Share": "Compartir",
    "prefix": "Prefijo",
    "postfix": "Sufijo",
    "percentage": "Porcentaje",
    "thousandssep": "Use separador 1000",
    "hyperlink": "Hipervínculo",
    "notlinked": "-",
    "oldInternetExplorer": "Se ha detectado internet explorer 9. Por favor actualice a una versión más reciente de internet explorer o intente usar Google chrome.",
    "replacefile": "Existe un archivo actualmente con el mismo nombre en la carpeta actual. Haga clic en OK para reemplazar el archivo.",
    "sortorder": "Orden",
    "sortfield": "Ordenar campo",
    "Ascending": "Ascendente",
    "Descending": "Descendente",
    "Sort": "Ordenar",
    "sortselection": "Selección",
    "sortsubchart": "Suborganigrama actual",
    "sortchart": "Organigrama total",
    "blankselection": "Imposible ordenar. Seleccione por lo menos una cuadro.",
    "applyto": "Aplicar a:",
    "addcoheadscb": "Crear organigrama con múltiples cabezas",
    "sortboxescb": "Ordenar cuadros después de actualización",
    "includereftbl": "Usar tabla de referencia",
    "refinvalid": "Invalida",
    "refnotfound": "No encontrada",
    "refnotconfig": "No configurada",
    "refcirc": "Referencia circular",
    "invaliddate": "INVALIDA",
    "appenddata": "Añadir datos",
    "restrictcb": "Restringir consulta",
    "compoundcb": "Crear documento multi-organigrama",
    "topboxcb": "Especificar cuadro superior",
    "entertopbox": "Ingrese una lista de los ID de los cuadros superiores separadas por coma",
    "topboxmin": "El cuadro superior no puede estar en blanco/vacía.",
    "spliton": "Dividir usando",
    "Division": "División",
    "splitaltkey": "Clave alterna",
    "connmsg1": "Email",
    "connmsg2": "para ayuda configurando conectores.",
    "English": "Inglés",
    "French": "Francés",
    "Spanish": "Español",
    "German": "Alemán",
    "rows": "renglones",
    "authenticating": "Autenticando...",
    "preservebs": "Mantener cambios manuales a estimos de rama",
    "preservebo": "Mantener ordenamiento de cuadros (sobreescribir ordenamiento despúes de actualización)",
    "preservesb": "Mantener cambios de usuario a la paginación (corte de suborganigramas)",
    "preserveassist": "Mantener identificación manual de asistentes",
    "preservebl": "Mantener cambios manuales a la presentación de los cuadros (diseño de cuadros)",
    "selectedtemp": "Vista de organigrama seleccionada",
    "refreshwarning1a": "Precaución:",
    "refreshwarning1b": "Esta opcion no es recomendada para organigramas de 100 cuadros o más. Utilice formato condicional (vistas de organigrama) o bloqueo de cuadro.",
    "testauth": "Prueba autentic.",
    "dateformat": "Formato de fecha",
    "commit": "Envío",
    "accessprivs": "Privilegio de acceso",
    "restrictaccess": "Acceso restringido al documento actual",
    "uploadaccess": "Cargar privilegios nuevos",
    "downloadaccess": "Descargar priv. Act.",
    "validaccesspriv": "Privilegios de acceso cargados exitosamente.",
    "invalidaccesspriv1": "Error – archivo vacío.",
    "invalidaccesspriv2": "Error – línea de verificación:",
    "invalidaccesspriv3": "Error – encabezado inválido.",
    "twocolortri": "Triangulo de dos colores",
    "setcolor": "Definir color",
    "setlabel": "Definir etiqueta",
    "setdashed": "Definir línea punteada",
    "worker": "Worker (Workforce now)",
    "workerdemo": "Worker-Demographics (Vantage)",
    "xmlformat": "Formato XML",
    "pdftype": "PDF",
    "ppttype": "PPT",
    "boxcount": "Conteo de cuadros",
    "seatcount": "Conteo de usuarios:",
    "userlookup": "Búsqueda usuarios:",
    "expiredate": "Fecha de expiración:",
    "serverinfo": "Información de servidor:",
    "accounttype": "Tipo de cuenta:",
    "source": "Origen:",
    "connector": "Conector:",
    "channel": "Canal:",
    "country": "País:",
    "startdate": "Fecha inicio:",
    "keycontact": "Contactos clave:",
    "contactemail": "Email contacto:",
    "notes": "Notas:",
    "term": "Término:",
    "LookupU": "Búsqueda",
    "LookupR": "Resultados de búsqueda",
    "svrsummary": "Reporte de ocupantes",
    "trialstart": "Inicio de prueba:",
    "invaliddatemsg": "Fecha inválida",
    "triallen": "Duración periodo prueba (dd):",
    "orginfo": "Actualización de cuenta exitosa.",
    "userinfo": "Actualización de información de usuario exitosa. Los cambios se aplicarán en su próximo ingreso.",
    "missingmissing": "El directorio de fotos no contiene el archive missing.jpg.",
    "maxmsg": "Selec campos p/función max.",
    "minmsg": "Selec campos p/función min.",
    "scalingOptions": "Ajuste",
    "loadingpages": "Cargando página",
    "generatepdf": "Descargando PDF",
    "downexcel": "Preparando Excel...",
    "reload": "Recargar",
    "enableaccesslist": "Habilitar seguridad a nivel-renglón",
    "dynloading": "Construyendo org...",
    "scaleh": "Altura escala %",
    "scalew": "Ancho escala %",
    "maintainaspect": "Mantener aspecto",
    "Set Aspect Ratio": "Configurar aspecto",
    "freeaspect": "Liberar - mantener aspecto",
    "scalehorz": "Ajustar a tamaño pág. (horizontal)",
    "scalevert": "Ajustar a tamaño pág. (vertical)",
    "scalefill": "Ajustar a página completa",
    "setposition": "Posición a la izquierda",
    "workerrun": "Ejecutar ADP",
    "deployment": "Despliegue:",
    "orginfo2": "Inf. org:",
    "userinfo2": "Inf. usuario:",
    "accountdetails": "Actualización detalles de cuenta exitosa.",
    "acctdetails": "detalles de la cuenta",
    "ruledriven": "Organigrama basada en regla (no conserva los cambios manuales)",
    "section508": "Sección 508",
    "excelsubs": "Subordinados",
    "excelmgr": "Gerente",
    "querydata": "Consulta",
    "Branch Style": "Estilo rama",
    "alllevels": "Todos niveles",
    "setascomgr": "Establecer como gte-adjunto",
    "createppt": "Creando PPT...",
    "generateppt": "Descargando PPT",
    "outoptions": "Tamaño diapos.",
    "standardppt": "Estándar (4:3)",
    "widescreenppt": "Panorámica (16:9)",
    "publimit1": "¿Está seguro de querer publicar",
    "publimit2": "¿páginas?",
    "retrieveuser": "Recuperar nombre de usuario",
    "enabledittemp1": "Actualizar vistas de organigrama y estilos de cuadro",
    "enabledittemp2": "",
    "orgchartbuild": "Creador de organigrama OrgChart",
    "querybuildsetuperr": "OrgChart builder no está configurado. Contacte a soporte técnico.",
    "querybuilddataerr": "No se pudo cargar su organigrama. ",
    "queryoptions": "Opciones de consulta",
    "displayoptions": "Opciones de visualización",
    "filteroptions": "Opciones filtros",
    "subchartoptions": "Insertar divisiones",
    "Page size": "Tamaño de página",
    "pagebreaks": "Cortes de página",
    "singlepage": "Organigrama de página única",
    "multipage": "Insertar cortes de páginas",
    "queryresults": "Posición destino",
    "queryblank": "Destino no especificado",
    "f_name": "Nombre",
    "l_name": "Apellido",
    "s_title": "Título",
    "noqueryresults": "Consulta sin coincidencias.",
    "unknownqerr": "Error desconocido. Contacte a soporte técnico si persisten los problemas.",
    "querytoomanyresults": "Demasiados resultados.",
    "includelevels": "Incluír",
    "buildchart": "Ir",
    "None": "Ninguno",
    "hidemaster": "Ocultar elementos de fondo",
    "customexcel": "Personalizado...",
    "dynmsg1": "[1] obteniendo datos...",
    "dynmsg2": "[2] procesando datos...",
    "dynmsg3": "[3] construyendo organigrama...",
    "Session Timeout": "Expiró sesión",
    "reloadpic": "Vuelva a cargar foto",
    "lefttriangle": "Triángulo izquierda",
    "printpdf": "Optimizar para impresión",
    "screenpdf": "Optimizar para pantalla",
    "excludebackgrnd": "Fondo blanco",
    "leftassist": "Asistente izquierdo",
    "rightassist": "Asistente derecho",
    "leftpassist": "Colega asistente izquierdo",
    "rightpassist": "Colega asistente izquierdo",
    "passreuse": "La contraseña no puede ser reutilizada.",
    "querytoomanyresults4": "Límite de organigrama de página única excedido.",
    "querytoomanyresults3": "Tamaño máximo de organigrama excedido.",
    "chainofcommand": "Cadena de mando",
    "svrchart": "Mi organigrama",
    "PLAN": "PLAN",
    "wplan": "Planificación de la fuerza de trabajo",
    "wplantools": "Herramientas de planificación",
    "Manage": "Gestionar",
    "includefiltered": "Incluir gerentes filtrados",
    "merge": "Combinar",
    "Track": "Seguir",
    "tmoved": "Cuadro movido",
    "tadded": "Cuadro agregado",
    "tdelete": "Cuadro eliminado",
    "tupdated": "Cuadro actualizado",
    "tmoveupdate": "Cuadro movido y actualizado",
    "webpublish": "Publicación web",
    "freetrial4b": "Llamar al +1-415-462-1313 para ayuda o solicitar una demo.",
    "quickstartc": ">>> envíenos por email sus dudas",
    "adphelpemail": "Prueba gratuita asistente de conector ADP",
    "servercharterr": "La función mi organigrama no esta configurada. Contacte soporte técnico para siguientes pasos.",
    "serverqueryerr": "Error en búsqueda. Contacte soporte técnico si el problema persiste.",
    "searching": "Buscando...",
    "pagelimit": "Límite de consulta excedido!",
    "mergecurfile": "Seleccione archivo para combinar",
    "applymaster": "Aplicar fondo",
    "orgname2": "Nombre legal:",
    "usersummary": "Infore de usuario",
    "pngstdquality": "Calidad estándar",
    "pnghiquality": "Alta calidad",
    "validated": "Validado",
    "testlink": "Probar enlace",
    "TestLinkTokenError": "No se puede probar este enlace en este momento. Vuelva a intentarlo.",
    "genlink": "General enlace",
    "copylink": "Copiar enlace",
    "publiclink": "Enlace público",
    "privatelink": "Enlace privado",
    "restrictedlink": "Enlace restringido",
    "onlaunch": "En lanzamiento:",
    "takenoaction": "No tomar acción",
    "openmychart": "Obrir 'Mi organigrama",
    "portal": "Portal",
    "iframe": "iFrame",
    "presentation": "Presentación",
    "showprofpanel": "Mostrar panel perfil",
    "showscpanel": "Mostrar panel suborganigrama",
    "enablemw": "Habilitar rueda ratón",
    "startpoint": "Punto inicio",
    "Additional parameters": "Parámetros adicionales",
    "togglesaml": "Habilidar enlace SAML",
    "entityid": "ID entidad:",
    "Result": "Resultado",
    "confidential": "Confidencial - sólo uso interno",
    "orgchart": "OrgChart",
    "croptochart": "Ajustar a organigrama",
    "transbk": "Fondo transparente",
    "Filters": "Filtros",
    "stayconnected": "Permanecer conectado",
    "commalerts": "Alertas",
    "ReleaseNotesLink": "Versiones",
    "Newsletters": "Noticias",
    "onCommSet": "Notificarme acerca de los próximos lanzamientos, nuevas funciones y anuncios de OrgChart",
    "offCommSet": "No me notifique sobre próximas actualizaciones, cambios y anuncios de productos.",
    "commDialogueMessage": "Preferencias de notificaciones email",
    "autobreaks": "Cortes automáticos",
    "sumif": "SUMIF",
    "averageif": "AVERAGEIF",
    "sumifdesc": "Sumar sólo si el registro cumple con el criterio definido.",
    "averageifdesc": "Promediar sólo si el registro cumple con el criterio definido.",
    "pagedensity": "Densidad de página:",
    "pagedense": "Denso",
    "pagestandard": "Estándard",
    "pageverydense": "Muy denso",
    "testpanel": "Panel de prueba",
    "dirtyfilter": "Organigrama modificada por usuario. ¿Descartar cambios?",
    "domgraction": "Acciones de gerente",
    "doprofile": "Perfil de empleado",
    "usage": "Usa:",
    "ActivityR": "Informe de actividades",
    "Actions": "Acciones",
    "includebkgrndcolor": "Establecer color de fondo",
    "defsubfilter": "Editar regla subordinada...",
    "refreshtime": "Actualizar fecha y hora",
    "profloaderr": "No es posible de cargar perfil. Intente nuevamente.",
    "profsaveerr": "No es posible de crear perfil. Intente nuevamente.",
    "profload": "Perfil cargado.",
    "profsave": "Perfil guardado.",
    "enablelimitaccess": "Habilitar seguridad a nivel de sucursal",
    "savingprofile": "Guardando perfil...",
    "loadingprofile": "Cargando perfil...",
    "aboxcount": "Conteo de cuadros permitido:",
    "ats": "ATS:",
    "edition": "Edición:",
    "profilesavepanel": "Guardar perfil",
    "sandboxupdate": "La cuenta de entorno de pruebas fue restablecida correctamente.",
    "saveconf": "¿Está seguro de salir? Usted puede perder cualquier cambio no guardado.",
    "benchtoviewer": "VISOR",
    "Shortcuts": "Atajos",
    "tab": "Petaña inicial:",
    "enablefilemgr": "Habilitar administrador de archivos",
    "enableexcel": "Habilitar exportación Excel",
    "enablepublish": "Habilitar publicación",
    "More": "Mas",
    "newchart": "Nuevo organigrama",
    "Dynamic Navigation": "Flechas de navegación",
    "Background Publish": "Publicación en segundo plano",
    "Zoom": "Ampliar/reducir",
    "OrgChart Workbench": "MesaTrabajo OrgChart",
    "Open Existing Chart": "Abrir organigrama existente",
    "Default Template": "Vista predeterminada",
    "Theme": "Tema",
    "Measurements": "Medidas",
    "SI": "SI",
    "Enable Right-Click": "Habilitar clic-Derecho",
    "Mouse wheel": "Rueda de ratón",
    "More Options": "Más opciones",
    "Size": "Tamaño",
    "Fit to Screen": "Ajustar a la pantalla",
    "Size for Printing": "Tamaño para impresión",
    "Scope": "Alcance",
    "Include Master": "Incluir fondo",
    "Default view": "Vista por defecto",
    "Support": "Soporte",
    "View": "Vista",
    "Help Resources": "Recursos de ayuda",
    "Terms of Service": "Términos de servicio",
    "paywalldropdown": "Actualizar para habilitar-Funciones Premium",
    "paywallhover": "Funcionalidad Premium",
    "Off": "Apagado",
    "zoom": "Ampliar/reducir",
    "vscroll": "Desplazar (Arriba/Abajo)",
    "hscroll": "Desplazar (Izquierda/Derecha)",
    "function": "Función",
    "supportfunction": "Función de apoyo",
    "placeholdercb": "Organigrama funcional",
    "adpadvopt": "Perfil ADP:",
    "adprefropt": "Perfil ADP seleccionado:",
    "iwizselectAPDmsg1": "El asistente de importación crea automáticamente un organigrama usando una conexión directa a ADP workforce now o cuenta ADP vantage.",
    "iwizselectAPDmsg2": "Haga clic en ? para obtener información de cómo configurar su conexión ADP .",
    "valueSelect": "Seleccione un(a)",
    "fieldSelect": "Seleccione un campo",
    "addval": "Agregar valor",
    "selectadpprofile": "Importar datos desde ADP",
    "noFilterName": "Por favor ingrese un nombre de filtro.",
    "delfltrwmsg1": "¿Está usted seguro de eliminar el filtro selecionado?",
    "Recent Target Positions": "Posiciones superiores recientes",
    "sysutilities": "Herramientas:",
    "source2": "Selecione origen",
    "notSelected": "Por favor seleccione un origen.",
    "sandboxtool": "Cuenta sandbox:",
    "expirytool": "Informe de subscripcion:",
    "expirybutton": "Descarga",
    "Show fields": "Mostrar campos",
    "Show source": "Mostrar fuente",
    "moreviews": "Gestionar vistas...",
    "Manage Profile": "Gestionar perfil...",
    "Manage Filters": "Gestionar filtros...",
    "Chart Background": "Fondo de organigrama",
    "Print Current Screen": "Imprimir pantalla actual",
    "filterinvalid": "Regla de filtro inválida",
    "filtervalid": "Regla de filtro válida",
    "valuedefvalid": "Valor de campo válido",
    "valuedefinvalid": "Valor inválido de campo: el campo no existe.",
    "upgradepremiumemail": "Actualizar a OrgChart Premium",
    "ADPKeyFailure": "Fallo obteniendo llaves ADP. Asegúrese de que la autorizacion se ha provisto en ADP marketplace.",
    "isolvedKeyFailure": "Aún no hay datos de empleados de isolved disponibles. Es posible que deba esperar hasta su próxima sincronización de empleados. Contacte con el soporte si vuelve a ocurrir.",
    "Print Preview": "Vista previa de impresión",
    "resettocheckpoint": "Restaurar punto de control actual",
    "Type": "Tipo",
    "Advanced Search Keys": "Campos de búsqueda avanzada",
    "Search record": "Buscar en registro",
    "Mapping": "mapeo",
    "Configuration Settings": "Configuraciones",
    "Configuration": "Configuración",
    "CSVRefreshFailure": "No se pueden cargar los datos CSV. Asegúrese de que el campo está en el directorio especificado.",
    "autoposition": "Ejecutar a cuadro de organigrama propio",
    "setChartDefault": "Establecer organigrama como predeterminada",
    "dumpMetadata": "Crear nuevo punto de control",
    "loadMetadata": "Cargar a punto de control",
    "Add Access Group": "Agregar grupo de acceso",
    "Login mode": "Modo de registro",
    "addparams": "Parámetros",
    "Launch Workbench": "Banco de trabajo OrgChart",
    "launchmode": "Modo lanzamiento",
    "RefreshConfirm": "¿Está seguro que desea actualizar esta organigrama desde la fuente de datos?",
    "language": "Lenguaje",
    "AddNewChartDBConfig": "¿Desea agregar nuevas organigramas desde su archivo de metadatos?",
    "deleteChart": "Eliminar organigrama",
    "deleteConfirm": "¿Está usted seguro de eliminar esta organigrama?",
    "My Settings": "Mis configuración",
    "Chart Settings": "Configuración de organigrama",
    "Account Settings": "Configuración de cuenta",
    "Time Format": "Formato de tiempo",
    "Chart Builder Masters": "Fondos del generador de organigramas",
    "Chart Info": "Acerca de este organigrama...",
    "Current Screen": "Pantalla actual",
    "Alert": "Alerta",
    "Chart Template Missing": "La vista de organigrama de la vista seleccionada no está disponible. Póngase en contacto con el administrador del sistema para solucionarlo.",
    "Checkpoints": "Puntos de control",
    "refreshdata": "Actualizar datos",
    "paywalldropdownGeneral": "Funciones premium-No habilitadas",
    "Security": "Seguridad",
    "Chart Builder": "Creador de organigrama",
    "Data Refresh Successful!": "Actualización de datos exitosa!",
    "Font Face": "El tipo de letra",
    "7029": "Comando no reconocido. Por favor, actualice su navegador, o contacte a soporte al cliente si el problema persiste.",
    "2016": "Fallo en procesamiento previo",
    "0503": "El permiso del registro del cliente no esta disponible. Contacte a su representante ADP.",
    "0429": "Demasiadas solicitudes. Por favor intente nuevamente en un par de minutos.",
    "0400": "La API ha devuelto un error de permisos o autenticación. Compruebe la configuración de su conexión.",
    "Get started with OrgChart Premium!": "¡Comience con OrgChart Premium!",
    "basicROPaywall": `Su función de ADP no le permite realizar compras en ADP Marketplace. Para realizar la compra, comuníquese con su administrador de ADP Workforce Now. Para obtener más información, envíe un correo electrónico a ${supportEmailaddr} o llame al 1.415.462.1313.`,
    "basicAdminPaywall": `Para comprar OrgChart Premium, visite ADP Marketplace o, para obtener más información, envíe un correo electrónico a ${supportEmailaddr} o llame al 1.415.462.1313.`,
    "basicPaywallExcl": `OrgChart Premium aún no está disponible en su región. Para obtener más información, envíe un correo electrónico a ${supportEmailaddr} o llame al 1.415.462.1313.`,
    "basicPaywallLegacy": `Ya está suscrito a una versión anterior de OrgChart. Envíe un correo electrónico a ${supportEmailaddr} o llame al 1.415.462.1313 para cambiar a OrgChart Premium.`,
    "group": "Grupo",
    "about": "Acerca",
    "selectpersonid": "Entrada de ID persona",
    "concatinvalid": "Regla invalida.",
    "validmongouserid": "Mínimo 3 caracteres para el ID de usuario.",
    "invalidrange": "Rango de fecha inválido",
    "Container": "Contenedor",
    "Enterit": "Ingrese un(a)",
    "createuiprofile": "Nuevo perfil de IU",
    "scarrowstyles": "Estilo de flecha de suborganigrama",
    "Set Font Color": "Establecer color de fuente",
    "mymap": "Mi mapa",
    "Include Active on Leave": "Incluir activo en licencia",
    "occtext": "Puesto",
    "canEditTemps": "Editar vistas y estilos de cuadros",
    "Load": "Carga",
    "archivefail": "Error de solicitud de archivo",
    "exportnotfound": "Archivo no encontrado para la fecha especificada.",
    "exportfailure": "Exportación de archivo fallida",
    "exportfullaccessonly": "La exportación del archivo solo está disponible para usuarios con acceso completo a este organigrama.",
    "Grid": "Cuadrícula",
    "appinfo": "Información de aplicación",
    "Filters Applied": "Filtros aplicados",
    "uiprofile": "Nombre de perfil",
    "adpoid": "OID ADP",
    "Box Shape": "Forma de cuadro",
    "Formula": "Fórmula",
    "ADPKeyFailurePremium": "OrgChart Premium necesita de su consentimiento antes de que podamos cargar sus datos de RRHH. Haga clic en el siguiente enlace para dar su aprobación. Después de proporcionar el consentimiento, haga clic en el botón reintentar para empezar a utilizar OrgChart.",
    "buildpit": "Crear desde el archivo",
    "Filter values": "Valores de filtro",
    "Point In Time": "Punto en el tiempo",
    "Point in time": "Punto en el tiempo",
    "containstext": "Ingrese texto",
    "copymessage": "Copiado",
    "onecolCR": "Una columna central a la derecha",
    "shape": "Forma",
    "adminuser2": "Administrador",
    "filemgrfolder": "carpeta",
    "Fields & Formulas": "Campos y fórmulas",
    "customFontCmd": "Nombre de la fuente",
    "Set Fill Color": "Establecer color de relleno",
    "nosearchresults": "Ningún elemento coincide con su búsqueda",
    "Link": "Enlace",
    "dataresetinprogress": "Reinicio de datos",
    "deltaconfig": "Notificaciones de reporte delta",
    "Select a date range for your report": "Seleccione un rango de fechas para su reporte",
    "automatic": "Automático",
    "Authentication": "Autenticación",
    "Applied From": "Aplicado desde",
    "Load Charts": "Cargar organigramas",
    "Never": "Nunca",
    "defaultchartlevels": "Niveles predeterminados de la organigrama",
    "Fields Included": "Campos incluidos",
    "generalchartbuilder": "Configuraciones generales del creador de organigramas",
    "Presentation Options": "Presentación",
    "UI Colors": "Colores de IU",
    "expiredSession": "Sesión expirada. Por favor, ingrese nuevamente.",
    "usertype": "Tipo de usuario",
    "ssofail": "Autenticación única falló. Haga clic aquí para más información",
    "General": "General",
    "enterhighlight": "Ingrese la regla de resaltado aquí",
    "mrbprops": "Propiedades de grupo",
    "AddNew": "Añadir nuevo",
    "Chart Name": "Nombre del organigrama",
    "Company Name": "Nombre de la compañía",
    "Highlight": "Resaltado",
    "highlight": "resaltado",
    "Browser": "Navegador",
    "addfields": "Añadir campos",
    "savescheduler": "Debe guardar este organigrama antes de activar el programador de actualización",
    "Refreshing": "Actualizar",
    "Highlights": "Resaltados",
    "viewerdatafilters": "Filtros de importación",
    "configerror": "ERROR DE CONFIGURACIÓN",
    "CopyChartDBConfig": "¿Desea copiar una configuración de organigramas existente?",
    "unitID": "ID de unidad organizativa",
    "Levels Shown": "Niveles mostrados",
    "invalidconcatfield": "Regla invalida. Una o más referencias a los campos no se encontraron",
    "Too many matches Expand your search to narrow the results": "Demasiadas coincidencias. Acote su búsqueda.",
    "Box Sorting": "Ordenación de cuadros",
    "Border Color": "Color de borde",
    "Headers": "Encabezados",
    "status": "Estado:",
    "using": "usando",
    "archivenotfound": "Archivo no encontrado para la fecha especificada.",
    "deltafailure": "Generación de reporte delta no exitosa",
    "Basic Math": "Matemáticas básicas",
    "resetcharts": "En blanco",
    "Self": "Uno mismo",
    "Description": "Descripción",
    "showvalues": "Mostrar valores",
    "selectsupervisorid": "Entrada de ID de supervisor",
    "Calculation": "Cálculo",
    "reenteremailviewer": "Mínimo 4 caracteres para el correo",
    "Launch File": "Ejecutar archivo",
    "acctdetails2": "Detalles de la cuenta",
    "return": "Intro",
    "Format": "Formato",
    "Master Page": "Fondo",
    "allgroups": "Todas los cuadros agrupados",
    "Hide Field": "Ocultar campo",
    "seed": "Descendientes (Límite a rama)",
    "clocktime": "Reloj de 24 horas",
    "launchto": "Ejecutar a",
    "folderempty": "Esta carpeta está vacía.",
    "Border Style": "Estilo de borde",
    "filterinuse": "Nombre de filtro ya se encuentra en uso",
    "nofoldersexist": "No existen carpetas",
    "rowsecnocharts": "Ningún organigrama ha sido cargado. Añada un organigrama para configurar las reglas de seguridad.",
    "dataoptions": "Opciones de datos",
    "dataresetconfirm": "¿Está seguro de que desea reiniciar los datos de los organigramas? Cualquier cambio hecho antes de este punto se perderá.",
    "Predefined": "Predeterminado",
    "grouptype3": "Grupo de gerente adjunto",
    "GroupName": "Grupo:",
    "Values": "Valores",
    "formulaerrnoname": "El nombre no puede quedar en blanco.",
    "OrgID": "OrgID",
    "seattype": "Tipo de asiento",
    "Merge Data": "Combinar datos",
    "UserID": "ID de usuario",
    "Archived Charts": "Archivo",
    "copyall": "Todo",
    "on": "Encendido",
    "accessgroups": "Grupos de acceso",
    "loadeddate": "Archivo actualmente cargado",
    "invalidaccountdate": "Formato de fecha invalido. Favor de utilizar el formato 'yyyy-mm-dd'",
    "Input": "Entrada",
    "Application": "Aplicación",
    "Search & Directory": "Directorio y búsqueda",
    "SecurityRules": "Reglas de seguridad",
    "users": "usuarios",
    "addfolders": "Añadir carpetas",
    "Filter": "Filtros",
    "allowallfolders": "Haga clic en (+) para permitir el acceso a la carpeta",
    "uploadinprogress": "Cargando archivo…",
    "Groups": "Grupos",
    "Limit to single row": "Limitar a una sola fila",
    "You do not have permission to view this chart": "Usted no cuenta con permiso para ver este organigrama.",
    "Group Configuration": "Configuración de accesos de grupo",
    "Branch Security": "Seguridad de rama",
    "downloadprep": "Preparando descarga…",
    "Auto Apply": "Aplicar automáticamente",
    "Operations": "Operaciones",
    "Fast Select": "Selección rápida",
    "LookUp": "Consultar",
    "defaultgroupname": "Ingrese el nombre de grupo",
    "Limit Fields": "Restringir la consulta a los campos",
    "Condition": "Condición",
    "Checkpoint": "Punto de control",
    "noitems": "Ningún elemento coincide con su búsqueda",
    "copymessage2": "al portapapeles",
    "noemailwarning": "¡Advertencia! Los usuarios requieren un correo electrónico para iniciar sesión. ¿Está seguro de que desea guardar los cambios?",
    "boxlimit": "Límite de cuadro:",
    "Lookup": "Consultar",
    "Rule Configuration": "Configuración de regla:",
    "Saved Filters": "Filtros guardados",
    "Additional fields": "Campos adicionales",
    "Concatenate": "Concatenar",
    "Container Box Style": "Estilo de cuadro contenedora",
    "enterfilter": "Ingrese la regla de filtros aquí",
    "Author": "Autor",
    "No Rule": "Sin regla",
    "Find": "Encontrar",
    "Background": "Fondo",
    "Backgrounds": "Fondos",
    "Masters": "Fondos",
    "usernameupdatefail": "No se puede cambiar el nombre de este usuario.",
    "alternatetitle": "Título alterno",
    "highlightinuse": "Nombre del resaltado ya se encuentra en uso",
    "selectuser": "Entrada de usuario de servicio",
    "totalusers": "total de usuarios.",
    "Server": "Servidor",
    "Try to pull records from Parking": "Intentar obtener los registros desde área de espera",
    "Scheduled By": "Programado por",
    "assistL": "Asistente a la izquierda",
    "removefolders": "Remover carpetas",
    "Home": "Inicio",
    "chartinfo": "Información del organigrama",
    "autodelta": "Notificaciones automáticas",
    "Link Template": "Enlazar vista",
    "Basic Rule": "Regla básica",
    "Time Formats": "Formatos de hora",
    "Role Assignment": "Asignación de roles",
    "exclude": "Excluir",
    "endpoint": "Último punto",
    "Allow Groups with Managers": "Permitir grupos con gerentes",
    "unknownerrnoemail": "Error desconocido. Intenté cargar nuevamente la página, o contacte a soporte si el problema persiste.",
    "reqpitinfo": "Haga clic aquí para aprender más sobre organigramas en un punto en el tiempo",
    "allowedlimit": "Llímite permitido de cuadros:",
    "resetdirs": "Reiniciar carpetas",
    "selectuiprofile": "Entrada de perfil de IU",
    "rowsecrestrictedfields": "No se puede ver ninguno de los campos.",
    "nofileresults": "No hay resultados de búsqueda en",
    "fileinfoerr": "Error al obtener información de archivo.",
    "customfonts": "Fuentes personalizadas",
    "savingaccountsettings": "Guardar configuración de cuenta",
    "Organization ID": "ID de organización",
    "disabledAccount": "Cuenta desactivada. Haga clic aquí para más detalle.",
    "No chart data loaded - select the Refresh Data Now option to load data": "No hay datos para la organigrama cargados - seleccionar la opción actualizar organigrama para cargar datos.",
    "emailadderr": "Correo en uso. Favor intente ingresar otra dirección.",
    "Not In": "No en",
    "newnameuiprofile": "Renombre el perfil de IU",
    "copyuiprofile": "Copiar perfil de IU",
    "Rule": "Regla",
    "Allow View": "Permitir vista",
    "uploadfailmultiplefiles": "Fallo en carga: No se pueden cargar múltiples aarchivos. Por favor, suba un archivo a la vez.",
    "occcode": "Código de posición",
    "chartaccess": "Permitir acceso",
    "Chart Management": "Gestión de organigrama",
    "All": "Todo",
    "formulaerrdupname": "El nombre ya existe.",
    "fileinfoerror": "No es posible actualizar el directorio. Por favor, inténtelo de nuevo.",
    "parentUnitID": "ID de unidad organizativa padre",
    "renameuiprofile": "Ingrese el nombre del perfil de IU",
    "assistPL": "Compañero asistente a la izquierda",
    "notsandbox": "Esta no es una cuenta de ambiente de pruebas",
    "Box Flag": "Marca de cuadro",
    "Current top box": "Cuadro superior actual",
    "groupprops": "Propiedades de grupo",
    "nochartsloaded": "No hay organigramas cargados",
    "Importfiltereditor": "Importar editor de filtros",
    "UI Profile": "Perfil de IU",
    "novalue": "El valor debe ser de al menos dos caracteres",
    "assistPR": "Compañero asistente a la derecha",
    "needsrefresh": "Una nueva versión de OCN ha sido liberada. Favor de actualizar su navegador (Ctrl+Shift+R)",
    "enterhighlightname": "Ingrese el nombre del resaltado",
    "customFontMsg": "ej. Helvética",
    "Filters & Highlights": "Filtros y resaltados",
    "Current View": "Vista actual",
    "Filtered Managers": "Gerentes filtrados",
    "addafolder": "No existe el archivo",
    "Enter Name Here": "Ingrese el nombre aquí",
    "color": "Color",
    "pitenabled": "Archivo automático",
    "archiveloadsuccess": "Carga de archivo exitoso",
    "noheaders": "Usted debe importar los datos antes de añadir supervisores auxiliares.",
    "grouptype1": "Grupo con encabezado",
    "Clear Existing Groups": "Borrar los grupos existentes",
    "preferredlast": "Último preferido",
    "breakcharacter": "Carácter divisor",
    "Connecting Line Style": "Estilo de conector",
    "buildcharton": "Crear el organigrama en",
    "Excel Settings": "Configuraciones de excel",
    "chiefID": "ID posición jefe",
    "Box Color": "Color de cuadro",
    "Administration": "Administración",
    "used": "utilizado",
    "companynamedd": "Ingrese el nombre de la compañía",
    "onecolL": "Una columna a la izquierda",
    "configerrormsg": "Uno o más campos están mal definidos para este organigrama. Por favor, use la sección de mapas para definirlos apropiadamente.",
    "renamefolder": "No es posible renombrar la carpeta. inténtelo nuevamente.",
    "ungroup": "Desagrupar",
    "ActivityLog": "Registros…",
    "Existing Chart": "Organigrama existente",
    "grouptype2": "Grupo sin encabezado",
    "customFontTitle": "Nuevo estilo de fuente",
    "Security Profile": "Perfil de seguridad",
    "Restricted fields": "Campos restringidos",
    "highlightcolor": "Color de resaltado",
    "Notification": "Notificación",
    "advancedSettings": "Configuraciones avanzadas",
    "Definitions": "Definiciones",
    "refreshorgprops": "Propiedades de actualización",
    "selected": "seleccionado.",
    "archivesuccess": "Archivo creado exitosamente.",
    "Section": "Sección",
    "createnew": "Crear nuevo",
    "Header": "Encabezado",
    "uiprofiles": "Perfiles de IU",
    "include": "Incluir",
    "customfont": "Personalizado",
    "occcount": "Conteo de posición",
    "Number of Boxes": "Cuadros mostrados",
    "scheduleoptions": "Opciones de programación",
    "grouptype": "Tipo de grupo",
    "Loading": "Cargar",
    "docut": "Texto cortado",
    "Layout Type": "Tipo de diseño",
    "removefields": "Remover campos",
    "Allowed fields": "Campos permitidos",
    "Chart Access": "Acceso al organigrama",
    "Select All": "Seleccionar todo",
    "boxingroup": "Todas los cuadros en este grupo",
    "onecolCL": "Una columna centrada a la izquierda",
    "user": "Usuario",
    "Dynamic": "Dinámico",
    "Local": "Local",
    "Local (time)": "local",
    "uploadingnow": "Cargando archivo…",
    "6004": "Una o más fórmulas contienen referencias inválidas. Por favor, verifique sus fórmulas (Más > configuración del organigrama > campos y fórmulas), o contacte con el servicio de atención al cliente si este problema persiste.",
    "Date Format": "Formato de fecha",
    "Refine": "Afinar por",
    "manual": "Manual",
    "Invalid or unset default chart Define the default chart in the database config panel": "Organigrama inválido o no establecido como determinado. Defina el organigrama predeterminado en el panel de configuración de la base de datos.",
    "Allowed": "Permitido",
    "Security Profile Configuration": "Configuración de seguridad",
    "pleaseReduceNumberLevels": "Por favor reduzca el número de niveles de su organigrama.",
    "User Information": "Información de usuario",
    "viewernochartserr": "No se han configurado organigrama. Haga clic en crear nuevo organigrama para iniciar.",
    "No charts have been configured": "No se han configurado organigrama",
    "Apply Box Style To Members": "Aplicar estilo de cuadro a los miembros",
    "yesfileresults": "Resultados de búsqueda en",
    "banded": "Agrupado",
    "copyclipboard": "Copiar al portapapeles",
    "preferredfirst": "Preferidos primero",
    "eightcolumn": "Ocho columnas",
    "Connecting Line Color": "Color de conector",
    "enterMyMap": "Entrada mapeo de campo",
    "clicktoadd": "Haga clic en (+) para añadir",
    "Linked Template": "Vista enlazada",
    "Current Chart": "Información de organigramas",
    "lastpit": "Último archivo",
    "Main Data Source": "Fuente de datos principal",
    "Data Source": "Fuente de datos",
    "Data sources": "Fuentes de datos",
    "nospaceuiprofile": "Perfiles de IU no deben contener espacios",
    "Columns": "Columnas",
    "viewernotset": "No establecido",
    "deltaerr": "Error al generar el reporte delta",
    "Add new chart confirm": "¿Desea crear manualmente un nuevo organigrama? Asegúrese de que su fuente de datos y la configuración sean correctas.",
    "border": "Borde",
    "entercheckpointname": "Ingrese un nombre al punto de control",
    "themearrow": "Flecha de tema",
    "Map": "Mapa",
    "availableviews": "Vistas disponibles",
    "twelvecolumn": "Doce columnas",
    "Row Level Security": "Seguridad a nivel de renglón",
    "stagger": "Escalonar",
    "year": "Año",
    "Years": "Años",
    "Set Text Style": "Configurar estilo de texto",
    "sixcolumn": "Seis columnas",
    "onecolR": "Una columna a la derecha",
    "Seed Value": "Valor generado",
    "Custom Colors": "Colores personalizados",
    "Records": "Registros",
    "twentycolumn": "Veinte columnas",
    "allowedviews": "Vistas permitidas",
    "branchlevelsecurity": "Seguridad a nivel de rama",
    "UI Profiles": "Perfiles de IU",
    "unexpectederr": "Campo actualizado. Ha ocurrido un error interno.",
    "checkpoint": "punto de control",
    "Complex Math": "Matemáticas complejas",
    "Optional": "Opcional",
    "assistR": "Asistente a la derecha",
    "fontstyle": "Estilos de fuente",
    "FieldValue": "Valor de campo",
    "renameerr": "No se puede cambiar el nombre de los archivos seleccionados. Por favor, inténtelo de nuevo.",
    "accountinfo": "Detalles de cuenta",
    "selectadpoid": "Entrada ADP OID",
    "copyitem": "Artículo",
    "Details": "Detalles",
    "userdetails": "Detalles de usuario",
    "userdetails (short)": "Detalles de usuario",
    "deltareport": "Reporte delta",
    "loadingfolder": "Cargando…",
    "enterfontstyle": "Ingrese un nombre de fuente (ej. Helvética)",
    "sixteencolumn": "Dieciséis columnas",
    "Criteria": "Criterios",
    "enterfiltername": "Ingrese un nombre de filtro aquí",
    "Apply Template": "Aplicar vista",
    "Required": "Requerido",
    "savinggroups": "Guardando cambios…",
    "Grouping": "Agrupar",
    "selectpassword": "Entrada de contraseña de servicio",
    "Static Formula Editor": "Editor de formula estática",
    "from": "Desde",
    "chartbuildertemplates": "Vista del generador de organigramas",
    "Custom fields": "Campos personalizados",
    "Fields shown": "Campos visibles",
    "Always Apply": "Aplicar siempre",
    "Show Username": "Mostrar nombre de usuario",
    "rowsecallowedfields": "Únicamente estos campos pueden ser vistos.",
    "Private Folder Access": "Acceso a carpeta privada",
    "showFilenames": "Mostrar nombres de archivos",
    "canExportExcel": "Exportar a Excel",
    "In": "En",
    "Conditional rule": "Regla condicional",
    "AuxSuperID": "ID supervisor aux",
    "Not Equal": "No es igual",
    "month": "Mes",
    "Equal": "Igual",
    "autochildren": "Auto (Subordinados)",
    "Current": "Actual",
    "DecimalPlaces": "Dígitos decimales",
    "items": "elementos",
    "Operation": "Operación",
    "checkdelconfirm": "¿Está seguro que desea eliminar este punto de control?",
    "nofieldvalues": "No existen valores asociados con este campo",
    "securityoverride": "Sobrescribir asignación de seguridad del sistema",
    "Access Group": "Grupo de acceso",
    "uifont": "Fuente de IU",
    "orgChiefID": "ID de jefe de unidad organizativa",
    "includeorphans": "Incluir huérfanos",
    "filterbuild": "Los filtros seleccionados se aplicarán en la próxima construcciòn",
    "maxplimit": "Número máximo de cuadros es un solo documento organigrama",
    "singleplimit": "Número máximo de cuadros en una sola página",
    "Plan Status": "Estado de plan",
    "Archive Plan": "Archivar plan",
    "importsaveconfirm": "Está a punto de importar nuevos datos.",
    "Target": "Objetivo",
    "loadheadersfailure": "Se detectaron uno o más problemas en la asignación de campos del origen de datos. Haga clic en configurar mapeo para resolverlo.",
    "addrestricted": "Añadir campo restringido",
    "Lock Plan": "Bloquear plan",
    "Enable Administrator User Impersonation": "Habilitar el administrador de sustitución de usuario",
    "Showing": "Mostrando",
    "managers": "gerentes",
    "Showing X of Y managers": "Mostrando {visibleCount} de {totalCount} gerentes",
    "Showing results": "Mostrando {firstResult} - {lastResult} de {totalCount} resultados",
    "Results per page": "Resultados por página",
    "Limit": "Límite",
    "refreshsaveconfirm": "Está a punto de realizar una actualización de datos.",
    "Change": "Cambiar",
    "Show Overlay": "Mostrar superposición",
    "selectagroup": "Seleccione un grupo de la lista",
    "Browse": "Navegar",
    "viewer": "Visor",
    "addnewgroup": "Haga clic en 'agregar' para crear un grupo.",
    "generatedelta": "Generando reporte delta",
    "Additional Tables": "Tablas adicionales",
    "directory": "Directorio",
    "Compare Plans": "Comparar planes",
    "Talent Pool": "Grupo de talento",
    "savemasteras": "Guardar maestro como",
    "Date Modified": "Fecha modificada",
    "No Plans Alert": "Haga clic aquí para crear su primer plan.",
    "Private": "Privado",
    "addkey": "Agregar clave",
    "Online": "En línea",
    "deleteusers": "¿Seguro que desea eliminar los usuarios seleccionados?",
    "SystemError": "No se completó la transacción:",
    "Active Plans": "Planes activos",
    "Offline": "Desconectado",
    "Search Archived Charts": "Buscar organigramas archivados",
    "Search Backgrounds": "Buscar fondos",
    "Minimum Group Size": "Tamaño mínimo de grupo",
    "deletesource": "Eliminar archivo de origen después de actualización",
    "Share with others": "Compartir con otros",
    "Delete Plan": "Eliminar plan",
    "nosavedfilter": "No se encontraron filtros guardados.",
    "searchkeys": "Claves de búsqueda",
    "Edit Plan": "Editar plan",
    "Duplicate Plan": "Duplicar plan",
    "Save Master": "Guardar maestro",
    "Last Synchronized": "Última sincronización",
    "Away": "Lejos",
    "New User": "Nuevo usuario",
    "Private Plan": "Plan privado",
    "Plan On": "Plan activado",
    "Plan Explorer": "Explorador de planes",
    "Error": "Error",
    "Planning": "Planificación",
    "Plan": "Plan",
    "keyname": "Nombre clave",
    "Starting": "Comenzando",
    "collaborator": "Colaborador",
    "allowcommitsds": "Permitir comunicación con fuente de datos",
    "Save Plan": "Guardar plan",
    "Plan Name": "Nombre de plan",
    "containsuser": "Introduzca nombre de usuario o correo electrónico",
    "notsupported": "No soportado por",
    "PersonUnitID": "ID posición de unidad org",
    "deleteuser": "¿Seguro que desea eliminar al usuario?",
    "customoutfields": "Usar campos personalizados de salida",
    "owner": "Propietario",
    "Archived": "Archivado",
    "allowmanualrefresh": "Permitir actualizar manualmente esta organigrama",
    "saveandcontinue": "¿Guardar cambios y continuar?",
    "Created": "Creado",
    "Plan Builder": "Creador de plan",
    "includeself": "Incluir uno mismo",
    "Rename base chart": "Renombrar organigrama base",
    "Rename Plan": "Renombrar plan",
    "Rename profile": "Renombrar perfil",
    "Plan Metrics": "Métricas de plan",
    "createcheck": "Seleccione 'nuevo' para crear un punto de control.",
    "Change Levels": "Cambiar niveles",
    "headerssaveconfirm": "Está a punto de modificar el origen de datos del organigarma seleccionado.",
    "loadtoedit": "Cargar un organigrama para editar filtros y resaltes",
    "NoPlansExist": "No se han creado planes aún. Haga clic aquí o en seleccionar nuevo plan para poder iniciar.",
    "conddefeditor": "Editor de definición condicional",
    "Edit Box": "Cuadro de edición",
    "Comments": "Comentarios",
    "Unlock Plan": "Desbloquear plan",
    "people": "persona(s)",
    "person": "persona",
    "(No people)": "(Sin personas)",
    "Group \"Full Access\"": "Grupo \"Acceso Total\"",
    "selectf": "Seleccionar campo",
    "Plan Name cannot be left blank": "Nombre de plan no puede esta vacío",
    "Team members": "Miembros de equipo",
    "Distance To Target": "Distacia al objetivo",
    "Status": "Estado",
    "nosavedhighlight": "No se encontraron resaltes guardados",
    "Open Plan": "Abril plan",
    "dropdups": "Eliminar duplicados",
    "Archived Plans": "Planes archivados",
    "Comment": "Comentar",
    "Enter": "Entrar",
    "Enter (Value)": "Ingrese",
    "Monthly": "Mensual",
    "New Plan": "Nuevo plan",
    "Dashboard": "Tablero",
    "Unable to Save Changes": "No se pueden guardar cambios",
    "SystemError2": "Intente volver a cargar la página, o contacte a soporte si este problema persiste.",
    "restrictq": "Restringir consulta a esos campos",
    "Select a user to start sharing": "Seleccionar un usuario para comenzar a compartir",
    "6000": "Conector no compatible con tipo de archivo seleccionado.",
    "addoperations": "Haga clic en (+) para añadir operaciones.",
    "NoValuesAdded": "No hay valores. Haga clic aquí para añadir.",
    "Change Topbox": "Cambiar cuadro superior",
    "piechartprops": "Editor de grafica circular",
    "Activity Log": "Registro de actividades",
    "Last Modified": "Última modificación",
    "Active": "Activo",
    "Paused": "En pausa",
    "Inactive": "Inactivo",
    "Shared Plans": "Planes compartidos",
    "background": "Antecedentes",
    "NoSharedUsers": "No está compartiendo este plan. Haga clic aquí para empezar a compartir.",
    "addtemplate": "Agregar vista",
    "Share Plan": "Compartir plan",
    "Target Field": "Campo objetivo",
    "Enter Plan Name": "Ingrese nombre de plan",
    "Change History": "Cambiar historia",
    "Create Metrics": "Crear métricas",
    "Validation Alert": "Alerta de validación",
    "grayscale": "Escala de grises",
    "Total Changes": "Total de cambios",
    "NoMetrics": "Haga clic aquí para añadir una métrica",
    "Moves": "Mueve",
    "Uniform Scaling": "Escala uniforme",
    "Target Value": "Valor objetivo",
    "stageNew": "No se presentan registros. Realice una búsqueda para adicionar nuevos registros.",
    "Hover Profile": "Perfil flotante",
    "Add Metric": "Agregar métrica",
    "Edits": "Edita",
    "Metric": "Métrica",
    "Index Page": "Página de inicio",
    "Loading Plan": "Cargando plan",
    "Last Sync": "Última sincronización",
    "Building Plan": "Creando plan",
    "Adds": "Agrega",
    "Deletes": "Elimina",
    "No formulas have been created": "No se crearon fórmulas. Diríjase a configuración de organigrama > campos y fórmulas para agregar formulas",
    "Add metrics": "Agregar métricas para establecer objetivos de plan y dar seguimiento a cambios",
    "Inverted": "Invertido",
    "Fields editable in plan": "Los campos abajo son editables en su plan",
    "Shortcut Field": "Campo de atajo",
    "fotm": "1o del mes",
    "Included Headers": "Encabezados incluídos",
    "Summary": "Resumen",
    "Fields available": "Los campos que aparecen aquí están disponibles para edición en su plan",
    "History": "História",
    "Sharing & Collaboration": "Compartir y colaboración",
    "Share to collaborate": "Otorga a otros usuarios acceso colaborativo o de sólo visualización a este plan",
    "alldivisions": "Todas las divisiones",
    "Expand": "Expandir",
    "Select a user to share with": "Seleccionar un usuario para compartir",
    "motm": "15o del mes",
    "No archives have been created": "No se han creado archivos",
    "Chart Builder & Publisher Subchart Breaks": "Creador de organigrama y generador de cortes de suborganigrama",
    "Default Fields": "Campos predeterminados",
    "Manage Editable Fields": "Gestionar campos editables",
    "All plans are shared with you": "Todos los planes compartidos con usted",
    "Metrics & Data Visualization": "Métricas y visualización de datos",
    "Collapse": "Colapsar",
    "Syncing Plan": "Plan de sincronización",
    "Effective Dates": "Fechas efectivas",
    "Subcharts & Shortcuts": "Suborganigramas y atajos",
    "Timeline": "Línea de tiempo",
    "by": "por",
    "eotm": "Último del mes",
    "Editable Fields": "Campos editables",
    "Manage metrics": "Gestionar métricas",
    "allowedHighlights": "Resaltados permitidos",
    "Archive Cleanup": "Limpieza de archivos",
    "ExportChart": "Exportar organigrama",
    "Symbols": "Símbolos",
    "Show Activity": "Mostrar actividad",
    "SFTP": "SFTP",
    "Conflict Detected": "Conflicto detectado entre la fuente de datos y el plan",
    "Chart Documents": "Documentos del organigrama",
    "dateBracket": "Soporte de fecha",
    "Add Branch Rule": "Añadir regla de seguridad de rama",
    "eqdesc": "Los campos condicionales se ocultan si el valor de un registro es igual al criterio de valor de campo.",
    "Auto Format": "Formato automático",
    "ownbranch": "Restringir a la propia rama",
    "Date Bracket": "Soporte de fecha",
    "Remove rule": "Remover regla",
    "Employee Removed": "El registro ya no existe en los datos de la fuente. Invierta el cambio para resolver el conflicto.",
    "Documents": "Documentos",
    "Dynamic Range": "Rango dinámico",
    "Rule Comparison": "Comparación de regla",
    "formulareservedname": "es un nombre reservado.",
    "formulareservedname2": "Por favor ingrese un nombre de campo único.",
    "Use Source": "Utilizar fuente",
    "Choose Source": "Elija entre los valores del plan o de la fuente para resolver el problema.",
    "Months": "Meses",
    "Older Than": "Eliminar archivos anteriores a",
    "confirmAddDelegated": "Un usuario con esta dirección de correo electrónico ya existe en otra organización. ¿Quiere concederles acceso a su organización?",
    "Reserved Field Name": "Nombre de campo reservado",
    "Additional Levels": "Niveles adicionales",
    "enumeratedbranch": "Ramas enumeradas",
    "indesc": "Los campos condicionales se ocultan si el valor de un registro coincide con cualquier criterio de valor de campo.",
    "documentproperties": "Propiedades del documento",
    "branchaccesslist": "Campo de acceso a rama",
    "Branch Level Security": "Seguridad a nivel de rama",
    "nindesc": "Los campos condicionales se ocultan si el valor del registro no coincide con ningún criterio de valor de campo.",
    "allowedFilters": "Filtros permitidos",
    "Activity": "Acitivdad",
    "Select a Profile": "Seleccione un perfil",
    "Revert": "Revertir",
    "ViewerLoadChartError": "Sólo se pueden añadir al visor los organigramas hechos a partir de un organigrama maestro. Cree su organigrama usando el creador de organigramas para añadirlo al visor.",
    "Static Range": "Rango estático",
    "neqdesc": "Los campos condicionales se ocultan si el valor de un registro no es igual al criterio de valor de campo.",
    "Delegated": "Delegado",
    "Weeks": "Semanas",
    "Master Charts": "Creador de organigramas",
    "Use Plan": "Utilizar plan",
    "topboxids": "ID´s de cuadro superior",
    "Configure Link Access": "Configurar enlace de acceso",
    "Suppress": "Suprimir",
    "New Table": "Haga clic aquí para crear una tabla.",
    "Allow Public Access": "Permitir acceso público",
    "Select UI Profile": "Seleccione el perfil de la interfaz de usuario",
    "Object": "Objeto",
    "Source Data": "Datos de origen",
    "Revert To Source": "Volver a la fuente",
    "Authorization": "Autorización",
    "Append Plan": "Añadir tabla de plan",
    "Table Manager": "Administrador de la tabla",
    "Data field used for assignment": "Campo de datos utilizado para asignación de grupo",
    "Delete Confirm Append Entry": "¿Está seguro de que desea eliminar la entrada adicional seleccionada? (Los cambios tendrán efecto en la próxima actualización de la tabla).",
    "Automatically assign users to access group upon login": "Asignar automáticamente los usuarios al grupo de acceso al iniciar la sesión",
    "Export Options": "Opciones de exportación",
    "Allowed Referrer Domains": "Dominios de referencia permitidos",
    "tabledeleteconfirm": "ADVERTENCIA: Todos los organigramas que utilicen esta tabla como fuente adicional ya no incluirán los datos adicionales asociados a esta tabla (los cambios se reflejarán en la próxima actualización de los datos).¿Está seguro de que desea eliminar permanentemente esta tabla? Esta acción no se puede deshacer.",
    "Configure whitelist domains for restricted link access": "Configurar los dominios de la lista blanca para el acceso restringido a los enlaces",
    "All fields are exported by default": "Todos los campos se exportan por defecto.",
    "useuiprofile": "Utilizar el perfil de la interfaz de usuario",
    "About Append Tables": "Las tablas adicionales permiten cambiar los valores de los datos de origen.",
    "No Append Entries": "No se han creado entradas para añadir. Utilice los botones de la izquierda para crear su primera entrada",
    "Link User Configuration": "Configuración del usuario de enlace",
    "Auto-Assignment Configuration": "Configuración de la autoasignación",
    "Card": "Tarjeta",
    "Use default group instead of denying access": "Utilizar el grupo por defecto en lugar de denegar el acceso",
    "Append Table": "Adicionar tabla",
    "Also Reports To": "También informa a",
    "Left Bound": "Antes",
    "Bounds": "Límites",
    "Right Bound": "Después",
    "Set which groups line up with values in your data": "Establezca qué grupos se alinean con los valores de sus datos",
    "Document Settings": "Configuración del documento",
    "Use Presentation": "Usar presentación",
    "Master chart used to validate user": "Organigrama maestro utilizado para validar al usuario",
    "Image Settings": "Configuración de la imagen",
    "Automated Chart Export": "Exportación automática de organigramas",
    "Allow public access": "Habilitar el acceso público permitirá a cualquier persona en internet con este enlace de este usuario acceder a OCN. ¿Está seguro de que quiere proceder?",
    "Use data field for Row Level Security assignment": "Utilizar el campo de datos para la asignación de seguridad de nivel de fila",
    "Find Record": "Buscar registro",
    "Find record to add to talent pool…": "Buscar registro para añadir al grupo de talento…",
    "Append Entry Help": "Añadir, actualizar, mover y suprimir registros en su organigrama.",
    "personidinuse": "PersonID ya está en uso.",
    "Bounded": "Limitado",
    "Chart Editor": "Editor de organigramas",
    "User Record Retrieval": "Recuperación registro de usuario",
    "Overwrite Existing Data": "Sobrescribir datos existentes",
    "confirmexit": "¿Está seguro de que desea salir?",
    "Filter Options": "Opciones de filtro",
    "Error importing views message": "Error al importar vistas. Asegúrese de utilizar el botón 'exportar vistas' en otra cuenta OCN y pulse el botón pegar en esta pantalla.",
    "New Record": "Nuevo registro",
    "enablegoogleslides": "Habilitar exportación diapositivas Google",
    "Please Correct": "Por favor corrija",
    "Interactive": "Interactivo",
    "Configure the fields used to identify a chart record that corresponds with a user.": "Configure los campos utilizados para identificar un registro de organigrama que corresponda a un usuario.",
    "No activity yet": "Aún no hay actividad.",
    "Add Branch": "Agregar rama",
    "Prebuilt Filters": "Filtros preconstruídos",
    "No filter applied": "Ningún filtro aplicado",
    "Filtering": "Filtrado",
    "View successfully imported. Be sure to save the changes to your shared templates and box styles libraries.": "Vista importada correctamente. Asegúrese de guardar los cambios en las bibliotecas compartidas de estilos de cuadro y plantillas.",
    "addmanualsub": "Añadir subordinado",
    "Interactive Filtering": "Filtrado interactivo",
    "Effective date": "Fecha efectiva",
    "Confirm Overwrite Manual Data Source": "¡PROCEDA CON PRECAUCIÓN! Cambiar el archivo de origen de datos sobrescribirá los datos existentes, incluidas todas las ediciones manuales.\n ¿Está seguro de que desea sobrescribir los datos de origen?",
    "Remove Field": "Eliminar campo",
    "Overwrite": "Sobrescribir",
    "Add to plan": "Añadir al plan",
    "Return to Chart": "Volver a organigrama",
    "Return to base chart": "Regresar al organigrama base",
    "privateinfotext": "Los vínculos privados le permiten crear puntos de entrada personalizados en el organigrama mientras sigue requiriendo autenticación (SSO o inicio de sesión directo).",
    "Show Details": "Mostrar detalles",
    "Hit the paste shortcut on your keyboard to import templates": "Presione el atajo de pegar en su teclado para importar vistas",
    "linnkuserconfigwarning": "No se ha configurado ningún usuario para este tipo de vínculo. Vaya a más -> configuración de cuenta -> autorización para configurar los usuarios para los vínculos. Haga clic en el botón ? para más detalles.",
    "Are you sure you want to": "¿Está seguro de que desea",
    "Move within plan": "Moverse dentro del plan",
    "creategoogleslides": "Creación de diapositivas Google...",
    "publicinfotext": "Los enlaces públicos son accesibles para cualquier persona en internet con un enlace vinculado a este usuario.",
    "Do you want to resume planning in your last open plan?": "¿Desea reanudar la planificación en su último plan abierto?",
    "Additional Info": "Información adicional:",
    "About Plan": "Acerca del plan",
    "generategoogleslides": "Cargando diapositivas Google a Google drive",
    "restrictedinfotext": "Los vínculos restringidos están protegidos, accesibles solo desde los sitios que especifique.",
    "navtocell": "Mostrar tabla",
    "Basic Info": "Información básica",
    "Remove from pool": "Retirar del grupo",
    "Close Plan Builder": "Cerrar creador de planes",
    "deletemanualbox": "Eliminar cuadro",
    "Launch Configuration": "Configuración lanzamiento",
    "Shadow": "Sombra",
    "Get Started": "Comenzar",
    "Box Spacing": "Espaciado de cuadro",
    "SVG Image": "Imagen SVG",
    "Mode": "Modo",
    "Save Alert": "¿Guardar cambios?",
    "Justify": "Justificar",
    "Dynamic Value": "Valor dinámico",
    "See Plans": "Ver planes",
    "Refresh chart now": "Actualizar organigrama ahora",
    "JPG Image": "Imagen JPG",
    "Legacy Chart": "Organigrama heredado",
    "Excel Data": "Datos Excel",
    "supportdeskhelp2": "mesa de soporte",
    "Permission denied to access Planning module. Ensure your role and organization have access to Planning": "Permiso denegado para acceder al módulo de planeación. Asegúrese de que su rol y su organización tengan acceso a planeación.",
    "Align Chart Top": "Alinear arriba",
    "Last Login": "Último inicio de sesión",
    "Font Selector": "Selector de fuente",
    "Metadata Type": "Tipo de metadatos",
    "PNG Image": "Imagen PNG",
    "Sync Now": "Sincronizar ahora",
    "Buy Now": "Comprar ahora",
    "Label Options": "Opciones de etiqueta",
    "Do you want to roll up the subordinates from other pages": "¿Desea acumular los subordinados de otras páginas?",
    "Unable to locate target box!": "No se puede localizar el cuadro destino!",
    "Sync plan": "Plan sincronización",
    "Locked plans cannot be synced with base chart data": "Los planes bloqueados no se pueden sincronizar con los datos del organigrama base",
    "Archived plans cannot be synced with base chart data": "Los planes archivados no se pueden sincronizar con los datos del organigrama base",
    "Cannot sync with unsaved background changes": "No se puede sincronizar con cambios de fondo sin guardar",
    "Launch to Self": "Lanzamiento a uno mismo",
    "Load Headers": "Cargar encabezados",
    "Standard Search": "Búsqueda estándar",
    "Resume last open plan": "¿Reanudar el último plan abierto?",
    "Branch Level": "Nivel de rama",
    "Google Slides": "Diapositivas Google",
    "Save Changes": "Guardar cambios",
    "PPT Document": "Documento PPT",
    "Line Thickness": "Línea gruesa",
    "Remote": "Remoto",
    "Center Chart Horizontal": "Centrar horiz",
    "Open Last Plan": "Abrir último plan",
    "Box Sort": "Ordenar cuadros",
    "Line Color": "Color línea",
    "Single Logout": "Cierre sesión",
    "Click Setup Chart to get started": "Haga clic en configurar organigrama para comenzar",
    "Please Wait": "Espere por favor",
    "Delete SSO Configuration": "Eliminar configuración de SSO",
    "Confirm delete SSO configuration": "Confirmar eliminación de la configuración de SSO",
    "SSO Entity ID": "ID entidad SSO",
    "Static Value": "Valor estático",
    "SSO Configuration": "Configuración SSO",
    "Master Chart Settings": "Configuración del organigrama maestro",
    "Font Color": "Color de fuente",
    "darkmode": "Modo oscuro",
    "Planning Access Denied": "Acceso a planeación denegado",
    "PDF Document": "Documento PDF",
    "Discard Changes": "Descartar cambios",
    "Staging": "Espera",
    "Contact your system administrator if this issue persists": "Contacto al administrador del sistema si persiste este problema.",
    "Session Warning": "Susesión está por expirar debido a inactividad. Selecciones continuar o cerrar la sesión. De lo contrario, se cerrará automáticamente.",
    "Excel Spreadsheet": "Hoja de cálculo excel",
    "Metadata Location": "Ubicación metadatos",
    "Create a Workbench document": "Crear documento workbench",
    "No Shortcuts Found": "No se han encontrado accesos directos",
    "lightmode": "Modo iluminado",
    "Auto Provision": "Aprovisionamiento automático",
    "User Value": "Valor usuario",
    "Revert Change": "¿Revertir el cambio?",
    "Move Out": "Sacar",
    "Font Size": "Tamaño de fuente",
    "Use Value from current User Record": "Usar valor del registro de usuario actual",
    "Web Link": "Enlace web",
    "Cell Fill": "Relleno de celda",
    "Confirm New Password": "Confirmar nueva contraseña",
    "Wrap Text": "Ajustar texto",
    "leave the Plan Builder": "abandonar el generador de planes",
    "Italic": "Itálico",
    "Configure AzureAD Photos": "Configuración fotos AzureAD",
    "Exit Plan Builder": "Salir del generador de planes",
    "Enable Workbench": "Habilitar workbench",
    "Privacy Policy": "Política de privacidad",
    "saveconfirm3": "Los cambios no guardados se perderán.",
    "Master Editor": "Editor maestro",
    "SSO Metadata Location": "Localidad metadatos SSO",
    "Group Assigned": "Grupo asignado",
    "Confirm Delete Plan": "¿Está seguro de que desea eliminar permanentemente este plan? Esta acción no se puede revertirse.",
    "AzureAD Photo Configuration": "Configuración fotos AzureAD",
    "supportdeskhelp": "Si el problema persiste, puede comunicarse con nuestro",
    "Search Name or Title": "Búsqueda nombre o título",
    "Password reset successfully. Be sure to update your password manager, if you use one.": "Contraseña restablecida correctamente. Asegúrese de actualizar su administrador de contraseñas, si utiliza uno.",
    "Pie Chart": "Gráfico circular",
    "Stay Logged In": "Permanecer conectado",
    "Plan Needs Sync": "El plan necesita sincronización",
    "Switch To Branch Level": "Cambiar a nivel rama",
    "Advanced Search": "Búsqueda avanzada",
    "Switch To Field Level": "Cambiar a nivel campo",
    "Continue Working": "Seguir trabajando",
    "Enable Report Issue": "Habilitar informe de problema",
    "Comm Preferences": "Preferencias com",
    "App Settings": "Config aplicación",
    "Stay": "Permanecer",
    "Underline": "Subrayado",
    "Bold": "Negrita",
    "Plan Updates Available": "Actualizaciones del plan disponibles",
    "Revert Confirm": "¿Está seguro de que desea revertir este cambio?",
    "Localization": "Localización",
    "Set your AzureAD credentials here to import Azure AD photos with your chart data.": "Establezca aquí sus credenciales de AzureAD para importar fotos de azure AD con los datos del organigrama.",
    "Exit Builder": "Salir del builder",
    "Continue Planning": "Continuar planificando",
    "and return to your chart": "¿y volver a su organigrama?",
    "SSO Metadata Type": "Tipo de metadatos SSO",
    "Plan Needs Updates": "Este plan se ha sincronizado desde la última vez que lo abrió. Confirme para obtener las actualizaciones más recientes.",
    "Open Plan Explorer": "Abrir el explorador de planes",
    "Show different fields depending on user language.": "Mostrar diferentes campos dependiendo del idioma del usuario.",
    "Saved Highlights": "Destaques guardados",
    "moveoutboxtool": "Mover fuera del plan",
    "Center Chart Vertical": "Centrar vert",
    "Chart Templates": "Vistas de organigrama",
    "Presentation": "Presentación",
    "Current Set": "Conjunto actual",
    "No Recent Documents": "No hay documentos recientes",
    "Enter Hex Value": "Introduzca valor hexadecimal",
    "Rename view": "Renombrar vista",
    "Chart Setting Mismatch": "Advertencia: El organigrama que se está configurando es diferente al organigrama actualmente abierto. La edición está deshabilitada.",
    "Undo": "Deshacer",
    "New Append Table": "Nueva tabla anexa",
    "SAML Invalid Mapping": "Valores no válidos u omisos en atributo de grupo SAML.",
    "SAML Attribute To": "Grupo de seguridad de aplicaciones",
    "Manage Views": "Administrar vistas",
    "SSO Enabled": "SSO habilitado",
    "No archives found for this chart.": "No se han encontrado archivos para esta organigrama.",
    "Alter the appearance the chart box layout.": "Modificar la apariencia del diseño de el cuadro.",
    "No records found outside the scope of the plan": "No se han encontrado registros fuera del alcance del plan",
    "Duplicate View": "Duplicar vista",
    "Redo": "Rehacer",
    "SAML Attributes Handling": "Manejo de atributos SAML",
    "Recent documents": "Documentos recientes",
    "Delete View": "Eliminar vista",
    "Save View": "Guardar vista",
    "Field in Record": "Campo en el registro",
    "Missing Photos": "Fotos que faltan",
    "Move View": "Mover vista",
    "File Name": "Nombre de archivo",
    "Select a view to start editing": "Seleccionar una vista para empezar a editar",
    "Launch Chart Builder": "Iniciar generador de organigramas",
    "New View": "Nueva vista",
    "Automatically create new users if they do not already exist": "Crear automáticamente nuevos usuarios si aún no existen",
    "Invalid File Name": "Nombre de archivo no válido",
    "SAML Group Attribute": "Atributo de grupo SAML",
    "No File Selected": "No se seleccionó archivo",
    "Open document": "Abrir documento",
    "File Manager": "Administrador de archivos",
    "Custom Accent Color": "Color de énfasis personalizado",
    "Accent": "Énfasis",
    "Roll Up": "Consolidación",
    "Rename Subchart": "Renombrar suborganigrama",
    "What would you like to do with the subordinates of this manager?": "¿Qué le gustaría hacer con los subordinados de este gerente?",
    "SSO Enabled Warning": "Está seguro de que desea habilitar inicio de sesión único? el inicio de sesión único se activará para este ID de identidad",
    "System Vew Edit Prompt": "Esta es una vista de sistema y no puede ser modificada",
    "A file name can't contain": "Un nombre de archivo no puede contener los siguientes caracteres:",
    "File Preview": "Vista previa de archivo",
    "Rename Field": "Renombrar campo",
    "Rename custom chart": "Renomb. organigrama pers.",
    "SSO Disabled Warning": "Está seguro de que desea deshabilitar inicio de sesión único? Todos los usuarios que actualmente usan inicio de sesión único ya no podrán iniciar sesión con el IDP correspondiente al ID de identidad",
    "AdvSecEnterperisePaywall": "La seguridad avanzada es una característica solo para la versión enterprise. Póngase en contacto con su representante de ventas para obtener más información.",
    "New SSO Configuration": "Advertencia: Active el cuadro SSO habilitado para habilitar el inicio de sesión SSO.",
    "Switch Mode": "Cambiar modo",
    "View Manager": "Administrador de vistas",
    "Automatically sign users out of IDP in addition to application sign-out.": "Cierra automáticamente la sesión de los usuarios de IDP además de cerrar la sesión de la aplicación.",
    "Refresh document": "Actualizar documento",
    "Appearance": "Apariencia",
    "SAML Attribute From": "Grupo seguridad de IDP",
    "Delete Manager": "Eliminar gerente",
    "Create blank chart": "Crear organigrama en blanco",
    "Custom Background Color": "Color personalizado de fondo",
    "Compare Charts": "Comparar organigramas",
    "Plan Options": "Opciones de plan",
    "Igloo": "Igloo",
    "Click on a topbox from the list below": "'Sus criterios de filtro han eliminado todos los cuadros de la pantalla. Haga clic en un cuadro superior de la lista a continuación para navegar a una rama sin filtrar o ajustar sus criterios de filtro'",
    "Phone": "Teléfono",
    "sharepointqerr": "No se pudo configurar SharePoint. Comuníquese con el servicio de atención al cliente en",
    "NoSharepointConfig": "Credenciales de SharePoint incompletas o no configuradas. Haga clic aquí para configurar.",
    "Effective Dating": "Citas efectivas",
    "ViewerNoMasterChartsNotAdmin": "No se pudieron cargar los datos del organigrama. Comuníquese con el administrador del sistema para configurar su cuenta.",
    "unableOpenPlan": "No se puede abrir el plan. Confirme la integridad de los datos del organigrama de origen y el mapeo de campo.",
    "New Mapping": "Nuevo mapeo",
    "Mute": "Muda",
    "Reload Directory": "Recargar directorio",
    "All fields are shown in the Profile Tab by default": "Todos los campos se muestran en la pestaña perfil de forma predeterminada.",
    "Photo Source": "Fuente de la foto",
    "AzureAD": "Azure AD",
    "incompletesharepointcreds": "Finalice la configuración automatizada de sharepoint guardando sus credenciales de sharepoint dentro del panel de configuración de la cuenta> autorización",
    "Snapshot": "Instantánea",
    "delegatedsameorgemail": "ya se le ha otorgado acceso a esta organización.",
    "This is a Point in Time chart generated": "Este es un organigrama de un momento en el tiempo generado",
    "Metrics": "Métrica",
    "permanentaction": "Advertencia: esta acción no se puede deshacer",
    "Additional photo configuration": "Configuración de fotos adicional",
    "Users": "Usuarios",
    "No Snapshots found for this chart. Click here to configure automated snapshot generation.": "No se encontraron instantáneas para este organigrama. Haga clic aquí para configurar la generación automática de instantánea",
    "Sharepoint Domain": "Dominio de SharePoint",
    "Move With Manager": "Moverse con el gerente",
    "Duplicate EntityID": "No se puede guardar la configuración de SSO. Confirme que la identificación de la entidad sea correcta y comuníquese con el servicio de asistencia si el problema persiste",
    "Invalid SSO Metadata": "No se puede guardar la configuración de SSO. Verifique el tipo y la ubicación de los metadatos.",
    "No Snapshots found for the above date range.": "No se encontraron instantáneas para el período anterior.",
    "ConfigureSharePoint": "Configuración de credenciales de SharePoint",
    "Sharepoint Configuration": "Configuración de sharepoint",
    "Select the field to translate based on the end-user's language settings.": "Seleccione el campo para traducir según la configuración de idioma del usuario final.",
    "Enable Automatic Archives to Begin Configuring Automated Delta Report Emails": "Habilite los archivos automáticos para comenzar a configurar los correos electrónicos de informes delta automatizados",
    "Skype": "Skype",
    "Move Manager": "Gestor de movimientos",
    "planinfo": "Información del plan",
    "Move Out Manager": "Información del plan",
    "Filtered Records will be removed when possible": "Los registros filtrados se eliminarán cuando sea posible",
    "Field Mapping": "Mapeo de campo",
    "email": "Email",
    "Create an Archive to begin making use of Delta Reports": "Cree un archivo para comenzar a utilizar delta reports",
    "Add Fields to Table": "Agregar campos a la tabla",
    "Filtered records will show with a filter overlay": "Los registros filtrados se mostrarán con una superposición de filtros",
    "Hyperlink": "Hipervínculo",
    "BuilderNoMasterChartsNotAdmin": "El generador de organigramas necesita un organigrama maestro para crear organigramas rápidamente. Comuníquese con el administrador del sistema para configurar su cuenta.",
    "Do you want to create a manual Archive for": "¿Desea crear un archivo manual para",
    "restrictedfiletypeupload": "Para cargar este tipo de archivo, vaya a workbench → documento → administrador de archivos",
    "ExportIndexPage": "El alcance de la descarga se limitará a 'Todo el organigrama' mientras se publica con la página de índice",
    "Configure dedicated API photo connectors.": "Configure conectores de fotos API dedicados.",
    "Filtered records other than managers will be removed from the chart when possible": "Los registros filtrados que no sean administradores se eliminarán del organigrama cuando sea posible",
    "Desired Holders": "Titulares deseados",
    "Edit Fields": "Edita campos",
    "Plan Builder Position Directions": "Nombre su plan, elija un punto de partida, y empiece a planear",
    "Diversity": "Diversidad",
    "enterorgsizeh": "¿Cuántos empleados hay en su organización?",
    "selecttopofchart": "Seleccione un empleado superior en la lista de abajo",
    "Holder": "Titular",
    "Do not automatically format document layout": "No formatear automáticamente el diseño del documento",
    "enterAttributeName": "Ingrese el atributo SAML para el nombre",
    "Welcome to OrgChart": "Bienvenido a OrgChart",
    "I Use an HRIS System": "Yo use un sistema de recursos humanos",
    "No API Support": "Aún no tenemos acceso directo a este sistema de conección API. Haga clic aquí para ponerse en contacto con nosotros acerca de la configuración de una integración.",
    "Select Append Data Source": "Seleccione una fuente de datos anexos",
    "Field Picker": "Seleccionador de campos",
    "Refresh Now": "Refrescar ahora",
    "Maximum character limit reached": "El límite máximo de caracteres alcanzado",
    "deleteOpenConfirm2": "Ha eliminado el organigrama actualmente abierto. Para abrir un nuevo organigrama, cierra el menu de configuración de cuenta y seleccione una de las opciones en el menú desplegable de organigramas de la barra de herramientas localizada en la parte superior izquierda.",
    "Review": "Revisar",
    "Core": "Núcleo",
    "SAML attributes": "Atributos SAML",
    "Open Image": "Abrir imagen",
    "Assign Data Source": "Seleccione una fuente de datos para empezar la configurazión",
    "Build Position Plan": "Cuál posición le gustaría en la parte superior de este plan",
    "addcoheadsplancb": "Cree un plan de co-director",
    "estimateorgsize": "Un aproximado está bien. puede agregar o remover empleados después.",
    "Case Insensitive Match": "Coincidencia insensible de mayúsculas y minúsculas",
    "About API": "Sincronizar data con mi sistema de recursos humanos",
    "cohead": "Co-Director",
    "Map positions from source data": "Mapee posiciones a partir de su fuente de datos",
    "redirectToIDP": "Redirigiendo hacia su IDP",
    "Currently Applied": "Actualmente aplicado",
    "SAML NameID Attribute": "Atributos SAML de ID de nombre",
    "Column Mapping": "Mapear columna",
    "enterAttributeNameID": "Ingrese el atributo SAML para la identificación del nombre",
    "deleteOpenConfirm1": "Está seguro de que desea eliminar este organigrama? Una vez guardados los cambios, el organigrama actualmente abierto se cerrará",
    "FieldAccessReminder": "La seguridad de nivel de fila se aplica a todos los organigramas maestros. Los campos y valores presentes en estas opciones están asociados sólo con el organigrama maestro actualmente abierto. Para agregar campos de otro organigrama maestro, cierre este panel, seleccione el organigrama maestro del menú de organigrama desplegable y luego vuelva a abrir esta interfaz.",
    "No chart data loaded mobile": "La data de su organigrama no ha cargado. Seleccione el botón de actualización en el menú de herramientas inferior para cargar datos",
    "failedauth": "Autenticación fallida",
    "Choose Plan Name": "Elija un nombre para este plan",
    "Manual Chart": "Organigrama manual",
    "Launch directory with all records": "Inicia directorio con todos los archivos",
    "navtorec": "Navegar a el archivo",
    "HRIS Connection": "Conección HRIS",
    "Select Main Data Source": "Seleccione la fuente de datos principal",
    "Blank Notification": "Este mensaje no tiene contenido",
    "Interactive Highlighting": "Resaltado interactivo",
    "Enable Direct Sign-In": "Habilitar el inicio de sesión directo",
    "Select Photo Data Source": "Seleccione la fuente de datos de fotos",
    "selectfields": "Seleccione los campos que gustaría incluir en la data de su organigrama",
    "Legacy": "Heredados",
    "Select Merge Data Source": "Seleccione la fuente de datos para combinar",
    "Org Size": "Tamaño de la organización",
    "AggregatedField": "Campo agregado",
    "Personal": "Personal",
    "Start From Scratch": "Empezar de cero",
    "Direct Sign-In": "Inicio de sesión directo",
    "StaticFormula": "Fórmula estática",
    "This chart exceeds your total box limit": "Este organigrama excede su límite máximo de cuadros",
    "reviewmanual": "Si todo se ve bien, haga clic en finalizar para completar la configuración",
    "enterAttributeEmail": "Ingrese el atributo SAML para el correo electrónico",
    "Behavior": "Comportamiento",
    "New Blank": "Nuevo espacio en blanco",
    "ssoautoproinfotext": "Cree nuevos usuarios automáticamente si aún no existen.",
    "Allow Photo Search": "Permitir búsqueda de fotos",
    "Select File": "Seleccionar un archivo",
    "Start From File": "Empiezar desde un archivo",
    "invalidchartappend": "Debe tener un organigrama maestro abierto en el mirador para comenzar a configurar una tablea de anexión",
    "Blank Message": "Los mensajes serán mostrados aquí",
    "genericsave": "Desea guardar sus cambios? Cualquier cambio no guardado se perderá",
    "Editor Tools": "Herramientas de edición",
    "Select Top of Chart": "Seleccione la parte superior del organigrama",
    "Build Position Chart": "Cuál posición le gustaría en la parte superior de este organigrama",
    "Disable Direct Sign-In": "Desabilita inicio de sesión directo",
    "Upload Image": "Cargar imagen",
    "Enable SSO": "Habilita el \"Inicio de sesión único\"",
    "Select Background": "Seleccione un fondo",
    "SAML Name Attribute": "Atributo SAML de nombre",
    "openchartdoc": "Abrir documento",
    "Notification Center": "Centro de notificaciones",
    "Recently Opened Charts": "Organigramas abiertos reciéntemente",
    "Please Select Field": "Por favor seleccione un campo válido",
    "Edit Users": "Editar usuarios",
    "Open Existing": "Abrir existente",
    "Open In Editor": "Abrir en el editor",
    "Delete Sharepoint": "Eliminar punto compartido",
    "Enum Table": "Tabla enumerada",
    "openbackground": "Abrir fondo",
    "About manualchart": "Ingresar mi data manualmente",
    "Open Editor": "Abrir editor",
    "signInDisabled": "El inicio de sesión directo ha sido desabilitado",
    "About Background Editor": "Configure sus fondos",
    "SAML Email Attribute": "Atributo SAML de correo electrónico",
    "Plan Builder Directions": "Nombre su plan, elija un punto de partida, y empiece a planear",
    "Chart Builder Directions": "Elija un punto de partida y haga clic en construir para crear un organigrama",
    "Select Build Chart Level": "¿Cuántos niveles debajo de este empleado le gustaría incluir?",
    "No Subject": "No hay tema",
    "ssodisableinfotext": "El inicio de sesión único no puede ser desabilitado si el inicio de sesión directo está desabilitado",
    "addfolder": "Agregar carpeta",
    "single unread": "Message no leído",
    "Open Background": "Abrir fondo",
    "Load Mapping": "Cargar mapeo",
    "Chart Builder Info": "Use sus datos base como punto de partida para crear un organigrama personalizado",
    "Conflict": "Conflicto detectado",
    "I Have an Excel File": "Tengo un archivo de Excel",
    "Select Build Position Level": "¿Cuántos niveles debajo de esta posición le gustaría incluir?",
    "Include Background": "Incluir fondo",
    "Change AutoText": "Cambiar texto automático",
    "notvalidated": "No ha sido validado",
    "Where is your data": "Dónde está sus datos de empleado",
    "main SAML assertion": "Aserción SAML principal",
    "BackgroundEditorQuickLink": "Editor de fondo",
    "API Connection": "Conección API",
    "Background Name": "Nombre de fondo",
    "No Messages": "No hay mensajes",
    "About Account Settings": "Adminitra sus usuarios y la configuración de seguridad",
    "ssoenableinfotext": "Habilitar/Deshabilitar el inicio de sesión de los usuarios a través del IDP configurado",
    "Default Group": "Groupo predeterminado",
    "Employee PositionID": "ID de posición del empleado",
    "reviewmanualh": "Revisar la configuración del organigrama",
    "PositionID": "ID de posición",
    "Employee": "Empleado",
    "recnavprompt": "¿Te gustaría navegar al registro recién agregado?",
    "multiple unread": "Mensajes no leídos",
    "Unread": "No leído",
    "Unread Force Read Messages": "Tiene mensajes importantes sin leer que debe seleccionar antes de salir del centro de notificaciones",
    "Position Management": "Administración de posición",
    "Preexistingid": "Este ID ya existe en su plan",
    "SSO Deletion Warning": "Está a punto de eliminar esta configuración de inicio de sesión único. Por favor confirme que desea continuar.",
    "SSO Save Warning": "Esto dejará a la organización sin un inicio de sesión único activo. Por favor confirme que desea continuar.",
    "Loading Background Editor": "Cargando editor de fondo",
    "Max Char Limit Warning": "Advertencia de límite máximo de caracteres",
    "enterAttributeGroup": "Ingrese el atributo SAML para el grupo",
    "enterorgsize": "Ingrese la cantidad de registros que tiene en su organización y haga clic en siguiente",
    "Start From Connection": "Empieza desde la conexión",
    "selectfieldsh": "¿Cuáles campos de la data le gustaría incluir?",
    "ssodirectinfotext": "Habilitar/Deshabilitar que los usuarios inicien sesión directamente",
    "selectmapping": "Ayúdenos a entender sus datos",
    "Allow RW Users to Refresh Master Charts": "Permitir que usuarios de rol read/write refresquen el organigrama maestro",
    "Reference Table": "Tabla de referencia",
    "Yesterday": "Ayer",
    "Set the group new users are created in by default.": "Establecer el grupo predeterminado para nuevos usuarios.",
    "Picklist": "Lista de selección",
    "No profiles defined": "No hay perfiles definidos",
    "Welcome Message 2": "Necesitaremos data para construir su organigrama",
    "Build Employees Chart": "¿Cuál empleado le gustaría ver como cuadro superior en este organigrama?",
    "About flatfile": "Usar data de un documento en formato Excel or CSV",
    "pinobj": "Fijar posición",
    "Background Editor": "Editor de fondo",
    "Value Mismatch": "Inconsistencia de valores",
    "sloinfotext": "Cerrar automáticamente la sesión de los usuarios de IDP cuando se cierra la aplicación.",
    "About View Manager": "Configure sus vistas y diseños de cuadro",
    "Synthesize positional data from employees": "Sintetizar los datos de posición de los empleados",
    "What View To Apply": "¿Qué vista le gustaría aplicar?",
    "generateSPMetadata": "Metadata SAML del prov. Serv.",
    "System views cannot be modified": "Vistas del sistema no pueden ser modificadas.",
    "Custom Filter": "Filtros personalizados",
    "Sign-In Disabled Warning": "¿Está seguro de que desea deshabilitar inicio de sesión directo? Usuarios SÓLO podrán iniciar sesión a través de inicio de sesión único.",
    "Default Background Info": "Pongamos todo en marcha con un fondo prediseñado",
    "Older": "Más viejo",
    "Setting Up Background": "Configuración de fondo",
    "Positions": "Posiciones",
    "enumeratedtableprops": "Editor de tablas enumeradas",
    "ManualBlank": "Dejar en blanco para un organigrama de cuatro personas",
    "Contact": "Contrato",
    "Chart Builder Position Directions": "Elija un punto de partida y haga clic en construir para crear un organigrama",
    "Page Breaks": "Interrupción de páginas",
    "I have no data": "Empezar de cero",
    "Create Field Map": "Crear mapa de campos",
    "NameID Handling": "Manejo de identificación de nombre",
    "Recommended": "Recomendado",
    "Disable SSO": "Deshabilitar inicio de sesión único",
    "Browse Files": "Navegar archivos",
    "Excel File": "Archivo Excel",
    "No Content": "Sin contenido",
    "DeleteSharepointConfig": "¿Está seguro de que desea eliminar permanentemente la configuración de punto compartido? Esta acción no se puede deshacer",
    "Open a chart to begin editing View rules": "Abra un organigrama para empezar a editar las reglas de vista",
    "nochartsforplanning": "No hay organigrama configurado. Por favor, primero haga clic aquí para configurar un organigrama",
    "Data Fields": "Campos de data",
    "View successfully imported. Be sure to save the changes to your shared views and box styles libraries.": "Vista importada exitosamente. Asegúrese de guardar los cambios en sus vistas compartidas y librería de estilos de cuadro",
    "About Chart Settings": "Configure su conexión de API y su configuración de datos",
    "Turn On": "Encender",
    "Compensation": "Compensación",
    "lastvalidation": "Última validación",
    "Default Background": "Fondo estándar",
    "Find by username or email": "Buscar por nombre de usuario o correo electrónico",
    "Select Language": "Seleccione el idioma",
    "Flat File": "Archivo plano",
    "BreadCrumbs": "Migas de pan",
    "Build Employees Plan": "¿Qué empleado le gustaría en la parte superior de este plan?",
    "All Files": "Todos los archivos",
    "Sign-In Enabled Warning": "¿Está seguro de que desea habilitar el inicio de sesión directo? Los usuarios podrán iniciar sesión fuera de SSO.",
    "BackgroundEditorTools": "Herramientas",
    "Filters and Highlights": "Filtros & destacados",
    "Edit Metrics": "Editar métricas",
    "Character length cannot exceed": "La longitud del carácter no puede exceder",
    "Create New Background": "Crear nuevo fondo",
    "uploaddatafile": "Suba su archivo de datos",
    "Unhandled Validation": "No se pueden validar las credenciales en la aplicación. Verifique que las credenciales que ha ingresado sean correctas. Si la validación continúa fallando, comuníquese con el equipo de soporte si desea validar las credenciales.",
    "About BackgroundEditorQuickLink": "Cree y personaliza sus fondos",
    "Active Background": "Activar fondo",
    "SSO Deletion": "Eliminación de inicio de sesión único",
    "Inbox": "Bandeja de entrada",
    "Select Initial Import Method": "¿Cuál es el mejor lugar para obtener los datos de su organigrama?",
    "Select a message to read": "Seleccione un mensaje para leer",
    "Parent PositionID": "Parent positionID",
    "Reports": "Informes",
    "Doc Settings No Source": "Este documento no tiene fuente de datos. Use las herramientas del entorno de trabajo para gestionar los datos de la tabla.",
    "nofilefiltermatches": "archivo(s) actualmente oculto(s). Para ver estos archivos, cambie el filtro de archivos en la parte inferior derecha.",
    "Code": "Código",
    "Chart Document Linked To Master Chart": "Este documento de tabla está vinculado a una tabla maestra.",
    "Images": "Imágenes",
    "Resolve conflict": "Resolver el conflicto más tarde",
    "Enabled": "Activado",
    "View Unsaved Charts": "Hemos recuperado una o más tablas no guardados. ¿Le gustaría verlas ahora?",
    "mfaStep2Long": "Abrir la aplicación de autenticación y, a continuación, toque el icono '+'.\n\nEscanee la imagen de la derecha, utilizando la cámara de su dispositivo.",
    "Chart Document": "Documento de tabla",
    "API Timeout Message": "Debido a la naturaleza de su integración con la API, esta actualización tardará mucho más de lo habitual. Aunque no podrá realizar actualizaciones sobre pedido en la aplicación, podremos actualizar sus datos durante su actualización automática programada. Puede encontrar los detalles de su actualización en ajustes de tabla > actualización",
    "Chain of Command Levels": "Niveles de la cadena de mando por arriba de la tabla",
    "InsertedBreak": "Descomponer los ingresados bajo",
    "Resolve": "Resolver",
    "Presentation Support": "Esta opción de presentación no se ofrece aún.",
    "Not Configured": "No configurado",
    "GroupNameError": "Error en el nombre del grupo",
    "Children": "Hijas",
    "invalidemail": "Dirección de correo electrónico inválida",
    "Presentation Not Available": "Presentación no disponible",
    "Plan Open Failure": "No se puede abrir el plan. Sus permisos no le permiten acceder a este plan o a los campos requeridos dentro del plan. Póngase en contacto con el administrador del sistema.",
    "multifactorauth": "Autorización multi factor",
    "Doc Inherits from Master Chart": "Este documento hereda la configuración de una tabla maestra.",
    "MFA Enabled": "La MFA está actualmente activada y se requiere al iniciar la sesión. Para desactivar esta medida de seguridad o volver a configurarla con un nuevo código, puede hacer clic en el botón de reinicio que aparece a continuación.",
    "Required & Not Configured": "Requerido y no configurado",
    "Setting Controlled by Master Chart": "Esta configuración del documento está controlada por su tabla maestra. Los cambios en esta sección deberán hacerse en el tabla maestra de origen en la configuración de tablas.",
    "disableMFAWarning": "Se ha deshabilitado la MFA con éxito",
    "See Less Fields": "Ver menos campos",
    "Revert Change and Resolve": "Revertir cambios y resolver",
    "RemovedBreak": "Desglosar los eliminados bajo",
    "Point In Time Chart": "Tabla de punto en el tiempo",
    "API Timeout": "Tiempo de la API agotado",
    "switch view prompt": "Haga clic aquí para cambiar los conjuntos de vistas",
    "Append Remove Duplicates": "Se han encontrado entradas duplicadas. ¿Desea consolidar sus entradas? Nota: Esta acción no se puede revertir?",
    "Top of Chart": "Tope de tabla",
    "mfaConfirmCode": "Ingrese código de confirmación",
    "Review Later": "Revisar luego",
    "Review Unsaved Charts": "Revisar tablas no guardadas",
    "Group Name Exists": "Por favor, use un nombre único para su filtro por grupo",
    "Configured": "Configurado",
    "wrongextension2": "Por favor, seleccione uno válido",
    "mfaStep1LongPre": "Descargue e instale una aplicación de autenticación en su teléfono o tableta. Las aplicaciones admitidas son",
    "Record Info": "Información de registro",
    "QRCodeGen": "Código QR del autenticador generado correctamente.",
    "mfaAuthenticator": "Autentificador activo",
    "Record Not Found": "Registro no encontrado",
    "step3": "Paso 3",
    "MFA Required": "El administrador de su cuenta debe realizar la MFA. Si necesita ayuda con esta función, contacte al administrador de su cuenta para que le ayude.",
    "wrongextension": "Tipo de archivo no válido seleccionado para el modo actual.",
    "Levels Below Topbox": "Niveles por debajo de el cuadro superior",
    "Invalid File Type": "Tipo de archivo no válido",
    "invalidCode": "Código de confirmación inválido.",
    "agupdatedbody": "Los usuarios con este grupo aplicado no cambiarán de rol hasta el siguiente inicio de sesión",
    "mfaStep3Long": "Una vez escaneado el código QR anterior, introduzca el código de verificación de 6 dígitos generado por la aplicación.",
    "confirmationCode": "Introduzca el código de confirmación de su aplicación de autenticación.",
    "validCode": "Ha activado correctamente la MFA.",
    "step1": "Paso 1",
    "No Changes Detected": "No se han detectado cambios.",
    "mfaValidateFirst": "La MFA no se habilitará hasta que sea validada. 1. Por favor, descargue una aplicación de autenticación si aún no lo ha hecho. 2. Escanee el código QR. 3. Confirme el código QR.",
    "mfaNotRequired": "Desactivar la MFA requerida permitirá a los usuarios acceder a su organización sin necesidad de habilitar y usar un método de MFA. Los usuarios con MFA activada podrán seguir utilizándola, aunque ahora tendrán la opción de desactivarla.\n\n¿Está seguro de que desea continuar?",
    "Page properties": "Propiedades de página",
    "Resolve Conflict Later": "Resolver el conflicto más tarde",
    "No Date Found": "No se ha encontrado ninguna fecha",
    "Bypassed": "Ignorado",
    "Create Group": "Crear grupo",
    "switch views": "Cambiar vista",
    "Plan Access Denied": "Acceso denegado al plan",
    "My Highlights": "Mis destacados",
    "ReplaceOrAdd": "La tabla de anexos ya tiene registros. ¿Desea sustituir todos los registros o añadir datos a los registros existentes? Si desea cancelar la carga, cierre esta ventana.",
    "mfaRequired": "Se requiere MFA para iniciar sesión",
    "Plan Load Record Failure": "Este registro ya no existe en su fuente de datos del plan.",
    "My Filters": "Mis filtros",
    "Recover Charts": "Recuperar tablas",
    "Import From": "Importar desde",
    "Child": "Hija",
    "ExistingAppend": "Ya existe una entrada anexa. Haga clic en SÍ para ser redirigido a la entrada anexa existente.",
    "mfaStatus": "Estado de MFA",
    "ManyExistingAppends": "Ya existen muchas entradas anexas. Haga clic en SÍ para ser redirigido a la lista de entradas anexas existentes.",
    "Show All": "Mostrar todo",
    "step2": "Paso 2",
    "Page Size & Margins": "Tamaño de página y márgenes",
    "backgroundHotLink": "Modificar fondos disponibles",
    "overrideMFA": "Anular MFA",
    "See More Fields": "Ver más campos",
    "groupnamemsg": "Necesita al menos 3 caracteres para el nombre del grupo.",
    "Flat Files": "Archivos planos",
    "mfaAdminPreReq": "Debe configurar la MFA para su usuario antes de poder requerir el inicio de sesión MFA para su cuenta. Haga clic en configurar para configurar su MFA ahora.",
    "mfaStep1Short": "Descargar la aplicación",
    "Changes": "Cambios",
    "Confirm Resolve Conflict": "Confirmar cambios y resolver",
    "Advanced": "Avanzado",
    "reqMFAWarning": "Todos sus usuarios tienen MFA habilitado y seguirán pudiendo iniciar sesión después de que usted requiera MFA. Haga clic en sí para exigir a los futuros usuarios que configuren la MFA.",
    "Keep MFA Requirement On": "Mantener activado el requisito de MFA",
    "Disable MFA Requirement": "Deshabilitar el requerimiento de MFA",
    "resetAuth": "Reiniciar el autentificador",
    "Authenticator": "Autenticador",
    "Assistants": "Asistentes",
    "Specify Top of Chart": "Especifique la parte superior de la tabla",
    "Levels Below Top of Chart": "Niveles por debajo del tope de la tabla",
    "Disconnect": "Desconectar de la jerarquía",
    "Presentation Support Link": "Si desea acceder a esta función lo antes posible, póngase en contacto con el servicio de asistencia.",
    "RenamedBreak": "Nombre de subtabla cambiado a",
    "viewsets": "Ver conjuntos",
    "clicktoconfigure": "Click aquí para configurar",
    "mfaInactivePost": "Los usuarios no han configurado la MFA y no podrán iniciar sesión. ¿Quiere exigir la MFA, de todos modos?",
    "Standard Field": "Campo estándar",
    "Unsaved Charts": "Tablas no guardadas",
    "mfaStep2Short": "Escanear este código de barras",
    "mfaSetting": "Configurar MFA",
    "invalidConfirmationCode": "Código de confirmación inválido.",
    "mfaVerify": "Verificar código y activar",
    "directoryHotLink": "Modificar ajustes del directorio",
    "Configure link user": "Configurar enlace de usuario",
    "Edit View": "Editar vista",
    "No Changed Fields": "No se han cambiado campos. Edite un campo en el registro para crear un nuevo cambio.",
    "Edit Table": "Editar tabla",
    "Formula name cannot contain a period": "El nombre de la fórmula no puede contener un punto",
    "Create filters that can be shared with other users": "Filtros compartidos con otros usuarios",
    "Create rule condition": "Crear condición de regla",
    "Search for": "Buscar",
    "Add folder": "Añadir carpeta",
    "Search folder": "Buscar carpeta",
    "Search specific folder": "Buscar en {folder}",
    "Search Charts": "Buscar organigramas",
    "Confirm password": "Confirmar contraseña",
    "Create new record": "Crear nuevo registro",
    "aTitle": "Título alternativo",
    "Include clickable navigation arrows connecting pages of the chart. May not be useful when physically printing": "Incluir flechas de navegación clicables que conecten las páginas del organigrama. Puede no ser útil al imprimir físicamente",
    "Source chart": "Organigrama fuente",
    "What data fields will be used in this plan?": "¿Qué campos de datos se usarán en este plan?",
    "Save now": "Guardar ahora",
    "No background": "Sin fondo",
    "InvalidName": "Nombre inválido",
    "Auto-sync": "Sincronización auto.",
    "Please check the following fields": "¡Revisa los siguientes campos!",
    "Modify UI Profile": "Modificar perfil de UI",
    "Enter email address(es) for notification": "Ingrese la(s) dirección(es) de correo electrónico para notificaciones",
    "Conditional Definition": "Definición condicional",
    "Unsaved": "No guard.",
    "Pagination changes": "Cambios de paginación",
    "Show search fields": "Mostrar campos de búsqueda",
    "Toggle fields to include": "Alternar campos a incluir",
    "viewnotfound": "Vista no encontrada",
    "Chart information": "Información del organigrama",
    "Click add rule to start conditionally formatting your chart": "Haga clic en añadir regla para comenzar a dar formato condicional a su organigrama",
    "Turn off MFA": "Desactivar MFA",
    "Reports filter": "Filtrar informes por el organigrama base al que están vinculados.",
    "replacefilesnonew": "Haga clic en \"Reemplazar archivos existentes\" para actualizar los archivos existentes en este directorio o en \"Cancelar\" para cancelar la carga.",
    "Update the automated rules driving chart presentation.": "Actualizar las reglas automatizadas que impulsan la presentación del organigrama.",
    "Enter formula rule": "Ingrese la regla de fórmula aquí:",
    "Plan changes": "Cambios en el plan",
    "Do you want to resume work in your last open report?": "¿Desea reanudar el trabajo en su último informe abierto?",
    "Picklist options": "Opciones de lista de selección",
    "Picklist type": "Tipo de lista de selección",
    "Enter email address(es) for auto-export": "Ingrese la(s) dirección(es) de correo electrónico para la exportación automática",
    "Delete Table": "Eliminar tabla",
    "Create group mapping": "Crear mapeo de grupo",
    "Hierarchy": "Jerarquía",
    "Select Build Chart Level Directions": "Elija el número de niveles para cambiar la profundidad de su organigrama",
    "deleterows": "Eliminar filas",
    "Box layout editor": "Editor de diseño de cuadro",
    "Include a page at the end of the export with name and number": "Incluir una página al final de la exportación con el nombre de cada empleado y el número de página correspondiente",
    "autoassignwarningmessage": "Advertencia: Esta función se aplica globalmente a su cuenta. Si habilita esta función sin la configuración adecuada, puede bloquearse a sí mismo y a todos sus usuarios de acceder a orgChart.\r\n\r\n¿Está seguro de que desea proceder?",
    "Use 24 hour clock": "Usar reloj de 24 horas",
    "Open Last Report": "Abrir último informe",
    "Custom Chart": "Organigrama personalizado",
    "Discard": "Descartar",
    "Align Objects Top": "Alinear objetos arriba",
    "Enter confirmation code": "Ingrese el código de confirmación",
    "Reset Charts": "Restablecer organigramas",
    "Date Time Format": "Formato de fecha y hora",
    "You must select a UI profile": "Debe seleccionar un perfil de UI",
    "This plan has changes that are no longer valid": "Este plan tiene cambios que ya no son válidos",
    "Level up": "Subir de nivel",
    "Saved": "Guardado",
    "Invalid Date": "Fecha inválida",
    "insertcolleft": "Insertar 1 columna a la izquierda",
    "Position file": "Posicionar archivo",
    "Basic info": "Información básica",
    "Level down": "Bajar de nivel",
    "Rule comparison": "Comparación de reglas",
    "Create new reports of your organization, or run saved reports": "Crear nuevos informes de su organización o ejecutar informes guardados",
    "Custom SLO Endpoint": "Punto final de SLO personalizado",
    "Username": "Nombre de usuario",
    "Choose file": "Elegir archivo",
    "Create checkpoint": "Crear punto de control",
    "Finish editing your view to update these rules": "Termine de editar su vista para actualizar estas reglas",
    "Add highlights": "Añadir destacados",
    "Resolve later": "Resolver más tarde",
    "Select sort field": "Seleccionar campo de ordenación",
    "Remove value from field": "Eliminar valor del campo",
    "minsubbreaksinfo": "Especifique el número mínimo de cuadros requeridos para insertar una división en el suborganigrama. Esta opción ayuda a reducir el número de páginas en el organigrama generado.",
    "Allowed views": "Vistas permitidas",
    "Enter prefix": "Ingrese prefijo",
    "Add field": "Añadir campo",
    "Chart details": "Detalles del organigrama",
    "Top of chart": "Parte superior del organigrama",
    "Show plans not shared with me": "Mostrar planes no compartidos conmigo",
    "topRight": "Arriba derecha",
    "Notifications": "Notificaciones",
    "Edit Record": "Editar registro",
    "Would you like to apply layout changes": "¿Le gustaría aplicar los cambios del diseño de cuadro?",
    "Delete formula": "Eliminar fórmula",
    "Approved positions file": "Archivo de posiciones aprobadas",
    "Automatically save changes": "Guardar cambios automáticamente",
    "Layout Editor": "Editor de diseño",
    "Show conflicts only": "Mostrar solo conflictos",
    "Invalid name": "Nombre inválido. No puede incluir",
    "Minimum length is 2 characters": "La longitud mínima es de 2 caracteres",
    "passcommon": "La contraseña es demasiado común. Por favor, intente con una contraseña diferente",
    "Save background alert": "¿Le gustaría guardar una copia de su fondo actual para que pueda ser utilizado por otros organigramas?",
    "Background changes will be saved as a new background": "Los cambios de fondo se guardarán como un nuevo fondo",
    "Add more": "Añadir más",
    "Find changes": "Buscar cambios",
    "Cannot edit rule background": "No se puede modificar el fondo mientras está siendo aplicado por una vista activa.",
    "Finish editing layout": "Terminar de editar el diseño",
    "Filter by status": "Filtrar por estado",
    "Name cannot be blank": "El nombre no puede estar en blanco",
    "Insert break": "Insertar salto",
    "Insert field": "Insertar campo",
    "Language": "Idioma",
    "Specify endpoint": "Especificar punto final",
    "Treat UTC 0 as Local Browser Time": "Tratar UTC 0 como la hora local del navegador",
    "View library": "Ver biblioteca",
    "sourcenotfound": "Fuente no encontrada",
    "Copy link": "Copiar enlace",
    "Include elements on the background, such as logos, legends, tables, and page numbers": "Incluir elementos en el fondo, como logotipos, leyendas, tablas y números de página",
    "Click here to select data source": "Haga clic aquí para seleccionar la fuente de datos",
    "Manage available views": "Administrar vistas disponibles",
    "Configure a flag and label for the selected boxes": "Configurar una bandera y etiqueta para los cuadros seleccionados",
    "Create report": "Crear informe",
    "Record": "Registro",
    "Dynamic formula": "Fórmula dinámica",
    "Reset view": "Restablecer vista",
    "Save copy": "Guardar copia",
    "automaticarchive": "Archivo automático",
    "No top box specified": "No se especificó ninguna cuadro superior",
    "Destination": "Destino",
    "Find branches": "Buscar sucursales",
    "Default levels": "Niveles predeterminados",
    "Configure group field mapping": "Configurar mapeo de campos de grupo",
    "Specify page size": "Especificar tamaño de página",
    "No highlights have been added": "No se han añadido destacados",
    "Maps to": "Mapee a",
    "Background Settings": "Configuración de fondo",
    "No plan description": "Sin descripción del plan",
    "Save and run": "Guard. y ejec.",
    "Select organization": "Seleccionar organización",
    "There are no reference tables": "No hay tablas de referencia",
    "Open report explorer": "Abrir explorador de informes",
    "Site": "Sitio",
    "Add data source": "Agregar fuente de datos",
    "Change data source": "Cambiar fuente de datos",
    "Self level info": "El valor utilizado es el registro del organigrama del usuario actual",
    "Inserted subchart break": "Inserción de ruptura en el suborganigrama",
    "Resume last open report": "¿Reanudar el último informe abierto?",
    "Powerpoint document": "Documento de PowerPoint",
    "Create rule comparison": "Crear comparación de reglas",
    "Apply filter": "Aplicar filtro",
    "Main data": "Datos principales",
    "Which boxes should this rule apply to?": "¿A qué cuadros se debe aplicar esta regla?",
    "Your chart has an automatic sort configuration applied": "Su organigrama tiene una configuración de ordenación automática aplicada. Para ordenar manualmente sus cuadros, elimine la configuración de ordenación automática en la pestaña de ordenación de su barra lateral.",
    "Selected field label": "Etiqueta del campo seleccionado",
    "Select chart to configure": "Seleccionar organigrama para configurar",
    "OR": "O",
    "Deselect All": "Deseleccionar todo",
    "reqFieldNotMapped": "Por favor, asigna el campo requerido.",
    "Field value criteria": "Criterios de valor del campo",
    "Remove data source": "Eliminar fuente de datos",
    "Use OAuth2.0 Authentication": "Usar autenticación OAuth2.0",
    "Edit formula": "Editar fórmula",
    "Chart Explorer": "Explorador de organigramas",
    "Loading archive": "Cargando archivo",
    "Subchart name field": "Campo de nombre de suborganigrama",
    "LinkUserNotSelectedError": "Por favor, seleccione un usuario de enlace",
    "Notify people": "Notificar a las personas",
    "Creating Archive": "Creando archivo",
    "Unable to find topbox": "No se pudo encontrar el cuadro principal",
    "Select a new topbox": "Seleccionar un nuevo cuadro principal",
    "recordField": "Campo de registro",
    "Privacy policy": "Política de privacidad",
    "Selected background": "Fondo seleccionado",
    "Saved filters": "Filtros guardados",
    "Delete element": "Eliminar elemento",
    "Create New Table": "Crear nueva tabla",
    "CreateFieldMap": "Crear mapa de campos",
    "Show less information": "Mostrar menos información",
    "Valid Email Address Required": "Se requiere una dirección de correo electrónico válida",
    "Return using": "Volver usando",
    "Branch level security": "Seguridad a nivel de sucursal",
    "Create Override": "Crear anulación",
    "clearformat": "Borrar formato",
    "ChangeAppendInfo": "Actualizar información de registro",
    "ComplexRule": "Regla compleja",
    "Create new conditional rule": "Cree sus propias condiciones para definir los criterios de una regla compleja",
    "Enter formula name": "Ingrese el nombre de la fórmula",
    "Add field value to rule criteria": "Añadir valor del campo a los criterios de la regla",
    "Refresh from source": "Actualizar desde la fuente",
    "passincnum": "Contener al menos un número",
    "Select which charts should use this background by default": "Seleccione qué organigramas deben usar este fondo por defecto",
    "datagroupmapping": "Mapeo de grupo de datos",
    "Value mismatches": "Desajustes de valor",
    "Duplicate view": "Vista duplicada",
    "Create custom chart": "Crear organigrama personalizado",
    "Apply pagination settings?": "¿Aplicar la configuración de paginación?",
    "Start breaks at": "Iniciar pausas en",
    "View rules": "Reglas de vista",
    "OptFieldMap": "Mapeo de campos opcional",
    "Label and value": "Etiqueta y valor",
    "Default background": "Fondo predeterminado",
    "Changes will be applied next data refresh": "Los cambios se aplicarán después de la próxima actualización de datos",
    "Margin": "Margen",
    "Edit Whitelist Domain": "Editar dominio de la lista blanca",
    "Save layout changes": "Guardar cambios de diseño",
    "Report owner": "Propietario del informe",
    "Saving": "Guardando",
    "Download this screen": "Descargar esta pantalla",
    "Clear search filters": "Borrar filtros de búsqueda",
    "Some sources require additional photo configuration in order to pull photos": "Algunas fuentes requieren configuración adicional de fotos para extraer fotos",
    "nosubchartupdate": "El panel de suborganigramas no se actualizará hasta que se realice una actualización.",
    "Set picklist": "Configurar lista de selección",
    "Choose which boxes (some boxes or all boxes) for this rule to target": "Elija qué cuadros (algunas cuadros o todas los cuadros) deben ser el objetivo de esta regla",
    "Select formula field": "Seleccionar campo de fórmula",
    "No Name": "Sin nombre",
    "Click + to add an operation": "Haga clic en + para agregar una operación",
    "Configure field mapping": "Configurar mapeo de campos",
    "Display Name": "Nombre para mostrar",
    "No rule conditions": "Sin condiciones de regla. Haga clic aquí para agregar.",
    "Currently used seats": "Asientos actualmente utilizados",
    "Create new user": "Crear nuevo usuario",
    "record": "registro",
    "Create highlights that can be shared with other users": "Destacados compartidos con otros usuarios",
    "Report explorer": "Explorador de informes",
    "Create formula": "Crear fórmula",
    "Function": "Función",
    "Report Blank": "El nombre del informe no puede estar en blanco.",
    "Mouse controls": "Controles del mouse",
    "Fields and formulas": "Campos y fórmulas",
    "Create new group": "Crear nuevo grupo",
    "Report information": "Información del informe",
    "Subchart sorting": "Ordenar suborganigrama",
    "Export a higher quality image to embed into a Word document or PowerPoint presentation": "Exportar una imagen de mayor calidad para incrustar en un documento de word o presentación de PowerPoint",
    "Data Source Details Unavailable": "Algunos detalles del organigrama pueden no estar disponibles para documentos de organigramas antiguos.",
    "AutoPopulateViewsFailure": "Límite máximo de vistas alcanzado (10) para este organigrama. Por favor, elimine una vista antes de agregar otra.",
    "Distribute Space Vertical": "Distribuir espacio vertical",
    "deletefield": "Campo",
    "Validate": "Validar",
    "Reports to": "Reporta a",
    "LoadMap": "Cargar mapeo de campos",
    "Enable automatic clean-up": "Habilitar limpieza automática",
    "Create new filter": "Crear nuevo filtro",
    "bypasstemplatelistwarning": "Los usuarios con permiso para editar vistas y estilos de cuadros podrán ver y editar todas las vistas compartidas en la cuenta.",
    "Apply to all subcharts": "Aplicar a todos los suborganigramas",
    "Apply to chart": "Aplicar al organigrama",
    "Look up using": "Buscar usando",
    "Filter by chart": "Filtrar por organigrama",
    "Requirement": "Requisito",
    "Value only": "Solo valor",
    "Revert All Changes": "¿Revertir todos los cambios?",
    "Run": "Ejecutar",
    "Line weight": "Peso de línea",
    "More options view": "Ver más opciones",
    "Application details": "Detalles de la aplicación",
    "Select frequency": "Seleccione la frecuencia",
    "mergeall": "Combinar todo",
    "Match using": "Coincidir usando",
    "Set which formatting or style properties should apply to boxes that meet the criteria above": "Establezca qué propiedades de formato o estilo deben aplicarse a los cuadros que cumplan con los criterios anteriores",
    "Edit this chart to adjust the filter": "Edite este organigrama para ajustar el filtro",
    "Wrap text": "Ajustar texto",
    "Edit this custom chart": "Editar este organigrama personalizado",
    "Reporting": "Informes",
    "Append Tables": "Agregar tablas",
    "Exclude all": "Excluir todo",
    "passincupp": "Contener al menos un carácter en mayúscula",
    "lastarchive": "Último archivo",
    "maxboxlimiterr": "Ha superado el número máximo de cuadros permitidos en una sola página. Los administradores pueden actualizar este límite",
    "Filter behavior": "Comportamiento del filtro",
    "Manage access": "Gestionar acceso",
    "bottomLeft": "Inferior izquierda",
    "insertrowbelow": "Insertar 1 fila abajo",
    "Cell formatting": "Formato de celda",
    "Conflict detected": "Conflicto detectado",
    "Add value to field": "Agregar valor al campo",
    "autoassignwarningheader": "¿Activar asignación automática de grupo?",
    "Box height": "Altura de cuadro",
    "Tenant ID": "ID de inquilino",
    "Allowed highlights": "Resaltados permitidos",
    "Don't have an account?": "¿No tiene una cuenta?",
    "fieldFormatWarning": "Las reglas solo pueden aplicar un cambio de formato de campo a la vez. Cree reglas de organigrama adicionales para aplicar más cambios de formato de campo a su organigrama",
    "Plans": "Planes",
    "Target field": "Campo objetivo",
    "Chart background": "Fondo del organigrama",
    "Field lookup": "Búsqueda de campo",
    "Rule definition": "Definición de reglas",
    "Ensure all boxes on each page are identically sized. This generally means boxes will be smaller than usual to accomodate large pages": "Asegúrese de que todos los cuadros en cada página sean del mismo tamaño. Esto generalmente significa que los cuadros serán más pequeños de lo habitual para acomodar páginas grandes",
    "topLeft": "Superior izquierda",
    "Available views": "Vistas disponibles",
    "Elements": "Elementos",
    "App preferences": "Preferencias de la aplicación",
    "Select fields included in delta report": "Seleccione los campos incluidos en el informe delta",
    "Photos": "Fotos",
    "Top box of chart": "Cuadro superior del organigrama",
    "Use approved positions table": "Usar tabla de posiciones aprobadas",
    "Schedule Chart Refresh": "Programar actualización del organigrama",
    "Open chart explorer": "Abrir explorador de organigramas",
    "Please wait": "Por favor, espere",
    "Shared users": "Usuarios compartidos",
    "Revert to source": "Revertir a la fuente",
    "Basic math operation": "Operación matemática básica",
    "Date from": "Desde la fecha",
    "Choose date": "Elegir fecha",
    "Unable to sort": "No se puede ordenar",
    "Create metrics": "Crear métricas",
    "Use existing background": "Usar fondo existente",
    "Select value": "Seleccionar valor",
    "Separator": "Separador",
    "Enter Target Value": "Ingresar valor objetivo",
    "Move element": "Mover elemento",
    "Revert to": "Revertir a",
    "Formatting changes": "Cambios de formato",
    "after": "después",
    "Date to": "Hasta la fecha",
    "Cannot change background. This view is applying a rule driven background.": "No se puede cambiar el fondo. Esta vista está aplicando un fondo determinado por una regla.",
    "Use tree style for singles": "Usar estilo de árbol para solteros",
    "Treat value as": "Tratar valor como",
    "Value comparison": "Comparación de valores",
    "Branch level info": "El nivel de rama verificará si un registro está presente dentro de la rama del usuario actual",
    "Sign up": "Registrarse",
    "Titles": "Títulos",
    "New plan": "Nuevo plan",
    "Disable MFA requirement": "Deshabilitar requisito de MFA",
    "Create custom rule": "Crear regla personalizada",
    "Contact plan owner to add additional fields": "Contactar al propietario del plan para agregar campos adicionales",
    "Use (Legacy) API Key": "Usar clave API (antigua)",
    "White": "Blanco",
    "Enable MFA requirement": "Habilitar requisito de MFA",
    "Target value": "Valor objetivo",
    "Recalculating": "Recalculando",
    "Link copied": "Enlace copiado al portapapeles",
    "See Reports": "Ver informes",
    "Aux details": "Agregar relaciones de reporte auxiliares que existen en sus datos",
    "Vertical align": "Alinear verticalmente",
    "What would you like to do with this record": "¿Qué le gustaría hacer con este registro?",
    "Field Label": "Etiqueta del campo",
    "Use Table": "Usar tabla",
    "bottomRight": "Inferior derecha",
    "Set the top box and add co-heads": "Establecer el cuadro superior y agregar co-jefes",
    "Preferred Last": "Último preferido",
    "Default mode": "Modo predeterminado",
    "Add custom gradient": "Agregar gradiente personalizado",
    "Seat limit": "Límite de asientos",
    "Make a copy": "Hacer una copia",
    "Download report": "Descargar informe",
    "Max box limit for single page": "Límite máximo de cuadros por página",
    "disconnected record": "registro desconectado",
    "Disconnected": "Desconectado",
    "Delimiter": "Delimitador",
    "Save changes to filter": "Guardar cambios en el filtro",
    "Constrained": "Restringido",
    "Upload file": "Subir archivo",
    "Continue Reporting": "Continuar informando",
    "Log in to your": "Inicie sesión en su",
    "OrgChart account": "cuenta de {gAppName}",
    "Edit import filter": "Editar filtro de importación",
    "disconnected records": "registros desconectados",
    "Enter break character": "Ingresar carácter de interrupción",
    "Conditions": "Condiciones",
    "Create dynamic formula": "Crear fórmula dinámica",
    "Refine your search": "Refinar su búsqueda",
    "IAT endpoint": "Punto final de IAT",
    "Enter postfix": "Ingresar sufijo",
    "mergeField": "Combinar campo",
    "deletevalues": "Valores",
    "Choose operation": "Elegir operación",
    "reqFieldsNotMapped": "No se puede actualizar hasta que todos los campos requeridos estén mapeados.",
    "Data sync automatic": "Los datos se sincronizan automáticamente",
    "Branch pruning": "Poda de ramas",
    "Clear all": "Borrar todo",
    "Time": "Hora",
    "Revert all changes to": "Revertir todos los cambios a",
    "Confirm field revert": "¿Está seguro de que desea revertir este campo al valor de origen?",
    "No values have been added": "No se han añadido valores",
    "Model, filter, and build your own custom chart off the shared base chart": "Modele, filtre y cree su propio organigrama personalizado a partir del organigrama base compartido.",
    "Edit user": "Editar usuario",
    "Email MFA setup link": "Enviar enlace de configuración de MFA por correo electrónico",
    "Welcome back. Please enter your credentials.": "Bienvenido de nuevo. Por favor, ingrese sus credenciales.",
    "Advanced search fields": "Campos de búsqueda avanzada",
    "Delete criteria": "Eliminar criterio",
    "No Tables Exist": "No existen tablas. Haga clic aquí para gestionar todas las tablas.",
    "What should be done to those boxes?": "¿Qué se debe hacer con esos cuadros?",
    "Applied by": "Aplicado por",
    "Application Security": "Seguridad de la aplicación",
    "Append data": "Agregar datos",
    "Merge data": "Combinar datos",
    "Would you like to save layout changes": "¿Desea guardar los cambios de diseño? Todas las vistas que usan este estilo de cuadro se actualizarán.",
    "Would you like to save layout changes plural": "¿Desea guardar los cambios de diseño? Todas las vistas que usan estos estilos de cuadro se actualizarán.",
    "exportusers": "Exportar usuarios",
    "Finish editing your chart to update these rules": "Termine de editar su organigrama para actualizar estas reglas",
    "Include terminated employees": "Incluir empleados terminados",
    "mfaActive": "La autenticación multifactor está activa",
    "Select format": "Seleccionar formato",
    "Included fields": "Campos incluidos",
    "Allowed filters": "Filtros permitidos",
    "Renamed Subchart": "Suborganigrama renombrado",
    "Add sort key": "Agregar criterio de ordenación",
    "All changes will be lost": "Se perderán todos los cambios",
    "This chart only": "Solo este organigrama",
    "Last run": "Última ejecución",
    "Active on leave": "Activo en permiso",
    "Currently used boxes": "Cuadros actualmente usados",
    "List options": "Opciones de lista",
    "Removed subchart break": "Interrupción de suborganigrama eliminada",
    "level": "nivel",
    "Please choose how you want background changes to be saved": "Por favor, elija cómo desea guardar los cambios de fondo",
    "deltareportconfiguration": "Configuración del informe delta",
    "No chart name": "Sin nombre de organigrama",
    "Name your background": "Nombre su fondo",
    "fullaccess1": "Acceso completo + rol de lectura/escritura",
    "Only existing OrgChart users can access this link": "Solo los usuarios existentes de OrgChart pueden acceder a este enlace",
    "You must select a role": "Debe seleccionar un rol",
    "Allowed folders": "Carpetas permitidas",
    "MFA Setup": "Configuración de MFA",
    "Link user": "Vincular usuario",
    "Invalid input": "Entrada no válida",
    "selectchart": "Seleccionar organigrama",
    "Data sync not automatic": "Los datos no se sincronizan automáticamente",
    "AuxRepMapping": "Mapeo de informes auxiliares",
    "Rename failure": "Fallo al renombrar",
    "Enumerated Table": "Tabla enumerada",
    "MFA status": "Estado de MFA",
    "DPR": "DPR",
    "No import filters have been added": "No se han añadido filtros de importación",
    "People with access": "Personas con acceso",
    "Include all": "Incluir todo",
    "insertrowabove": "Insertar 1 fila arriba",
    "Applied by view": "Aplicado por vista",
    "topMiddle": "Centro superior",
    "Enable auto-export": "Habilitar autoexportación",
    "Password must": "La contraseña debe",
    "Profile fields": "Campos del perfil",
    "Background changes will apply to all charts using this background": "Los cambios en el fondo se aplicarán a todos los organigramas que utilicen este fondo",
    "Background right spacing": "Ajustar el espacio desde el margen derecho",
    "is invalid value": "es un valor inválido",
    "Label only": "Solo etiqueta",
    "Create rule": "Crear regla",
    "Client ID": "ID de cliente",
    "Append data sources": "Añadir fuentes de datos",
    "Enter description": "Introducir descripción",
    "rowsecconditional": "Los campos se pueden ver cuando se cumplen todas las condiciones",
    "Changes will appear here": "Los cambios aparecerán aquí",
    "Currently Viewing": "Viendo actualmente",
    "Terms of service": "Términos de servicio",
    "Enter name here": "Introduzca el nombre aquí",
    "Dates": "Fechas",
    "IWizHeadsUp2": "Haga clic aquí para configurar los organigramas maestros.",
    "Notify on": "Notificar en",
    "Automatically sync with source": "Sincronizar automáticamente con la fuente",
    "Employee data updates hourly.":
      "Los datos de los empleados se actualizan cada hora. No hay actualización manual disponible. Solo las fuentes de datos añadidos y datos combinados pueden actualizarse a petición.",
    "Delete filter": "Eliminar filtro",
    "Delete filter?": "¿Eliminar filtro?",
    "Select background": "Seleccionar fondo",
    "Show Direct Reports": "Mostrar informes directos",
    "Revert to prior value": "Revertir al valor anterior",
    "Multi-Factor Authentication Settings": "Configuración de autenticación multifactor",
    "List": "Lista",
    "Open Report Explorer": "Abrir explorador de informes",
    "View manager": "Ver gerente",
    "DeleteAppendInfo": "Eliminar registro del organigrama",
    "Update existing record": "Actualizar registro existente",
    "Levels up": "Niveles hacia arriba",
    "Editing linked background": "Este fondo puede estar vinculado a otros organigramas.",
    "Custom chart filter": "Filtro de organigrama personalizado",
    "MoveAppendInfo": "Cambiar relación de informes",
    "Deleted under": "Eliminado bajo",
    "Rows": "Filas",
    "Add field value": "Añadir valor de campo",
    "No background applied": "Sin fondo aplicado",
    "Create new import filter": "Crear nuevo filtro de importación",
    "Include pre-defined system formulas, such as headcount and span of control": "Incluir fórmulas predefinidas del sistema, como número de empleados y alcance de control",
    "Accessibility Report": "Informe de accesibilidad",
    "accessibilityReportHelper": "Generar un libro de Excel plano, compatible con la Sección 508 y con lectores de pantalla",
    "Maximum 3 additional fields": "Máximo 3 campos adicionales",
    "accessibilityFieldCapReached": "Se alcanzó el máximo de 3 campos adicionales. Quite un campo para incluir otro.",
    "exportuserstip": "Exportar usuarios a archivo Excel",
    "at": "en",
    "Add rule": "Añadir regla",
    "fullaccess2": "Acceso completo + rol de administrador",
    "Save View Changes": "¿Desea guardar su vista actual antes de vincularla a un organigrama maestro?",
    "docMappingChanged": "El archivo que seleccionó puede tener una asignación diferente. Seleccione guardar y continuar para guardar los cambios actuales y configurar la asignación.",
    "ResetMap": "Restablecer asignación de campo",
    "Area under construction": "Área en construcción",
    "Border dash": "Guion de borde",
    "Use fields from a base chart within this background": "Usar campos de un organigrama base dentro de este fondo",
    "AutoPopulateFailure": "Error al vincular el contenido al organigrama maestro. Verifique los límites de configuración del organigrama e intente nuevamente.",
    "Select fields": "Seleccionar campos",
    "No reports": "Sin informes",
    "Recents": "Recientes",
    "Find report": "Buscar informe",
    "Field change history": "Historial de cambios de campo",
    "Show more information": "Mostrar más información",
    "Show more chart details": "Mostrás más detalles del organigrama",
    "changed to": "cambiado a",
    "changed from": "cambiado de",
    "multiple values": "múltiples valores",
    "Reassigned from": "Reasignado de",
    "Created date": "Fecha de creación",
    "No comments": "Sin comentarios",
    "Your user is not permitted to access this instance of OrgChart": "Su usuario no tiene permiso para acceder a esta instancia de OrgChart",
    "Name your chart before turning on auto save": "Por favor, nombre su organigrama personalizado antes de activar el guardado automático",
    "Filter out by type": "Filtrar por tipo",
    "replacefiles": "Haga clic en \"Reemplazar archivos existentes\" para actualizar los archivos existentes en este directorio o \"Omitir duplicados\" para agregar solo archivos nuevos.",
    "On leave": "En licencia",
    "Automatic delta report notifications": "Notificaciones automáticas de informes delta",
    "Click here to add additional fields": "Haga clic aquí para añadir campos adicionales",
    "No results found": "No se encontraron resultados",
    "Add filters": "Añadir filtros",
    "Border type": "Tipo de borde",
    "Moved under": "Movido bajo",
    "This is not normally required": "Esto normalmente no es necesario",
    "before": "antes",
    "Download entire chart": "Descargar todo el organigrama",
    "Base Charts": "Organigramas base",
    "Client secret": "Secreto del cliente",
    "Build Employees Chart Directions": "Elija una persona clave para representar la parte superior de su organigrama",
    "Enable anyways": "Habilitar de todos modos",
    "Enter full URL here": "Introduzca la URL completa aquí",
    "Resort boxes to save space": "Reorganizar cuadros para ahorrar espacio",
    "Create folder": "Crear carpeta",
    "Source data changes": "Cambios en los datos de origen",
    "No description": "Sin descripción",
    "beforeequal": "antes o en",
    "levels": "niveles",
    "Edit configuration": "Editar configuración",
    "Conflicting field format changes": "Cambios de formato de campo en conflicto",
    "Merge data sources": "Combinar fuentes de datos",
    "No additional fields": "No hay campos adicionales",
    "Save background": "Guardar fondo",
    "Directory result fields": "Campos de resultados del directorio",
    "Edit group": "Editar grupo",
    "Configure Data Source": "Configurar fuente de datos",
    "Custom Sign-Out URL": "Cerrar sesión en el sitio en lugar de volver a la página de inicio de sesión",
    "Box shadow": "Sombra de cuadro",
    "Select formula span": "Seleccionar rango de fórmula",
    "Knowledge base": "Base de conocimientos",
    "Background left spacing": "Ajustar el espacio desde el margen izquierdo",
    "No disconnected records": "No hay registros desconectados",
    "Share plan": "Compartir plan",
    "Support portal": "Portal de soporte",
    "Find users": "Buscar usuarios",
    "Search plans": "Buscar planes",
    "Create security profile": "Crear perfil de seguridad",
    "Index": "Índice",
    "customPlacement": "Colocación personalizada",
    "Finish editing": "Finalizar edición",
    "Name your chart": "Nombre su organigrama",
    "Unable to save additional fields": "No se pueden guardar campos adicionales",
    "Remove filtered records": "Eliminar registros filtrados",
    "Edit security profile": "Editar perfil de seguridad",
    "Viewing Chart": "Viendo organigrama",
    "Success and failure": "Éxito y fallo",
    "Set list": "Establecer lista",
    "Additional info": "Información adicional",
    "Chart Builder Filter": "¿Le gustaría aplicar filtros para enfocar su organigrama?",
    "Enter name": "Introduzca el nombre",
    "Revert to checkpoint": "Revertir al punto de control",
    "Line subgroup style": "Estilo de subgrupo de línea",
    "Overlay a region of color over boxes that match the criteria": "Superponer una región de color sobre los cuadros que cumplan con los criterios.",
    "More Details": "Más detalles",
    "passinclow": "Contener al menos un carácter en minúscula",
    "Text formatting": "Formato de texto",
    "Launch Settings": "Iniciar configuración",
    "OrgChart LLC. All rights reserved": "OrgChart LLC. Todos los derechos reservados",
    "Create from existing": "Crear desde existente",
    "bottomMiddle": "Centro inferior",
    "Chart type": "Tipo de organigrama",
    "No conditional formatting rules": "Sin reglas de formato condicional",
    "Save Background": "Guardar fondo",
    "Download this branch": "Descargar esta rama",
    "Page Number": "Número de página",
    "Document status": "Estado del documento",
    "Create highlight": "Crear resaltado",
    "Allowed values": "Valores permitidos",
    "No box style selected": "No se seleccionó estilo de cuadro",
    "Background changes will only be applied to this chart": "Los cambios en el fondo solo se aplicarán a este organigrama",
    "Anyone with access to the web page on which you embed this link can access OrgChart": "Cualquiera con acceso a la página web donde incruste este enlace puede acceder a OrgChart",
    "Border Weight": "Grosor del borde",
    "Select an operation to configure": "Seleccione una operación para configurar",
    "Save as new": "Guardar como nuevo",
    "replacefilenonew": "Haga clic en \"Reemplazar archivo existente\" para actualizar el archivo existente en este directorio o \"Cancelar\" para cancelar la carga.",
    "Choose field value": "Elegir valor de campo",
    "Filter by role": "Filtrar por rol",
    "Choose an archive to build off of or create a delta report between two dates": "Elija un archivo para construir a partir de él o cree un informe delta entre dos fechas",
    "Select data source": "Seleccionar fuente de datos",
    "Update existing": "Actualizar existente",
    "Download activity report": "Descargar informe de actividad",
    "fullaccess0": "Acceso completo + rol de solo lectura",
    "Import fields from": "Importar campos de",
    "Open file explorer": "Abrir explorador de archivos",
    "Moved from": "Movido desde",
    "Show all": "Mostrar todo",
    "Rename plan": "Renombrar plan",
    "No more changes to show": "No hay más cambios que mostrar",
    "boxlimitwar": "Tenga en cuenta que aumentar el límite puede afectar negativamente el rendimiento de la aplicación.",
    "insertcolright": "Insertar 1 columna a la derecha",
    "DynFormWarn": "Estas fórmulas no funcionarán como se espera para organigramas base o planes. Utilice fórmulas regulares en su lugar.",
    "Select a new value to resolve the conflict": "Seleccione un nuevo valor para resolver el conflicto",
    "All fields restricted": "Todos los campos restringidos",
    "Select comparison": "Seleccionar comparación",
    "afterequal": "después o en",
    "Anyone with this link can access OrgChart": "Cualquiera con este enlace puede acceder a OrgChart",
    "Levels down": "Niveles hacia abajo",
    "Level 2": "Nivel 2",
    "Edit filter": "Editar filtro",
    "New value": "Nuevo valor",
    "Mute filtered records": "Silenciar registros filtrados",
    "Apply layout changes": "Aplicar cambios de diseño",
    "Last ran report": "Último informe ejecutado",
    "Changes effective": "Cambios efectivos",
    "Include system calculations": "Incluir cálculos del sistema",
    "Launch chart": "Lanzar organigrama",
    "Org unit file": "Archivo de unidad organizativa",
    "Branch rule": "Regla de rama",
    "switch to shared views to create new views": "Cambiar a vistas compartidas para crear nuevas vistas",
    "BasicRule": "Regla básica",
    "Chart view": "Vista del organigrama",
    "Chart Builder Chart": "Constructor de organigramas",
    "Level 4": "Nivel 4",
    "Users with access": "Usuarios con acceso",
    "Export format": "Formato de exportación",
    "Create filter": "Crear filtro",
    "Remove access": "Eliminar acceso",
    "UpdatingSC": "Actualizando nombres de suborganigramas",
    "mergecells": "Combinar celdas",
    "No filters have been added": "No se han añadido filtros",
    "Edit field format": "Editar formato de campo",
    "Create metric": "Crear métrica",
    "Delete plan": "Eliminar plan",
    "Choose to configure your report from today or select a date range": "Elija configurar su informe desde hoy o seleccione un rango de fechas",
    "Preferred First": "Preferido primero",
    "View controls background": "Los fondos están siendo controlados por una vista.",
    "Delete view": "Eliminar vista",
    "Enter custom value": "Introducir valor personalizado",
    "Chart Builder Filter Directions": "Filtre su organigrama para enfocarse en posiciones específicas, departamentos u otros criterios",
    "Download plan": "Descargar plan",
    "Level 3": "Nivel 3",
    "What would you like to call this plan?": "¿Cómo le gustaría llamar a este plan?",
    "Choose field": "Elegir campo",
    "Add people or groups": "Agregar personas o grupos",
    "Conflicts detected": "Conflictos detectados",
    "Text align": "Alineación de texto",
    "Saved highlights": "Resaltados guardados",
    "Line style": "Estilo de línea",
    "Reset your": "Restablecer su",
    "Favorites": "Favoritos",
    "Enter person id of top box": "Introduzca el ID de persona de el cuadro superior",
    "Status is current": "El estado es actual",
    "confirmViewRemove1": "Ha eliminado una o más vistas que actualmente están en uso por",
    "Changes not saved automatically": "Los cambios no se guardan automáticamente",
    "passincspc": "Debe contener al menos un carácter especial",
    "No files or folders here": "No hay archivos o carpetas aquí",
    "IWizHeadsUp1": "Informativo: Este método de importación de datos ha sido reemplazado.",
    "Add SSO Configuration": "Agregar configuración de SSO",
    "Must have a valid profile name": "Debe tener un nombre de perfil válido",
    "First Name": "Nombre",
    "account": "cuenta",
    "bypasstemplatelist": "Saltar la lista blanca de plantillas",
    "Edit highlight": "Editar resaltado",
    "Formula name": "Nombre de fórmula",
    "Can access chart": "Puede acceder al organigrama",
    "Select Custom Chart": "Seleccionar organigrama personalizado",
    "Automatic refresh notifications": "Notificaciones de actualización automática",
    "Unconstrained": "Sin restricciones",
    "Save Report": "Guardar informe",
    "Add group mapping": "Agregar mapeo de grupo",
    "Branch preferences": "Preferencias de sucursal",
    "Edit dynamic formula": "Editar fórmula dinámica",
    "to": "a",
    "Use preset query": "Usar consulta predefinida",
    "Create import filter": "Crear filtro de importación",
    "Rule driven background": "Fondo basado en reglas",
    "Failure only": "Solo fallos",
    "Choose entry type": "Seleccionar tipo de entrada",
    "Change password": "Cambiar contraseña",
    "Continue editing this custom chart": "Continuar editando este organigrama personalizado.",
    "Include a field that contains the reporting hierarchy for each employee": "Incluir un campo que contenga la jerarquía de informes para cada empleado",
    "Rule criteria": "Criterios de reglas",
    "No record selected": "Ningún registro seleccionado",
    "duplicateuiprofile": "El perfil de IU ya existe",
    "Delete metric": "Eliminar métrica",
    "findfield": "Buscar campo",
    "Remove break": "Eliminar salto",
    "Choose fields": "Seleccionar campos",
    "Show and hide fields": "Mostrar y ocultar campos",
    "Subchart breaks": "Saltos de suborganigrama",
    "Name your custom chart": "Nombre su organigrama personalizado",
    "Chart archives": "Archivos de organigramas",
    "Impersonate user": "Suplantar usuario",
    "Person ID required": "Se requiere ID de persona",
    "Pin": "Fijar",
    "Configure metrics": "Configurar métricas",
    "changed": "cambiado",
    "Report name": "Nombre del informe",
    "Untitled Report": "Informe sin título",
    "Default users as collaborators": "Usuarios predeterminados como colaboradores",
    "Basic Table": "Tabla básica",
    "Customize your search with various criteria to find the perfect match": "Personalice su búsqueda con múltiples criterios para encontrar el resultado perfecto",
    "confirmViewRemove2": "organigramas existentes. Una vez que guarde sus cambios, la(s) vista(s) ya no estará(n) disponible(s). ¿Está seguro de que desea guardar sus cambios?",
    "deletecols": "Eliminar columnas",
    "Dynamic formulas": "Fórmulas dinámicas",
    "SAP OrgUnit Chart Options": "Opciones de organigrama de SAP orgUnit",
    "No values added. Click here to add a value": "No se han añadido valores. Haga clic aquí para agregar un valor",
    "Revert all field changes": "Revertir todos los cambios de campo",
    "SEARCH": "BUSCAR",
    "Customer email": "Correo electrónico del cliente",
    "Chart Security": "Seguridad del organigrama",
    "No additional fields added": "Aún no se han añadido campos adicionales",
    "Base Chart": "Organigrama base",
    "Save changes to": "Guardar cambios en",
    "Detailed data query": "Consulta de datos detallada",
    "Choose views": "Seleccionar vistas",
    "Branch pruning info": "Los usuarios solo verán registros que coincidan con los criterios de reglas especificados. (Recomendado para la regla de sucursal 'Restringir a la propia sucursal'.)",
    "importfiltersdesc": "Especificar los datos (registros y campos) que deben incluirse o excluirse en su organigrama al actualizarse. Los datos que se filtran con filtros de importación no son buscables y no afectarán a los recuentos de personal u otras fórmulas.",
    "Last Name": "Apellido",
    "Add new value": "Añadir nuevo valor",
    "Add custom solid color": "Añadir color sólido personalizado",
    "Account details": "Detalles de la cuenta",
    "No chart description": "Sin descripción del organigrama",
    "Invalid photo credentials": "Credenciales de foto inválidas",
    "Keep me signed in": "Mantenerme conectado",
    "Select formula type": "Seleccionar tipo de fórmula",
    "selectcdoc": "Seleccionar documento de organigrama",
    "New SupervisorID Required": "Se requiere un nuevo supervisor para la mudanza",
    "Revert All Confirm": "¿Está seguro de que desea revertir todos los cambios asociados con esta entrada?",
    "Excluded fields": "Campos excluidos",
    "Fields that can be chosen for Excel export": "Campos que pueden ser elegidos para la exportación a Excel",
    "Fields that cannot be chosen for Excel export": "Campos que no pueden ser elegidos para la exportación a Excel",
    "Choose which fields to include in the order in which they will appear. Drag fields from one column to the other.": "Elija qué campos incluir en el orden en que aparecerán. Arrastre los campos de una columna a la otra.",
    "Fields allowed for Excel export": "Campos permitidos para la exportación a Excel",
    "By default, users can choose any fields permitted by their security overlay to export to excel. This feature allows you to optionally customize the list of fields your users will have access to downloading in their excel file": "Por defecto, los usuarios pueden elegir cualquier campo permitido por su capa de seguridad para exportar a Excel. Esta función le permite personalizar opcionalmente la lista de campos a la que tendrán acceso sus usuarios para descargar en su archivo de Excel",
    "Status is active": "El estado está activo",
    "unmergecells": "Desagrupar",
    "Create new highlight": "Crear nuevo resaltado",
    "Edit Append Table": "Editar tabla de anexos",
    "Black": "Negro",
    "Background top spacing": "Ajustar espaciado desde el margen superior",
    "Add element": "Añadir elemento",
    "Remove box": "Eliminar cuadro",
    "Enable sort": "Activar clasificación",
    "EmpFieldMap": "Mapeo de campos de empleado",
    "Advanced search": "Búsqueda avanzada",
    "Select field": "Seleccionar campo",
    "Add Whitelist Domain": "Agregar dominio a la lista blanca",
    "Must have a valid chart name": "Debe tener un nombre de organigrama válido",
    "Pagination wizard": "Asistente de paginación",
    "No refresh history": "Sin historial de actualización",
    "Data changes": "Cambios de datos",
    "Manage Tables": "Gestionar tablas",
    "Send Back": "Devolver",
    "Add criteria": "Agregar criterio",
    "Basic math has no configurable settings": "Las matemáticas básicas no tienen configuraciones ajustables",
    "Manually archive": "Archivar manualmente",
    "Export to Excel": "Exportar a Excel",
    "Exporting archive": "Exportando archivo",
    "Added under": "Agregado bajo",
    "Reset password": "Restablecer contraseña",
    "Changes saved automatically": "Los cambios se guardan automáticamente",
    "Use a white background instead of a color. This option is helpful if you plan to print this file": "Usar un fondo blanco en lugar de un color. Esta opción es útil si planea imprimir este archivo",
    "Remove field value from rule criteria": "Eliminar valor de campo de los criterios de regla",
    "collabplanalert": "El acceso a la planificación colaborativa requiere un asiento de lectura/escritura o de administrador. Contacte a su administrador para cambiar el tipo de asiento.",
    "Page density": "Densidad de página",
    "Disabled": "Deshabilitado",
    "New password must": "La nueva contraseña debe",
    "Modified date": "Fecha de modificación",
    "selectplan": "Seleccionar plan",
    "Domain": "Dominio",
    "Linked View will be applied when the top box of the subchart matches the rule criteria": "La vista vinculada se aplicará cuando el cuadro superior del suborganigrama coincida con los criterios de la regla",
    "Download this page": "Descargar esta página",
    "Background bottom spacing": "Ajustar espaciado desde el margen inferior",
    "Rules from chart": "Reglas del organigrama",
    "Rules from view": "Reglas de la vista",
    "Source info": "Info. de la fuente",
    "Record details": "Detalles del registro",
    "Any unsaved work will be lost.": "Cualquier cambio no guardado se perderá.",
    "source(s)": "fuente(s)",
    "change by author": "{changeDatetime} por {author}",
    "Applying filter": "Aplicando filtro...",
    "Loading chart": "Cargando organigrama...",
    "Update sharing": "Actualizar compartición",
    "Entity sharing access saved": "Acceso de uso compartido de {entity} guardado.",
    "Failed to share": "Error al compartir",
    "Shared filter banner": "Este es un filtro compartido y cualquier cambio se aplicará a los usuarios que tengan acceso a él.",
    "Shared highlight banner": "Este es un resaltado compartido y cualquier cambio se aplicará a los usuarios que tengan acceso a él.",
    "Delete shared filter?": "¿Eliminar filtro compartido?",
    "Delete shared highlight?": "¿Eliminar resaltado compartido?",
    "Delete shared filter confirm": "Al eliminar este filtro compartido, se eliminará para todos los usuarios con los que se ha compartido.",
    "Delete shared highlight confirm": "Al eliminar este resaltado compartido, se eliminará para todos los usuarios con los que se ha compartido.",
    "Delete filter confirm": "Eliminar este filtro lo quitará de su lista de filtros.",
    "Delete highlight confirm": "Eliminar este resaltado lo quitará de su lista de resaltados.",
    "Shared filter copied": "{entity} copiado en 'Mis filtros'.",
    "Shared highlight copied": "{entity} copiado en 'Mis resaltados'.",
    "Entity copy created": "{entity} copiado.",
    "importfiltercharterr": "Se encontraron uno o más problemas con el filtro de importación aplicado. Modifique o elimine el filtro de importación.",
    "chartScopeFilterCharterr": "Se encontraron uno o más problemas con el filtro de alcance del gráfico aplicado. Modifique o elimine el filtro de alcance del gráfico.",
    "Chart scope": "Alcance del gráfico",
    "Chart scope description": "Vea el alcance del gráfico y aplique una regla a este gráfico personalizado.",
    "Levels under top box": "Niveles bajo el cuadro superior",
    "Chart scope edit cc to edit": "Edite el gráfico para ajustar el alcance del gráfico.",
    "To remedy this issue: reduce the number of levels shown, adjust subchart break criteria, or apply a filter": "Para solucionar este problema: reduzca el número de niveles mostrados, ajuste los criterios de quiebre del suborganigrama o aplique un filtro.",
    "Interactive filters": "Filtros interactivos",
    "Shared filters": "Filtros compartidos",
    "Shared highlights": "Resaltados compartidos",
    "My filters": "Mis filtros",
    "My highlights": "Mis resaltados",
    "Share filter": "Compartir filtro",
    "Share highlight": "Compartir resaltado",
    "Copy filter": "Copiar filtro",
    "Copy highlight": "Copiar resaltado",
    "Filter details": "Detalles del filtro",
    "Highlight details": "Detalles del resaltado",
    "Back to filters": "Volver a los filtros",
    "Back to highlights": "Volver a los resaltados",
    "shared": "compartido",
    "No shared filters yet": "Aún no se han compartido filtros con usted.",
    "No shared highlights yet": "Aún no se han compartido resaltados con usted.",
    "A shared filter with this name already exists": "Ya existe un filtro compartido con este nombre en este organigrama.",
    "A shared highlight with this name already exists": "Ya existe un resaltado compartido con este nombre en este organigrama.",
    "Share filter info text": "Cuando se comparte un filtro, solo el propietario puede administrar el acceso compartido y eliminar el filtro.",
    "Share highlight info text": "Cuando se comparte un resaltado, solo el propietario puede administrar el acceso compartido y eliminar el resaltado.",
    "Share this entity with": "Compartir este {entity} con:",
    "Show highlight": "Mostrar resaltado",
    "Hide highlight": "Ocultar resaltado",
    "Show filter": "Mostrar filtro",
    "Hide filter": "Ocultar filtro",
    "boxes for a custom chart. Try building the chart from a smaller section of your organization or apply filters to reduce the number of boxes.": "cuadros para un organigrama personalizado. Intente crear el organigrama desde una sección más pequeña de su organización o aplique filtros para reducir el número de cuadros.",
    "Do you want to save changes to Filters": "¿Desea guardar los cambios en los filtros?",
    "back to filter list": "Volver a los filtros",
    "back to highlight list": "Volver a los resaltados",
    "Share this plan with": "Opcional: Compartir este plan ahora",
    "Share Filters & Highlights": "Compartir filtros y resaltados",
    "Filters applied tooltip": "Número de filtros aplicados al {document} abierto actualmente.",
    "Employee filter": "Filtro de empleados",
    "Show filter fields": "Mostrar campos de filtro",
    "No filter fields selected": "No se han seleccionado campos de filtro. Use el botón 'Campos' para agregar campos.",
    "includefilteredhelper": "Active esta opción para incluir a los responsables cuyos subordinados cumplan los criterios de filtro definidos, aunque los responsables no cumplan dichos criterios por sí mismos.",
    "share historical": "Compartir historial",
    "My filters info": "Cree, administre y aplique filtros en cualquier tipo de organigrama.",
    "My highlights info": "Cree, administre y aplique resaltados en cualquier tipo de organigrama.",
    "Saved highlights info": "Los resaltados heredados son administrados por los administradores en la configuración del organigrama: pestaña filtros y resaltados.",
    "No highlights created yet": "Aún no se han creado resaltados",
    "Search filters": "Buscar filtros",
    "Search highlights": "Buscar resaltados",
    "Shared filters info": "Estos filtros han sido compartidos con usted y pueden aplicarse a cualquier tipo de organigrama. La posibilidad de editar determinados filtros dependerá de su nivel de acceso compartido.",
    "Shared highlights info": "Estos resaltados han sido compartidos con usted y pueden aplicarse a cualquier tipo de organigrama. La posibilidad de editar determinados resaltados dependerá de su nivel de acceso compartido.",
    "Interactive highlights": "Resaltados interactivos",
    "Interactive filters & highlights": "Filtros y resaltados interactivos",
    "Delete highlight": "Eliminar resaltado",
    "Delete highlight?": "¿Eliminar resaltado?",
    "Legacy filters": "Filtros heredados",
    "Legacy highlights": "Resaltados heredados",
    "Applies to": "Se aplica a",
    "Restricted": "Restringido",
    "Budgeted Headcount": "Conteo presupuestado",
    "Salary Rollup": "Acumulado de salario",
    "Position Budget Rollup": "Acumulado de presupuesto de puesto",
    "Assigned to": "Asignado a",
    "No results found for the selected criteria. Please adjust your selection and try again": "No se encontraron resultados para los criterios seleccionados. Ajuste su selección e intente de nuevo",
    "Create base chart": "Crear organigrama base",
    "Pages": "Páginas",
    "Could not load page": "No se pudo cargar la página",
    "The number of records on the page exceeds the single page limit": "El número de registros en la página excede el límite de una sola página",
    "canvastoolarge": "Esta página es demasiado grande para mostrarse en el navegador.",
    "Maximum": "Máximo",
    "No preview": "Sin vista previa",
    "Select a preview": "Seleccionar una vista previa",
    "Plan settings": "Configuración del plan",
    "Current view applied": "Vista actual aplicada",
    "Chart description": "Descripción del organigrama",
    "Minimum group size": "Tamaño mínimo de grupo",
    "Allow groups with managers": "Permitir grupos con gerentes",
    "Co-manager": "Co-gerente",
    "Manager group box style": "Estilo de cuadro de grupo de gerentes",
    "Restore plan": "Restaurar plan",
    "Locking plan": "Bloqueando plan",
    "Unlocking plan": "Desbloqueando plan",
    "Deleting plan": "Eliminando plan",
    "Duplicating plan": "Duplicando plan",
    "Archiving plan": "Archivando plan",
    "Renaming plan": "Renombrando plan",
    "This field is read-only and cannot be edited": "Este campo es de solo lectura y no se puede editar",
    "Edit employee record": "Editar registro de empleado",
    "formulas": "fórmulas",
    "Add metric": "Añadir métrica",
    "Phases": "Fases",
    "Conflicted record": "Registro en conflicto",
    "Active append table": "Tabla adjunta activa",
    "Copy to My filters": "Copiar a mis filtros",
    "Copy to My highlights": "Copiar a mis resaltados",
    "copy": "copiar",
    "This user cannot be a collaborator because of their read-only role": "Este usuario no puede ser colaborador debido a su rol de solo lectura",
    "Revert changes": "Revertir cambios",
    "Move to Staging": "Mover a preparación",
    "Edit rule criteria": "Editar criterios de regla",
    "Duplicate rule criteria": "Duplicar criterios de regla",
    "Remove rule criteria": "Eliminar criterios de regla",
    "EmployeeID": "EmployeeID",
    "Data field": "Campo de datos",
    "Create group": "Crear grupo",
    "Position view library": "Biblioteca de vistas de puesto",
    "Employee view library": "Biblioteca de vistas de empleado",
    "Record is disconnected from hierarchy": "El registro está desconectado de la jerarquía",
    "No field": "Sin campo",
    "Position field mapping": "Mapeo de campos de puesto",
    "Conflict auto-resolved": "Conflicto resuelto automáticamente",
    "Apply this formula to": "Aplicar esta fórmula a",
    "Turn on by default": "Activar por defecto",
    "Turn off by default": "Desactivar por defecto",
    "Page sort order": "Orden de clasificación de página",
    "Keep order as-is": "Mantener el orden actual",
    "Keep pagination as-is": "Mantener la paginación actual",
    "A single page export will not need to re-paginate your chart": "Una exportación de una sola página no necesitará repaginar su organigrama",
    "Sort by field": "Ordenar por campo",
    "Closed under": "Cerrado bajo",
    "Reopened under": "Reabierto bajo",
    "Released from": "Liberado de",
    "You’ve exceeded the max number of boxes allowed for export. Please reduce the scope of your export, or attempt an export from a different part of your organization, so that the number of boxes will not exceed your limit": "Ha excedido el número máximo de cuadros permitidos para la exportación. Reduzca el alcance de su exportación o intente exportar desde otra parte de su organización para que el número de cuadros no exceda su límite",
    "Administrators can update this limit in the Chart Settings: Presentation panel, though OrgChart does not recommend exporting charts with more than 20,000 records": "Los administradores pueden actualizar este límite en configuración del organigrama: panel presentación, aunque OrgChart no recomienda exportar organigramas con más de 20.000 registros",
    "You’ve reached the maximum limit of": "Ha alcanzado el límite máximo de",
    "Admins can adjust this limit in Chart Settings > Presentation Panel, but OrgChart recommends keeping charts under 20,000 records for best performance.": "Los administradores pueden ajustar este límite en configuración del organigrama > panel de presentación, pero OrgChart recomienda mantener los organigramas con menos de 20.000 registros para un mejor rendimiento.",
    "Use advanced Entra Query": "Usar consulta avanzada de entra",
    "Microsoft account type": "Tipo de cuenta de Microsoft",
    "Standard (.com)": "Estándar (.com)",
    "US government (.us)": "Gobierno de EE. UU. (.us)",
    "Changes pending": "Cambios pendientes",
    "Created by": "Creado por",
    "Manually added": "Añadido manualmente",
    "Source information not available": "Información de origen no disponible",
    "Enter field name": "Ingrese el nombre del campo",
    "Over source limit": "Sobre el límite de origen",
    "Could not refresh custom chart": "No se pudo actualizar el organigrama personalizado",
    "Could not open custom chart": "No se pudo abrir el organigrama personalizado",
    "Failed to reorder talent": "No se pudo reordenar el talento",
    "Could not locate employee to add to talent pool": "No se pudo localizar al empleado para añadir al grupo de talento",
    "Back to all groups": "Volver a todos los grupos",
    "Group name": "Nombre del grupo",
    "Group by field": "Agrupar por campo",
    "Group style": "Estilo de grupo",
    "Rename report": "Cambiar nombre del reporte",
    "Configure chart": "Configurar organigrama",
    "Chart settings": "Configuración del organigrama",
    "Save your current changes to this record": "Guarde sus cambios actuales en este registro",
    "Show grouping": "Mostrar agrupación",
    "Invalid email": "Correo electrónico inválido",
    "Fix email": "Corregir correo electrónico",
    "Reset integration": "Restablecer integración",
    "Reset data integration": "Restablecer integración de datos",
    "One or more fields contain errors": "Uno o más campos contienen errores",
    "Confirm delete": "Confirmar eliminación",
    "Cannot re-use previous password": "No se puede reutilizar la contraseña anterior",
    "Unable to build preview": "No se puede generar la vista previa",
    "An error prevented the preview from being generated. Please try again": "Un error impidió que se generara la vista previa. Intente de nuevo",
    "Rebuild preview": "Regenerar vista previa",
    "Record removed": "Registro eliminado",
    "Select a valid reports to": "Seleccione un reporte a válido",
    "Undo plan change": "Deshacer cambio del plan",
    "Create custom charts": "Crear organigramas personalizados",
    "Application, Account, User, and Chart information": "Información de aplicación, cuenta, usuario y organigrama",
    "Refresh base charts (Read/Write users)": "Actualizar organigramas base (usuarios lectura/escritura)",
    "Allow language change": "Permitir cambio de idioma",
    "Applying these settings will remove any manual subchart breaks": "Aplicar esta configuración eliminará cualquier división manual de suborganigrama",
    "Permission denied": "Permiso denegado",
    "Delete background": "Eliminar fondo",
    "Move background": "Mover fondo",
    "Replace Existing File": "Reemplazar archivo existente",
    "Replace Existing Files": "Reemplazar archivos existentes",
    "Skip Duplicate": "Omitir duplicado",
    "Skip Duplicates": "Omitir duplicados",
    "Existing": "Existente",
    "Replace or Discard Files": "Reemplazar o descartar archivos",
    "File manager": "Gestor de archivos",
    "Modify backgrounds": "Modificar fondos",
    "Delete open chart": "Eliminar organigrama abierto",
    "Not now": "Ahora no",
    "Load now": "Cargar ahora",
    "Update mapping": "Actualizar asignación",
    "Keep mapping": "Mantener asignación",
    "photoviewnophotos": "Ninguno de sus empleados tiene fotos. Agregue fotos en su sistema de RR. HH. para que aparezcan aquí.",
    "Unable to delete rule": "No se puede eliminar la regla",
    "accounts": "cuentas",
    "Move to trash": "Mover a la papelera",
    "Delete all": "Eliminar todo",
    "Move all to trash": "Mover todo a la papelera",
    "Empty trash": "Vaciar papelera",
    "Save and exit": "Guardar y salir",
    "Box style name in use": "Nombre de estilo de cuadro en uso",
    "Enter a field name": "Ingrese un nombre de campo",
    "Show less": "Mostrar menos",
    "Show more": "Mostrar más",
    "This custom chart is currently open. Are you sure you want to delete this custom chart": "Este organigrama personalizado está abierto. ¿Está seguro de que desea eliminar este organigrama personalizado?",
    "12 AM": "12 AM",
    "1 AM": "1 AM",
    "2 AM": "2 AM",
    "3 AM": "3 AM",
    "4 AM": "4 AM",
    "5 AM": "5 AM",
    "6 AM": "6 AM",
    "7 AM": "7 AM",
    "8 AM": "8 AM",
    "9 AM": "9 AM",
    "10 AM": "10 AM",
    "11 AM": "11 AM",
    "12 PM": "12 PM",
    "1 PM": "1 PM",
    "2 PM": "2 PM",
    "3 PM": "3 PM",
    "4 PM": "4 PM",
    "5 PM": "5 PM",
    "6 PM": "6 PM",
    "7 PM": "7 PM",
    "8 PM": "8 PM",
    "9 PM": "9 PM",
    "10 PM": "10 PM",
    "11 PM": "11 PM",
    "Copy file": "Copiar archivo",
    "Download file": "Descargar archivo",
    "Delete file": "Eliminar archivo",
    "Select a table": "Seleccionar una tabla",
    "New Base Chart": "Nuevo organigrama base",
    "Table Name": "Nombre de tabla",
    "Table name cannot be empty": "El nombre de tabla no puede estar vacío",
    "Table name must be at least 4 characters": "El nombre de tabla debe tener al menos 4 caracteres",
    "Table name already exists": "El nombre de tabla ya existe",
    "Create table": "Crear tabla",
    "Search for table name": "Buscar nombre de tabla",
    "Search by name or title": "Buscar por nombre o título",
    "Modifications": "Modificaciones",
    "Add record": "Añadir registro",
    "Unsaved changes detected": "Cambios sin guardar detectados",
    "Position fields": "Campos de puesto",
    "Employee fields": "Campos de empleado",
    "The system only allows you to add up to three additional co-heads": "El sistema solo permite añadir hasta tres co-directores adicionales",
    "Add co-head": "Añadir co-director",
    "Box selected": "Cuadro seleccionado",
    "Position box": "Cuadro de puesto",
    "Employee box": "Cuadro de empleado",
    "Chart styles": "Estilos de organigrama",
    "Additional reports": "Reportes adicionales",
    "Additional reports to": "Reportes adicionales a",
    "Add assignment": "Añadir asignación",
    "Duplicate additional reports are not allowed": "No se permiten reportes adicionales duplicados",
    "This supervisor is already selected": "Este supervisor ya está seleccionado",
    "Chart fields changed": "Campos del organigrama modificados",
    "Invalid reporting structure": "Estructura de reporte inválida",
    "Manage fields": "Administrar campos",
    "custom charts": "organigramas personalizados",
    "Choose data source": "Elegir fuente de datos",
    "Employee Chart": "Organigrama de empleados",
    "Position Chart": "Organigrama de puestos",
    "Allocation Ratio": "Proporción de asignación",
    "Position field categories": "Categorías de campos de puesto",
    "Data field categories": "Categorías de campos de datos",
    "Assign as": "Asignar como",
    "Both": "Ambos",
    "Create plan from": "Crear plan desde",
    "Create custom chart from": "Crear organigrama personalizado desde",
    "custom chart created": "Organigrama personalizado {name} creado.",
    "No rule": "Sin regla",
    "Add a description": "Añadir una descripción",
    "this can be done later": "esto se puede hacer después",
    "Cost reduction": "Reducción de costos",
    "Headcount reduction": "Reducción de plantilla",
    "Relocation": "Reubicación",
    "General organization design": "Diseño general de organización",
    "Select objective": "Seleccionar objetivo",
    "Objective": "Objetivo",
    "Employees": "Empleados",
    "Modify fields": "Modificar campos",
    "Upload checkpoint": "Cargar punto de control",
    "Select a chart type to configure data source": "Seleccione un tipo de organigrama para configurar la fuente de datos",
    "Employee List": "Lista de empleados",
    "Unassigned": "Sin asignar",
    "Assigned": "Asignado",
    "Released": "Liberado",
    "Unassigned from": "Desasignado de",
    "Assign": "Asignar",
    "Assign to position": "Asignar al puesto",
    "Clone position": "Clonar puesto",
    "Unassign employee": "Desasignar empleado",
    "Unassign employees": "Desasignar empleados",
    "Assign employee": "Asignar empleado",
    "Release employee": "Liberar empleado",
    "Release employees": "Liberar empleados",
    "Set as default chart": "Establecer como organigrama predeterminado",
    "Open in chart settings": "Abrir en configuración del organigrama",
    "Create copy": "Crear copia",
    "Delete chart": "Eliminar organigrama",
    "Delete chart disabled isolved": "No puede eliminar este organigrama en este momento. Póngase en contacto con el soporte de isolved para obtener más información.",
    "Add additional report field": "Añadir campo de reporte adicional",
    "General field mapping": "Mapeo general de campos",
    "Reset to default": "Restablecer a predeterminado",
    "This option is disabled due to role assignment restrictions": "Esta opción está deshabilitada debido a restricciones de asignación de rol",
    "Position dataset": "Conjunto de datos de puesto",
    "Employee dataset": "Conjunto de datos de empleado",
    "I have a single source with employee data": "Tengo una fuente única con datos de empleado",
    "I have multiple sources with employee and position data": "Tengo múltiples fuentes con datos de empleado y puesto",
    "I have a single source with employee and position data": "Tengo una fuente única con datos de empleado y puesto",
    "Budget field mapping": "Mapeo de campos de presupuesto",
    "Employee details field mapping": "Mapeo de campos de detalle de empleado",
    "Position details": "Detalles del puesto",
    "Start date": "Fecha de inicio",
    "End date": "Fecha de fin",
    "Vacant": "Vacante",
    "Assignment status": "Estado de asignación",
    "Assignees": "Asignados",
    "System generated": "Generado por el sistema",
    "Upgrade to add more": "Actualice para añadir más",
    "Learn more": "Más información",
    "Get started": "Comenzar",
    "Access groups remaining": "Grupos de acceso restantes",
    "Access groups used": "Grupos de acceso utilizados",
    "Source base chart": "Organigrama base de origen",
    "Auto-sync enabled": "Sincronización automática habilitada",
    "Auto-save enabled": "Guardado automático habilitado",
    "All staged records": "Todos los registros en preparación",
    "Unassign": "Desasignar",
    "Release": "Liberar",
    "Reopen": "Reabrir",
    "Assignment": "Asignación",
    "all employees": "todos los empleados",
    "Reopen position": "Reabrir puesto",
    "Close position": "Cerrar puesto",
    "Close and release": "Cerrar y liberar",
    "Close and unassign": "Cerrar y desasignar",
    "Closed": "Cerrado",
    "Search name": "Buscar nombre",
    "Type and press enter": "Escriba y presione enter",
    "Cost bands": "Bandas salariales",
    "Use cost band data": "Usar datos de banda salarial",
    "System calculate for me": "Cálculo automático del sistema",
    "Remove assignment": "Eliminar asignación",
    "Search for an employee": "Buscar un empleado",
    "Reassign employee": "Reasignar empleado",
    "Budget details": "Detalles del presupuesto",
    "Position budget summary": "Resumen de presupuesto del puesto",
    "remaining": "restante",
    "total budget": "presupuesto total",
    "Utilization": "Utilización",
    "Total cost": "Costo total",
    "Employee cost breakdown": "Desglose de costos del empleado",
    "Cost band max": "Máximo de banda salarial",
    "Current position cost": "Costo actual del puesto",
    "Create position": "Crear puesto",
    "Custom count": "Conteo personalizado",
    "Copy position": "Copiar puesto",
    "Employee changes": "Cambios de empleado",
    "Position changes": "Cambios de puesto",
    "Custom formulas remaining": "Fórmulas personalizadas restantes",
    "Custom formulas used": "Fórmulas personalizadas utilizadas",
    "Enter comment": "Ingrese un comentario",
    "Assigned position": "Puesto asignado",
    "Search for a position": "Buscar un puesto",
    "budget": "presupuesto",
    "View budget information": "Ver información de presupuesto",
    "Hide details": "Ocultar detalles",
    "Confirm assignments": "Confirmar asignaciones",
    "Employee {employee} assigned to {position}": "Empleado {employee} asignado a {position}",
    "{employee} is unassigned from {position}": "{employee} está desasignado de {position}",
    "{employee} is released from {position}": "{employee} está liberado de {position}",
    "Selections": "Selecciones",
    "Upgrade to create": "Actualice para crear",
    "conditional row level": "nivel de fila condicional",
    "Upgrade to group": "Actualice para agrupar",
    "compact and concise": "compacto y conciso",
    "multiple": "múltiple",
    "Current values": "Valores actuales",
    "Reports to (position)": "Reporta a (puesto)",
    "Work Location": "Ubicación de trabajo",
    "Position Title is required": "El título del puesto es obligatorio",
    "Parent PositionID is required": "El ID de puesto superior es obligatorio",
    "Reports To is required": "Reporta a es obligatorio",
    "Allocation must be a positive number": "La asignación debe ser un número positivo",
    "Cost Band Minimum must be a number": "El mínimo de banda salarial debe ser un número",
    "Cost Band Maximum must be a number": "El máximo de banda salarial debe ser un número",
    "Cost Band Minimum cannot be greater than Cost Band Maximum": "El mínimo de banda salarial no puede ser mayor que el máximo de banda salarial",
    "End Date must be on or after Start Date": "La fecha de fin debe ser igual o posterior a la fecha de inicio",
    "Copy count must be a positive number": "La cantidad de copias debe ser un número positivo",
    "Position ID is required": "El ID de puesto es obligatorio",
    "and {count} more": "y {count} más",
    "Base charts": "Organigramas base",
    "View and select chart export options": "Ver y seleccionar opciones de exportación del organigrama",
    "User preferences menu": "Menú de preferencias del usuario",
    "Help Center": "Centro de ayuda",
    "Data source refresh failures": "Errores de actualización de fuente de datos",
    "Data Load Failure": "Error de carga de datos",
    "Append Data Failure": "Error de datos adjuntos",
    "Merge Data Failure": "Error de combinación de datos",
    "Main data source": "Fuente de datos principal",
    "Append data source": "Fuente de datos adjunta",
    "Merge data source": "Fuente de datos de combinación",
    "Photo data source": "Fuente de datos de fotos",
    "Data source": "Fuente de datos",
    "Unknown": "Desconocido",
    "Plan no longer exists": "El plan ya no existe",
    "Error loading plan": "Error al cargar el plan",
    "Permission denied to access planning module": "Permiso denegado para acceder al módulo de planificación",
    "Permission denied to access plan": "Permiso denegado para acceder al plan",
    "Insufficient role to access planning module": "Rol insuficiente para acceder al módulo de planificación",
    "Core fields cannot be hidden in the table": "Los campos principales no se pueden ocultar en la tabla",
    "branch level": "nivel de rama",
    "Enable approvals": "Habilitar aprobaciones",
    "plan approval system": "sistema de aprobación de plan",
    "granular control": "control detallado",
    "calculate metrics": "calcular métricas",
    "accurate depiction": "representación precisa",
    "automatically assign": "asignar automáticamente",
    "Clone": "Clonar",
    "Edit position": "Editar puesto",
    "Multiple positions": "Múltiples puestos",
    "Multiple employees": "Múltiples empleados",
    "Automatically archive charts": "Archivar organigramas automáticamente",
    "Org structures": "Estructuras organizacionales",
    "Stay audit ready": "Manténgase preparado para auditorías",
    "securely captured": "capturado de forma segura",
    "identify patterns": "identificar patrones",
    "Assignments": "Asignaciones",
    "Additional data sources remaining": "Fuentes de datos adicionales restantes",
    "Upgrade to add": "Actualice para añadir",
    "additional HR systems": "sistemas de RR. HH. adicionales",
    "vacancies or contractors": "vacantes o contratistas",
    "secondary managers": "gerentes secundarios",
    "Upgrade to plan": "Actualice para planificar",
    "Plan with Position Data": "Planificar con datos de puesto",
    "Track KPIs": "Track kPIs",
    "Collaborate in Real Time": "Colaborar en tiempo real",
    "positions and vacancies": "puestos y vacantes",
    "insight": "información",
    "impact": "impacto",
    "setting and tracking": "configuración y seguimiento",
    "drag and drop": "arrastrar y soltar",
    "move groups": "mover grupos",
    "team is aware": "el equipo está informado",
    "This option is disabled due to package restrictions": "Esta opción está deshabilitada debido a restricciones del paquete",
    "Core mapped fields must always show to build your base chart": "Los campos principales mapeados siempre deben mostrarse para construir su organigrama base",
    "This field cannot be {status1} as it has already been selected as {status2}": "Este campo no puede ser {status1} ya que ha sido seleccionado como {status2}",
    "Upgrade": "Actualizar",
    "Employees in deleted position will be unassigned in the Employee List.": "Los empleados en el puesto eliminado serán desasignados en la lista de empleados.",
    "Would you like to rollup or delete the subordinates for {position}?": "¿Desea acumular o eliminar los subordinados de {position}?",
    "Rollup or delete subordinate positions": "Acumular o eliminar puestos subordinados",
    "Rollup subordinates": "Acumular subordinados",
    "Delete subordinates": "Eliminar subordinados",
    "Position field": "Campo de puesto",
    "Allocation": "Asignación",
    "Holder Count": "Cantidad de titulares",
    "Add subordinate position": "Añadir puesto subordinado",
    "Add subordinate position(s)": "Añadir puesto(s) subordinado(s)",
    "Add employee(s) to position": "Añadir empleado(s) al puesto",
    "Add assistant position": "Añadir puesto de asistente",
    "Created and assigned to": "Creado y asignado a",
    "Position profile": "Perfil del puesto",
    "Employee profile": "Perfil del empleado",
    "Edit position details": "Editar detalles del puesto",
    "Edit employee details": "Editar detalles del empleado",
    "Employee details": "Detalles del empleado",
    "Create new chart": "Crear nuevo organigrama",
    "range": "rango",
    "Starting value": "Valor inicial",
    "Ending value": "Valor final",
    "Choose a color": "Elegir un color",
    "last [n] days": "últimos [n] días",
    "last [n] weeks": "últimas [n] semanas",
    "last [n] months": "últimos [n] meses",
    "last [n] years": "últimos [n] años",
    "next [n] days": "próximos [n] días",
    "next [n] weeks": "próximas [n] semanas",
    "next [n] months": "próximos [n] meses",
    "next [n] years": "próximos [n] años",
    "yesterday": "ayer",
    "tomorrow": "mañana",
    "To (optional)": "Hasta (opcional)",
    "specific date": "fecha específica",
    "removed from your data set": "eliminado de su conjunto de datos",
    "created positions for you to maintain": "puestos creados para que usted mantenga",
    "append table": "tabla adjunta",
    "Minimum subordinate threshold": "Umbral mínimo de subordinados",
    "Include": "Incluir",
    "Exclude": "Excluir",
    "Favorite field {i}": "Campo favorito {i}",
    "Profile picture": "Foto de perfil",
    "Employee profile card": "Tarjeta de perfil del empleado",
    "Position profile card": "Tarjeta de perfil del puesto",
    "Additional {type} information": "Información adicional de {type}",
    "Heading information": "Información de encabezado",
    "Fields to": "Campos para",
    "Position start date": "Fecha de inicio del puesto",
    "Position end date": "Fecha de fin del puesto",
    "Full name": "Nombre completo",
    "Employee ID": "ID de empleado",
    "Position ID": "ID de puesto",
    "Record type": "Tipo de registro",
    "Record name": "Nombre del registro",
    "Modification type": "Tipo de modificación",
    "Replace all": "Reemplazar todo",
    "Add to existing": "Añadir a existente",
    "Append table has existing records": "La tabla adjunta tiene registros existentes",
    "Information unavailable": "Información no disponible",
    "Clear vacant positions": "Limpiar puestos vacantes",
    "Clear vacant positions after": "Limpiar puestos vacantes después de",
    "1 assignee": "1 asignado",
    "{n} assignees": "{n} asignados",
    "Field name": "Nombre de campo",
    "No fields added yet": "Aún no se han añadido campos",
    "Data sources below are not yet supported for this chart type. For assistance, please reach out to ": "Las fuentes de datos a continuación aún no son compatibles con este tipo de organigrama. Para obtener ayuda, comuníquese con",
    "What type of dataset do you want to ": "¿Qué tipo de conjunto de datos desea",
    "Force queue refresh": "Forzar actualización de cola",
    "Force queue": "Forzar cola",
    "Use Auth V1": "Usar auth V1",
    "Plan state": "Estado del plan",
    "Approval Status": "Estado de aprobación",
    "Approval status": "Estado de aprobación",
    "This plan has the following approver(s) and their approval status:": "Este plan tiene los siguientes aprobadores y su estado de aprobación:",
    "Draft": "Borrador",
    "Submitted": "Enviado",
    "Approved": "Aprobado",
    "Rejected": "Rechazado",
    "Withdrawn": "Retirado",
    "Pending": "Pendiente",
    "Submit Plan for Approval": "Enviar plan para aprobación",
    "Plan details": "Detalles del plan",
    "Owner": "Propietario",
    "Add approvers": "Añadir aprobadores",
    "Search for approvers": "Buscar aprobadores",
    "Message": "Mensaje",
    "Add a message for approvers": "Añadir un mensaje para los aprobadores",
    "Submit for approval": "Enviar para aprobación",
    "Submit Plan": "Enviar plan",
    "Plan Submitted": "Plan enviado",
    "Approve Plan": "Aprobar plan",
    "Approve plan": "Aprobar plan",
    "Reject plan": "Rechazar plan",
    "Submit plan": "Enviar plan",
    "Withdraw plan": "Retirar plan",
    "No plan approvals have been made yet.": "Aún no se han realizado aprobaciones de plan.",
    "Approvals": "Aprobaciones",
    "Reject Plan": "Rechazar plan",
    "Approval message": "Mensaje de aprobación",
    "Rejection message": "Mensaje de rechazo",
    "Approve": "Aprobar",
    "Reject": "Rechazar",
    "Submission Info": "Información de envío",
    "Submitted by": "Enviado por",
    "Submitted on": "Enviado el",
    "Submission message": "Mensaje de envío",
    "Approvers": "Aprobadores",
    "Add a message": "Añadir un mensaje",
    "Grant access": "Otorgar acceso",
    "Withdraw": "Retirar",
    "Withdrawal message": "Mensaje de retiro",
    "Optional message": "Mensaje opcional",
    "Withdrawn by": "Retirado por",
    "Withdrawn on": "Retirado el",
    "Force calculate": "Forzar cálculo",
    "Force calculate formulas": "Forzar cálculo de fórmulas",
    "Table view": "Vista de tabla",
    "Default editable fields": "Campos editables predeterminados",
    "Choose the default editable fields that you want to show in the {entity} modals.": "Elija los campos editables predeterminados que desea mostrar en los modales de {entity}.",
    "Plan settings apply to plans created from the selected base chart.": "La configuración del plan se aplica a planes creados desde el organigrama base seleccionado.",
    "Approval settings": "Configuración de aprobación",
    "Enable plan approvals": "Habilitar aprobaciones de plan",
    "Disable plan approval?": "¿Deshabilitar aprobación de plan?",
    "Disabling plan approval will hide plan approval flows for all plans created from this base chart. Are you sure you want to disable plan approval for this base chart?": "Deshabilitar la aprobación de plan ocultará los flujos de aprobación para todos los planes creados desde este organigrama base. ¿Está seguro de que desea deshabilitar la aprobación de plan para este organigrama base?",
    "When enabled, plans can be submitted for approval and e-mail notifications are sent for status updates.": "Cuando está habilitado, los planes se pueden enviar para aprobación y se envían notificaciones por correo electrónico para actualizaciones de estado.",
    "Disable": "Deshabilitar",
    "Show only plans needing my approval": "Mostrar solo planes que requieren mi aprobación",
    "Plan requires approval": "El plan requiere aprobación",
    "you": "usted",
    "Review changes": "Revisar cambios",
    "In Review": "En revisión",
    "Manage plan fields": "Administrar campos del plan",
    "Review plan": "Revisar plan",
    "This plan is in draft and has no approver information available until it is submitted for approval.": "Este plan está en borrador y no tiene información de aprobadores disponible hasta que se envíe para aprobación.",
    "Add language": "Añadir idioma",
    "Data localization": "Localización de datos",
    "Include field?": "¿Incluir campo?",
    "Include field": "Incluir campo",
    "Are you sure you want to include this field?": "¿Está seguro de que desea incluir este campo?",
    "Search for field": "Buscar campo",
    "Delete language": "Eliminar idioma",
    "Are you sure you want to delete this language? All mapped field configurations for this language will be lost.": "¿Está seguro de que desea eliminar este idioma? Todas las configuraciones de campos mapeados para este idioma se perderán.",
    "Layout type": "Tipo de diseño",
    "Standard box": "Cuadro estándar",
    "Group box": "Cuadro de grupo",
    "Group box style": "Estilo de cuadro de grupo",
    "Save changes": "Guardar cambios",
    "Display settings": "Configuración de visualización",
    "Limit text to a single row": "Limitar texto a una sola fila",
    "columns used in the group box": "columnas utilizadas en el cuadro de grupo",
    "Default to view's box style": "Predeterminar al estilo de cuadro de la vista",
    "Group box layouts cannot have columns": "Los diseños de cuadro de grupo no pueden tener columnas",
    "This box layout type is applied to employee boxes.": "Este tipo de diseño de cuadro se aplica a los cuadros de empleado.",
    "This box layout type is applied to the grouped box that groups the employee records.": "Este tipo de diseño de cuadro se aplica a el cuadro agrupado que agrupa los registros de empleado.",
    "You do not have any custom group styles created. Create a custom group style in the 'Box styles' panel and apply it to a conditional grouping.": "No tiene estilos de grupo personalizados creados. Cree un estilo de grupo personalizado en el panel 'Estilos de cuadro' y aplíquelo a una agrupación condicional.",
    "Framed": "Enmarcado",
    "Condensed": "Condensado",
    "Grouped employee records appear in a list. The ‘Group by field’ value for those grouped records is displayed at the top of the group.": "Los registros de empleados agrupados aparecen en una lista. El valor de 'Agrupar por campo' para esos registros agrupados se muestra en la parte superior del grupo.",
    "A frame is placed around grouped records. Conditional formatting targeting framed grouped records still appear.": "Se coloca un marco alrededor de los registros agrupados. El formato condicional dirigido a registros agrupados enmarcados sigue apareciendo.",
    "Employee box style": "Estilo de cuadro de empleado",
    "Default to last used or only created": "Predeterminar al último usado o único creado",
    "View name": "Nombre de vista",
    "BudgetedHeadcount": "Personal presupuestado",
    "SalaryRollup": "Resumen salarial",
    "CurrentPositionCost": "Costo del puesto actual",
    "PositionBudgetRollup": "Resumen del presupuesto de puestos",
    "PositionCount": "Número de puestos",
    "SubordinatePositions": "Puestos subordinados",
    "DirectSubordinatePositions": "Puestos subordinados directos",
    "PeerPositions": "Puestos equivalentes",
    "overtarget": "{delta} por encima del objetivo",
    "undertarget": "{delta} por debajo del objetivo",
    "Metric trend tooltip": "Inicio: {starting} | diferencia: {delta}",
    "Duplicate file or files": "Archivo(s) duplicado(s)",
    "foldermoveddeleted": "No se encontró la carpeta. Es posible que se haya cambiado de nombre o que ya no exista.",
    "foldernotfound": "Carpeta no encontrada",
    "deleteuser2": "de su cuenta",
    "connectionerr": "Error de conexión. Verifique su conexión e inténtelo de nuevo.",
    "planconfigupdated": "La configuración del plan se ha actualizado.",
    "planupdatedlatest": "Cambios del plan sincronizados.",
    "talentpoolupdated": "El grupo de talentos se ha actualizado.",
    "functionalchartoption": "Función {index}",
    "rowsecallowedfieldsimplicit": "Todos los campos no restringidos son visibles.",
    "formulaerrnooperations": "Agregue al menos una operación.",
    "formulaerrnorule": "Se requiere la definición de la regla.",
    "This field is required": "Este campo es obligatorio.",
    "Both fields are required": "Ambos campos son obligatorios.",
    "Add at least one value to the operation": "Agregue al menos un valor a la operación.",
    "There are required fields missing": "Faltan campos obligatorios.",
    "Maximum number of metrics reached alert": "Puede rastrear hasta {MAX_METRICS} {metrics} a la vez. Para agregar una nueva métrica, deberá eliminar una existente.",
    "No more formulas available to add alert": "No tiene fórmulas disponibles para rastrear. Los administradores pueden crear fórmulas en {chartSettingsFieldsFormulasPath}.",
    "No metrics available to add": "No hay métricas disponibles para agregar.",
    "Remove a metric to add a new one": "Elimine una métrica para agregar una nueva.",
    "Add metrics info": "Agregue métricas para establecer objetivos del plan y realizar un seguimiento de los cambios.",
    "chartSettingsFieldsFormulasPath": "Configuración del organigrama: campos y fórmulas",
    "Create Table": "Crear tabla",
    "Entity details": "Detalles de {entity}",
    "planNoChartAccess": "Necesita acceso al organigrama de origen para ver este plan. Contacte a su administrador para solicitar acceso.",
    "Position Location": "Ubicación del puesto",
    "Employee SupervisorID": "ID del supervisor del empleado",
    "Employee Location": "Ubicación del empleado",
    "Position Title": "Título del puesto",
    "Position Division": "División del puesto",
    "Employee Title": "Título del empleado",
    "Position Budgeted Salary": "Salario presupuestado del puesto",
    "Position Cost Center": "Centro de costos del puesto",
    "Position Cost Band Minimum": "Banda salarial mínima del puesto",
    "Position Cost Band Midpoint": "Banda salarial media del puesto",
    "Position Cost Band Maximum": "Banda salarial máxima del puesto",
    "Employee Salary": "Compensación del empleado",
    "Employee Pay": "Compensación acumulada del empleado",
    "Employee Cost Center": "Centro de costos del empleado",
    "DesiredHolders": "Dotación objetivo",
    "Build Position Doc": "¿Qué puesto desea colocar en la parte superior de este {document}?",
    "levelcharthelp": "Seleccione un campo para crear el organigrama por nivel. Todas las ramas usarán el estilo árbol.",
    "Select up to 3 fields": "Seleccione hasta 3 campos que se mostrarán en la parte superior de la tarjeta de perfil.",
    "Enable profile starring": "Campos de perfil favoritos (definidos por el usuario)",
    "Enterprise source limit": "Las cuentas empresariales pueden agregar hasta 10 fuentes de datos.",
    "livechartnotfound": "No se encontró el organigrama base asociado y no se puede sincronizar. Puede crear nuevos organigramas personalizados a partir de organigramas base existentes.",
    "chartnotfound": "No se encontró el organigrama base asociado y no se puede sincronizar. Puede crear nuevos organigramas personalizados. Este organigrama seguirá disponible para su edición o exportación.",
    "changePaylocity": "Para problemas relacionados con su integración de paylocity, o para configurar una nueva integración, comuníquese con",
    "changeSage300za": "El punto de conexión de API de esta integración debe ser configurado por el equipo de soporte. Para configurarlo, comuníquese con ",
    "Cannot add plan top box to talent pool": "No se puede agregar el cuadro superior del plan al grupo de talentos.",
    "Failed to remove talent": "Error al eliminar el talento.",
    "refreshemail": "Ingrese las direcciones de correo electrónico de los usuarios que deben recibir alertas.",
    "autoexportemail": "Ingrese las direcciones de correo electrónico de los usuarios que deben recibir exportaciones automáticas.",
    "invalidcharwarn": "Ciertos caracteres no están disponibles para nombres de campos. Puede utilizar la función de etiqueta de campo para agregar caracteres como '$'.",
    "The scope of the export exceeds your account's box limit": "El alcance de la exportación excede el límite de cuadros de su cuenta. Reduzca el alcance de la exportación o contacte a clientsuccess@theorgchart.com para aumentar su límite.",
    "One or more scope options is disabled because they exceed the maximum box limit for custom charts": "Una o más opciones de alcance están deshabilitadas porque exceden el límite de cuadros para organigramas personalizados. Un administrador puede configurar esto en la configuración.",
    "invalidemailmessage": "Ingrese una dirección de correo electrónico válida en la configuración de actualización programada para poder guardar los cambios.",
    "autoemailmessage": "Ingrese una dirección de correo electrónico válida en la configuración de exportación automática para poder guardar los cambios.",
    "Dayforce reset info": "La API de dayforce detecta cambios solo entre la última y la actualización actual de datos. Si ha realizado cambios significativos en su integración, haga clic en {resetLabel} para establecer una nueva línea base de datos durante la próxima sincronización nocturna.",
    "Confirm reset integration": "¿Está seguro de que desea restablecer su integración actual? Esta acción no se puede deshacer. Advertencia: la próxima actualización de datos puede tardar más.",
    "You are over your seat limit": "Ha alcanzado su límite de licencias de lectura/escritura. Puede liberar licencias convirtiendo usuarios existentes a licencias de solo lectura. Para comprar licencias adicionales, contacte a",
    "deletesingleuser": "Eliminar usuario",
    "enableFields": "Permitir alternancia interactiva de campos",
    "Reports to removed": "El registro ya no existe. Busque un nuevo 'Reporta a' o deshaga el cambio del plan para volver al origen.",
    "createWebLink": "Crear enlaces web",
    "recordDetails": "Detalles del registro",
    "chartExplorerWarn": "No tiene acceso al explorador de organigramas debido a su perfil de interfaz.",
    "contactAdmin": "Contacte a su administrador.",
    "Are you sure you want to delete background": "¿Está seguro de que desea eliminar este fondo? Los organigramas vinculados a este fondo ya no podrán cargarlo.",
    "Are you sure you want to move background": "¿Está seguro de que desea mover este fondo? Los organigramas vinculados a este fondo podrían no poder cargarlo.",
    "transferAttributesInfoText": "Transfiera atributos de usuario del proveedor de identidad (IDP) a la aplicación para una gestión mejorada de perfiles.",
    "transferAttributeLabel": "Transferir atributos de usuario",
    "Set default background": "Haga clic aquí para establecer el fondo predeterminado",
    "Load field mapping now": "¿Cargar el mapeo de campos ahora?",
    "Load field mapping info": "Se requiere un mapeo de campos válido para crear organigramas. OrgChart intentará determinar un mapeo apropiado, aunque algunos ajustes manuales pueden ser necesarios.",
    "lastrulemessage": "No puede eliminar la última regla de una vista. Para eliminar esta regla, agregue primero otra regla a la vista.",
    "duplicatedrop": "Activar para evitar que se agreguen registros duplicados al organigrama",
    "deleteuserdelegate1": "Este usuario tiene al menos un usuario secundario asociado en otras",
    "deleteuserdelegate2": "Si elimina este usuario, también se eliminarán todos los usuarios secundarios con el mismo correo electrónico en otras cuentas. ¿Está seguro de que desea eliminar estos usuarios?",
    "confirmdeletedelegate": "Eliminar usuarios principal y secundarios",
    "denydeletedelegate": "No eliminar",
    "Send all files to trash": "¿Está seguro de que desea enviar {fileCount} archivos de la carpeta '{folder}' a la papelera?",
    "Delete all files trash": "¿Está seguro de que desea eliminar {fileCount} archivos de la papelera? Esta acción no se puede deshacer.",
    "Permanently delete file": "¿Eliminar archivo permanentemente?",
    "Move files to trash": "Mover a la papelera",
    "Move all files to trash": "¿Mover archivos a la papelera?",
    "Delete all files": "¿Eliminar todos los archivos?",
    "Choose unique name": "Elija un nombre único.",
    "disableIndexSwitch": "La opción de página de índice solo está disponible para exportaciones de organigrama completo. Vaya a la pestaña general y actualice el alcance a organigrama completo.",
    "Generic insufficient permissions": "No tiene permiso para realizar esta acción debido a su grupo de acceso o rol. Contacte a su administrador del sistema.",
    "Folder locked": "Esta carpeta está bloqueada. No puede modificar el contenido de carpetas bloqueadas.",
    "No append tables (long)": "Aún no tiene tablas configuradas. Cree una tabla para administrar y modificar registros.",
    "New Table (name)": "Nueva tabla",
    "Modifications shown here (long)": "Todos los tipos de modificaciones se registrarán aquí en una vista de tabla.",
    "Manage tables info (long)": "Administre sus tablas existentes o cree una nueva para aplicar a su organigrama base.",
    "Additional field in use (long)": "Un nombre de campo se utiliza más de una vez. Verifique la tabla para asegurar que todos los nombres de campos sean únicos antes de guardar.",
    "Additional field is reserved (long)": "Uno o más nombres de campos están reservados. Verifique la tabla para asegurar que todos los nombres de campos sean únicos antes de guardar.",
    "Name is reserved": "Nombre reservado.",
    "Name already in use": "Nombre en uso.",
    "Errors in form": "Tiene cambios sin guardar, pero hay errores que deben resolverse antes de guardar. ¿Desea resolver los problemas o descartar sus cambios?",
    "About append table (long)": "La tabla adjunta le permite administrar registros en organigramas existentes. Busque un empleado o puesto existente para modificar, mover o eliminar. También puede agregar registros o usar los botones de carga/descarga para administrar registros en masa.",
    "About additional fields (long)": "Use su tabla adjunta para agregar nuevos campos a sus datos. No puede cambiar el nombre de los campos adicionales una vez creados.",
    "No Table Selected": "Ninguna tabla seleccionada",
    "Modification history": "Historial de modificaciones",
    "Modification history tip": "Todos los cambios se guardan automáticamente.",
    "Number of modifications": "Número de modificaciones realizadas en esta tabla",
    "Number of additional fields": "Número de campos agregados a esta tabla",
    "Changes have been saved": "Los cambios se han guardado.",
    "An error occurred while saving": "Se produjo un error al guardar.",
    "Active table set": "{tableName} establecida como tabla activa.",
    "Entity not found": "{entity} no encontrado",
    "Entity created": "{tableName} creado.",
    "Entity changes saved": "Cambios de {entity} guardados.",
    "Are you sure you want to delete entity": "¿Está seguro de que desea eliminar {entity}?",
    "Entity deleted": "{entity} eliminado.",
    "Entity copied": "Copia de {entity} creada",
    "Entity renamed": "{oldEntity} cambiado a {newEntity}",
    "Entity set as default": "{entity} establecido como predeterminado",
    "Entity i": "{entity} {i}",
    "Entity name": "Nombre de {entity}",
    "Add entity": "Agregar {entity}",
    "Create entity": "Crear {entity}",
    "Edit entity": "Editar {entity}",
    "Copy entity": "Copiar {entity}",
    "Entity saved": "{entity} guardado.",
    "Edit entity details": "Editar detalles de {entity}",
    "Entity name cannot be empty": "El nombre de {entity} no puede estar vacío.",
    "Number of entity applied to the chart": "Número de {entity} aplicados al organigrama.",
    "Fill all fields {entity}": "Todos los campos obligatorios deben completarse antes de poder guardar {entity}.",
    "Invalid date range": "Rango de fechas no válido. La fecha \"Desde\" debe ser anterior a la fecha \"Hasta\".",
    "Invalid numeric range": "Rango numérico no válido. El valor inicial debe ser menor que el valor final.",
    "Invalid range on criteria {n}": "Rango numérico no válido en el criterio {n}. El valor inicial debe ser menor que el valor final.",
    "Invalid date range on criteria {n}": "Rango de fechas no válido en el criterio {n}. La fecha \"Desde\" debe ser anterior a la fecha \"Hasta\".",
    "Missing required field": "Campo obligatorio faltante.",
    "Missing required field on criteria {n}": "Campo obligatorio faltante en el criterio {n}.",
    "Criteria {n} {msg}": "Criterio {n}: {msg}",
    "Generic default error": "Se detectó un error.",
    "Generic toast error": "Se produjo un error. Inténtelo de nuevo.",
    "Table name must be at least 4 characters and unique": "El nombre de la tabla debe tener al menos 4 caracteres y ser único.",
    "Chart fields changed (long)": "Los campos del organigrama han cambiado. Actualice su organigrama.",
    "Update Base Chart Mapping": "¿Actualizar el mapeo del organigrama base?",
    "Update Base Chart Mapping (long)": "¿Desea que OrgChart actualice el mapeo de su organigrama base para usar su nuevo campo de informe adicional?",
    "Update Base Chart Mapping (info)": "El mapeo de informes se puede ajustar en {mappingPath} en la sección {AuxRepMapping}.",
    "Delete additional field": "¿Eliminar campo adicional?",
    "Delete additional field (long)": "¿Está seguro de que desea eliminar el campo {name}?",
    "Broken field references warning": "Las referencias a este campo (estilos de cuadro, perfil y otras opciones de formato) ya no se mostrarán correctamente.",
    "Additional reports limit": "El sistema le permite agregar hasta cuatro asignaciones de supervisor adicionales.",
    "Additional reports info": "Los informes adicionales se pueden agregar rápidamente aquí y administrar en {mappingPath}.",
    "mappingPath": "Configuración del organigrama: mapeo",
    "You cannot rename the additional fields once they have been created": "No puede cambiar el nombre de los campos adicionales una vez creados.",
    "Refresh chart notice": "Actualice su organigrama para ver los últimos cambios.",
    "Confirm copy base chart": "Un organigrama base es su fundamento y normalmente solo necesita uno. Puede crear múltiples {customCharts} a partir de un solo organigrama base para modificar el formato, las líneas de reporte y otras configuraciones.",
    "Are you sure you want to copy base chart": "¿Está seguro de que desea copiar este organigrama base?",
    "Copy base chart": "¿Copiar organigrama base?",
    "Delete base chart": "¿Eliminar organigrama base?",
    "What type of chart are you creating": "¿Qué tipo de organigrama está creando?",
    "Confirm delete base chart": "Eliminar un organigrama base lo eliminará permanentemente. Los planes y organigramas personalizados que usan este organigrama base ya no podrán acceder a los datos. Esta acción no se puede deshacer.",
    "Base Employee Chart": "Organigrama base de empleados",
    "Base Position Chart": "Organigrama base de puestos",
    "Custom Employee Chart": "Organigrama personalizado de empleados",
    "Custom Position Chart": "Organigrama personalizado de puestos",
    "Employee Chart Plan": "Plan de organigrama de empleados",
    "Position Chart Plan": "Plan de organigrama de puestos",
    "Employee Chart Details": "Un organigrama centrado en las personas que visualiza las relaciones entre empleados individuales, mostrando conexiones directas independientemente de la estructura formal de puestos.",
    "Position Chart Details": "Un organigrama centrado en los puestos que muestra la jerarquía formal de su organización basada en roles y puestos en lugar de las personas que los ocupan.",
    "Position Chart Disabled": "Para habilitar esta función, comuníquese con el soporte al cliente.",
    "Position Chart Coming Soon": "El organigrama de puestos estará disponible próximamente.",
    "Select employee chart type": "Cambiar a un tipo de organigrama de empleados",
    "Select position chart type": "Cambiar a un tipo de organigrama de puestos",
    "characters remaining": "{count} caracteres restantes",
    "Switch chart types": "¿Cambiar tipos de organigrama?",
    "Switch chart type (long)": "Cambiar el tipo de organigrama requerirá que vuelva a seleccionar una fuente de datos.",
    "Select fields and assign them as either holder fields, position fields, or both": "Seleccione campos y asígnelos como campos de titular, campos de puesto o ambos usando los botones a continuación.",
    "Chart plan": "Plan de {chart}",
    "Plan Objective": "¿Cuál es el objetivo para crear este plan?",
    "planobjective": "Objetivo del plan",
    "Plan Objective Help": "Obtenga más información sobre los objetivos del plan en nuestro",
    "Plan Objective Help Link": "Centro de ayuda",
    "Assigned Out Of Scope": "Asignado*",
    "Assigned Out Of Scope Info": "Asignado fuera del alcance del plan",
    "Choose what type of position data": "Elija qué tipo de datos desea usar para crear su organigrama de puestos",
    "costband": "Banda de costos (por empleado)",
    "costbandinfo": "Establezca un rango de costos mínimo y máximo por empleado para monitorear el impacto presupuestario.",
    "Multi position editor changes info": "Cualquier cambio que realice en los siguientes campos se aplicará a los {count} {positions} que seleccionó.",
    "Reopen position editor changes info": "Puede {__reopenTheCountPosition__}, pero los empleados asignados en el momento del cierre {__wontBeAutomaticallyReassigned__} al puesto.",
    "Successfully updated positions": "{count} {positions} actualizados exitosamente",
    "Failed to update positions": "No se pudieron actualizar los puestos. Inténtelo de nuevo.",
    "costbanderror": "El mínimo de la banda de costos debe ser menor que el máximo de la banda de costos",
    "startenddateerror": "La fecha de inicio debe ser anterior a la fecha de fin",
    "staffingtargeterror": "El objetivo de dotación debe ser mayor que 0",
    "Show more entity": "Mostrar más {entity}",
    "Show less entity": "Mostrar menos {entity}",
    "staffingtargetinfo": "Representa el número máximo deseado de empleados asignados a este puesto. Aún puede asignar tantos empleados como considere necesario.",
    "System generated positions": "Este campo se genera automáticamente utilizando la estructura de reporte de empleado a empleado.",
    "System generated item": "{item} (Generado por el sistema)",
    "Pricing and Packaging": "Precios y paquetes",
    "accessGroupLimit": "Ha alcanzado el límite para agregar grupos de acceso. Comuníquese con soporte en support@theorgchart.com para obtener ayuda",
    "Box count tooltip": "Número total de cuadros en el {document} actualmente abierto.",
    "Boxes shown tooltip": "El número de cuadros mostrados en el {document} actualmente abierto.",
    "All staged records tooltip": "Número total de registros en el panel de preparación del organigrama personalizado actualmente abierto. Los registros pueden terminar en el panel de preparación si su supervisor ha sido filtrado del organigrama, o si los movió manualmente allí.",
    "Levels tooltip": "Número de niveles organizacionales mostrados en el {document} actualmente abierto.",
    "Disconnected records tooltip": "Número total de cuadros desconectados en el organigrama actualmente abierto. Los cuadros desconectados pueden tener identificadores de supervisor faltantes o inválidos, o pueden no reportar a otros registros en el árbol de reporte principal del organigrama base.",
    "Employee is unassigned from position": "{employee} ha sido desasignado de {position}.",
    "Employee is assigned to position": "{employee} ha sido asignado a {position}.",
    "{count} {employees} are assigned to {position}": "{count} {employees} han sido asignados a {position}.",
    "{count} {employees} are unassigned from {position}": "{count} {employees} han sido desasignados de {position}.",
    "totalHoldersCount employees are unassigned from entity": "{totalHoldersCountEmployees} han sido desasignados de {entity}.",
    "totalHoldersCount employees are unassigned from their positions": "{totalHoldersCountEmployees} han sido desasignados de sus puestos.",
    "totalHoldersCount employees are released from entity": "{totalHoldersCountEmployees} han sido liberados de {entity}.",
    "totalHoldersCount employees are released from their positions": "{totalHoldersCountEmployees} han sido liberados de sus puestos.",
    "Subordinate moved to parent": "{subordinate} se movió a {parent}.",
    "Subordinate moved from position to position": "{fromPosition} se movió a {toPosition}.",
    "Unassigned employees can be found in the Employee List": "Los empleados no asignados se pueden encontrar en la lista de empleados.",
    "Are you sure you want to unassign employee from the position position?": "¿Está seguro de que desea desasignar a {employee} del puesto {position}?",
    "Are you sure you want to unassign totalHoldersCount employees from the position position?": "¿Está seguro de que desea desasignar a {totalHoldersCountEmployees} del puesto {position}?",
    "Are you sure you want to unassign totalHoldersCount employees from the following positions?": "¿Está seguro de que desea desasignar a {totalHoldersCountEmployees} de los siguientes puestos?",
    "Released employees can be found in the Employee List": "Los empleados liberados se pueden encontrar en la lista de empleados.",
    "Are you sure you want to release employee from the position position?": "¿Está seguro de que desea liberar a {employee} del puesto {position}?",
    "Are you sure you want to release totalHoldersCount employees from the position position?": "¿Está seguro de que desea liberar a {totalHoldersCountEmployees} del puesto {position}?",
    "Are you sure you want to release totalHoldersCount employees from the following positions?": "¿Está seguro de que desea liberar a {totalHoldersCountEmployees} de los siguientes puestos?",
    "Reopen position multi": "Reabrir puesto(s)",
    "Are you sure you want to close the following position?": "¿Está seguro de que desea cerrar el siguiente {__position__}?",
    "The entity is closed": "El {entity} está cerrado.",
    "Entities are closed": "{__entities__} están cerrados.",
    "The entity is reopened": "El {entity} está reabierto.",
    "Entities are reopened": "{__entities__} están reabiertos.",
    "Entity has been reopened": "{entity} ha sido reabierto.",
    "Entity has been updated": "{entity} ha sido actualizado.",
    "eymappingerror": "No se ha establecido ningún mapeo para el organigrama EY. Configure manualmente el mapeo para terminar de cargar los datos del organigrama.",
    "Confirm remove assignment": "¿Está seguro de que desea eliminar a este empleado de este puesto?",
    "Confirm reassign employee": "¿Está seguro de que desea reasignar a este empleado?",
    "Employee reassignment": "Este empleado está actualmente asignado a {title}: {id}. Será trasladado cuando guarde sus cambios.",
    "Employee unassignment": "Este empleado será desasignado de {title}: {id} cuando guarde sus cambios",
    "autogenerated": "generado automáticamente",
    "How many position copies": "¿Cuántas copias de {title}: {id} desea crear?",
    "formulasLimit": "Ha alcanzado el límite para agregar fórmulas personalizadas. Comuníquese con soporte en support@theorgchart.com para obtener ayuda",
    "overbudget": "por encima del presupuesto",
    "underbudget": "por debajo del presupuesto",
    "Enable cost band info": "Para ver cómo la asignación de empleados afecta el presupuesto del puesto, active la configuración de banda de costos en configuración del organigrama: mapeo.",
    "Unable to create positions": "No se pudieron crear el/los puesto(s). Inténtelo de nuevo.",
    "Clone position success": "El {entity} ha sido clonado.",
    "How many new position copies": "¿Cuántas copias de puestos desea crear?",
    "Create position success": "El/los puesto(s) {entity} creado(s).",
    "Position selected": "Puesto seleccionado: {title}: {id}",
    "There are number assignment issues": "Hay {count} {text} con los empleados que está asignando a este puesto.",
    "assignment state issues": "problema(s) de estado de asignación",
    "is currently status": "está actualmente {status}",
    "is currently assigned to position": "está actualmente asignado a {title}: {id}.",
    "is currently assigned to position id": "está actualmente asignado a {id}.",
    "assigned and out of scope to": "asignado y fuera del alcance a {id}.",
    "assigned and out of scope to position": "asignado y fuera del alcance a {title}: {id}.",
    "Are you sure you want to assign them to position": "¿Está seguro de que desea asignarlos a {title}: {id}?",
    "has an unknown assignment status": "tiene un estado de asignación desconocido.",
    "conditional rls message": "Actualice para agregar seguridad condicional a nivel de fila y restringir a los usuarios de ver solo ciertos campos para ciertos registros.",
    "conditional rls template": "Actualice para agregar seguridad {conditional row level} y restringir a los usuarios de ver solo ciertos campos para ciertos registros.",
    "grouping message": "Actualice para usar la agrupación para agrupar empleados por ubicación, departamento o título para visualizaciones más compactas y concisas.",
    "grouping template": "Actualice para usar la agrupación para agrupar empleados por ubicación, departamento o título para visualizaciones más {compact and concise}.",
    "Delete plan message": "Eliminar este plan lo eliminará permanentemente. Esta acción no se puede deshacer.",
    "custom chart trash": "Mover organigrama personalizado a la papelera",
    "custom chart trash message": "Mover el organigrama personalizado a la papelera lo eliminará de esta carpeta. Puede recuperar organigramas personalizados de la papelera arrastrándolos a una carpeta diferente.",
    "custom chart delete": "Eliminar organigrama personalizado",
    "custom chart delete message": "Eliminar este organigrama personalizado lo eliminará permanentemente de su cuenta. Esta acción no se puede deshacer.",
    "Cost band help": "Use las bandas de costos para presupuestos, comparación salarial e información sobre variaciones. Si no todos los campos están mapeados, el sistema puede generar los valores faltantes usando fórmulas predefinidas. Para más información, visite nuestro {Help Center}",
    "Position budget help": "El cálculo del presupuesto del puesto utilizará este campo cuando esté mapeado, o calculará a partir de los datos de banda de costos si no está mapeado.",
    "Plan no longer exists (long)": "El plan actualmente abierto ha sido eliminado por otro usuario. Elija un plan existente o cree uno nuevo para continuar con la planificación.",
    "bls upgrade message": "Actualice para agregar seguridad a nivel de rama para restringir a los usuarios a ver solo ciertas partes del organigrama, como su departamento.",
    "bls upgrade template": "Actualice para agregar seguridad {branch level} para restringir a los usuarios a ver solo ciertas partes del organigrama, como su departamento.",
    "plan approvals upgrade message": "Un sistema de aprobación de planes que permite un proceso controlado de revisión y aprobación con múltiples aprobadores, seguimiento de estado y notificaciones por correo electrónico.",
    "plan approvals upgrade template": "Un {plan approval system} que permite un proceso controlado de revisión y aprobación con múltiples aprobadores, seguimiento de estado y notificaciones por correo electrónico.",
    "ag upgrade message": "Actualice para agregar grupos de acceso adicionales, para un control granular sobre permisos futuros y seguridad de datos.",
    "ag upgrade template": "Actualice para agregar grupos de acceso adicionales, para {granular control} sobre permisos futuros y seguridad de datos.",
    "changes message": "Actualice para rastrear los cambios de datos, formato y paginación que realiza en su organigrama personalizado. Audite quién realizó cada cambio y revierta fácilmente los cambios anteriores.",
    "functional chart message": "Actualice para crear un organigrama funcional para visualizar su organización por función, es decir, departamento, y superponer su jerarquía funcional sobre su estructura organizacional estándar.",
    "formulas message": "Actualice para agregar más fórmulas para calcular métricas de conteos de personal personalizados, acumulaciones de costos y más.",
    "formulas template": "Actualice para agregar más fórmulas para {calculate metrics} de conteos de personal personalizados, acumulaciones de costos y más.",
    "ar upgrade message": "Actualice para visualizar a los empleados que reportan a más de un supervisor para una representación más precisa de roles y responsabilidades compartidos.",
    "ar upgrade template": "Actualice para visualizar a los empleados que reportan a más de un supervisor para una {accurate depiction} de roles y responsabilidades compartidos.",
    "auto assign upgrade message": "Actualice para configurar OrgChart para asignar automáticamente grupos de acceso a los usuarios según sus datos de empleados.",
    "auto assign upgrade template": "Actualice para configurar OrgChart para {automatically assign} grupos de acceso a los usuarios según sus datos de empleados.",
    "pit archive message": "Asegúrese de que los organigramas se capturen y almacenen de forma segura con capacidades de archivado automático.",
    "pit archive template": "Asegúrese de que los organigramas sean {securely captured} y almacenados con capacidades de archivado automático.",
    "pit org message": "Revise las estructuras organizacionales pasadas para identificar patrones en contratación, rotación y cambios, ayudándole a tomar decisiones más informadas.",
    "pit org template": "Revise las estructuras organizacionales pasadas para {identify patterns} en contratación, rotación y cambios, ayudándole a tomar decisiones más informadas.",
    "pit audit message": "Comparta fácilmente organigramas históricos para auditorías, cumplimiento y presentaciones.",
    "pit audit template": "Comparta fácilmente organigramas {share historical} para auditorías, cumplimiento y presentaciones.",
    "addSourcesLimit": "Ha alcanzado el límite para agregar fuentes de datos adicionales. Comuníquese con soporte en support@theorgchart.com para obtener ayuda",
    "append message": "Actualice para agregar automáticamente datos de sistemas de RR. HH. adicionales o archivos de hojas de cálculo para visualizar más información como vacantes o contratistas.",
    "append template": "Actualice para agregar automáticamente datos de {additional HR systems} o archivos de hojas de cálculo para visualizar más información como {vacancies or contractors}.",
    "merge message": "Actualice para agregar automáticamente datos de sistemas de RR. HH. adicionales o archivos de hojas de cálculo para enriquecer su visualización de datos con información como supervisores secundarios.",
    "merge template": "Actualice para agregar automáticamente datos de {additional HR systems} o archivos de hojas de cálculo para enriquecer su visualización de datos con información como {secondary managers}.",
    "planning upgrade message": "Actualice para planificar con confianza con datos precisos de puestos, herramientas colaborativas e información sobre salarios, alcance de control y rendimiento para guiar las decisiones estructurales.",
    "plan position data message": "Planifique estratégicamente para el futuro con datos precisos de puestos. Analice puestos y vacantes por salario, alcance de control, rendimiento y más para proporcionar la mejor perspectiva de su estructura.",
    "plan position data template": "Planifique estratégicamente para el futuro con datos precisos de puestos. Analice {positions and vacancies} por salario, alcance de control, rendimiento y más para proporcionar la mejor {insight} de su estructura.",
    "track kpis message": "Asegúrese de que sus planes estén configurados para el éxito. Analice el impacto de sus planes propuestos estableciendo y rastreando objetivos para presupuesto, recuento de personal y más.",
    "track kpis template": "Asegúrese de que sus planes estén configurados para el éxito. Analice el {impact} de sus planes propuestos {setting and tracking} objetivos para presupuesto, recuento de personal y más.",
    "collaborate message": "Trabaje junto a sus colegas para arrastrar y soltar puestos, mover grupos de empleados y asegurar que su equipo esté al tanto del impacto de los cambios propuestos.",
    "collaborate template": "Trabaje junto a sus colegas para {drag and drop} puestos, {move groups} de empleados y asegurar que su {team is aware} del impacto de los cambios propuestos.",
    "System calculation requires both Staffing target and Cost band maximum to be mapped": "El cálculo del sistema requiere que tanto el objetivo de dotación como el máximo de la banda de costos estén mapeados.",
    "System generate Position Budget": "Este campo se calculará como: Objetivo de dotación × máximo de la banda de costos",
    "Cost band max staffing target position budget": "{costBandMax} × {desiredHolders} = salario presupuestado del puesto",
    "This is driven by the position budget field": "Esto está determinado por el campo {field}.",
    "Record out of scope info": "Para editar los detalles de este empleado, debe asignarlo a un puesto en este plan.",
    "rlsallowedtoggleinfo": "Los campos permitidos activados se muestran",
    "rlsrestrictedtoggleinfo": "Los campos restringidos activados están ocultos",
    "rlsconditionaltoggleinfo": "Los campos activados se muestran según las reglas condicionales",
    "rlsuserrecordnotfound": "Su perfil de seguridad requiere su registro en este organigrama, pero no se pudo encontrar su registro. Comuníquese con su administrador del sistema.",
    "Position Management enables you to visualize your employees and positions separately to gain better insight in your open roles and key position details": "La gestión de puestos le permite visualizar a sus empleados y puestos por separado para obtener una mejor perspectiva de sus roles abiertos y los detalles clave de los puestos.",
    "Multiple parent positions rollup alert": "Algunos puestos que está eliminando tienen subordinados que les reportan. ¿Qué desea hacer con estos puestos subordinados?",
    "Invalid target value": "El valor objetivo debe ser un número.",
    "noPositionSelectedTooltipInfo": "Seleccione un puesto para habilitar esta acción.",
    "onlyActivePositionsSelectedTooltipInfo": "El/los puesto(s) seleccionado(s) están activos.",
    "onlyClosedPositionsSelectedTooltipInfo": "El/los puesto(s) seleccionado(s) están cerrados y deben reabrirse para realizar cambios.",
    "multiplePositionsSelectedTooltipInfo": "Seleccione solo un puesto para clonar a la vez.",
    "closedOrUnassignedPositionsSelectedTooltipInfo": "El/los puesto(s) seleccionado(s) no tienen asignaciones.",
    "Revert all position changes info": "Puede revertir todos los cambios asociados con este puesto, pero los empleados asignados en el momento del cierre {positionRevertWarning}. Para revertir empleados a su puesto de origen, vaya a su ventana de detalles de empleado.",
    "Revert all position confirm": "¿Está seguro de que desea revertir todos los cambios realizados en este puesto?",
    "positionRevertWarning": "no serán reasignados automáticamente",
    "This action cannot be undone": "Esta acción no se puede deshacer.",
    "daterange": "rango de fechas",
    "Retain vacant supervisory positions": "Retener puestos vacantes",
    "Retain vacant supervisory positions info": "OrgChart genera puestos vacantes en su organigrama cuando los empleados son eliminados de su fuente de datos. Esto preserva la estructura de su organización y le permite reasignar o planificar estos roles críticos. La tabla de datos adjuntos se utiliza para gestionar estos puestos vacantes generados por el sistema.",
    "Retain positions": "Uno o más empleados fueron {removedFromDataSet}. Para retener sus roles, OrgChart ha {createdPositions} su estructura organizacional. Use la {appendTable} para ajustar estos puestos según sea necesario.",
    "Retain position info": "Retenga puestos en su organigrama cuando los empleados asignados son eliminados de su fuente de datos. Esto preserva su estructura organizacional y le permite reasignar o planificar estos roles críticos.",
    "Auto purge vacant positions": "Purga automática de puestos vacantes",
    "Auto purge vacant positions info": "Elimine automáticamente los puestos vacantes después de un período especificado para mantener su organigrama actualizado.",
    "Purge positions after": "Purgar puestos después de:",
    "Employee profile desc": "La tarjeta de perfil del empleado muestra los datos del empleado. Elija a continuación qué datos del empleado desea mostrar en la tarjeta de perfil del empleado.",
    "Position profile desc": "La tarjeta de perfil del puesto muestra los datos del puesto. Elija a continuación qué datos desea mostrar en la tarjeta de perfil del puesto.",
    "Additional {type} information desc": "La información adicional de {type} se muestra debajo de los campos favoritos.",
    "Position information unavailable": "La información del puesto no está disponible. Cambie a un organigrama de puestos para ver y gestionar los registros de puestos.",
    "Retain only vacant with subs": "Retener solo puestos vacantes con subordinados",
    "Clear vacant positions after info": "Elimine los puestos vacantes generados por el sistema después de un período definido que ya no sean necesarios para preservar su estructura organizacional. Si desea mantener siempre estos puestos vacantes en su organigrama, desactive este interruptor.",
    "__blocked__": "(oculto)",
    "profile preview": "Vista previa del perfil",
    "No assignees yet": "Aún no hay asignados.",
    "blockedmetrictip": "Esta métrica no está disponible ya que no tiene permiso para ver todos los valores utilizados para este cálculo. Para ver este número, ingrese un valor de trabajo para los campos utilizados para este cálculo que están marcados como \"oculto\".",
    "compensationaccesstip": "No tiene acceso a los datos de compensación reales de este empleado.",
    "recordeditorcompaccesstip": "No tiene acceso al valor real de algunos campos. Puede ingresar un valor provisional para los valores ocultos con fines de planificación.",
    "No holders in preview": "Todos los puestos están vacantes. No hay asignados para previsualizar.",
    "Force queue refresh question": "¿Forzar actualización de la cola?",
    "Refresh Queue Info": "¿Desea forzar este organigrama en la cola de actualización inmediatamente? El organigrama se actualizará en segundo plano.",
    "photoRefreshChoice": "¿Desea forzar la recarga de todas las fotos durante este proceso?",
    "Chart added to the refresh queue": "Organigrama agregado a la cola de actualización exitosamente",
    "Conflict record detected": "Conflicto detectado",
    "Maximum approvers allowed. Please remove some approvers.": "Máximo de {approverLimit} aprobadores permitidos. Elimine algunos aprobadores.",
    "Plan submitted for approval successfully": "Plan enviado para aprobación exitosamente.",
    "Failed to submit plan request": "No se pudo enviar la solicitud del plan.",
    "Plan request withdrawn successfully": "Solicitud del plan retirada exitosamente.",
    "Failed to withdraw plan request": "No se pudo retirar la solicitud del plan.",
    "Plan approved successfully": "Plan aprobado exitosamente.",
    "Failed to approve plan": "No se pudo aprobar el plan.",
    "Plan rejected": "Plan rechazado.",
    "Failed to reject plan": "No se pudo rechazar el plan.",
    "Plan already submitted": "Plan ya enviado.",
    "No active plan request to withdraw": "No hay solicitud de plan activa para retirar.",
    "Plan submission withdrawn successfully": "Envío del plan retirado exitosamente.",
    "Failed to submit plan submission": "No se pudo enviar la presentación del plan.",
    "Failed to withdraw plan submission": "No se pudo retirar la presentación del plan.",
    "No active plan submission to withdraw": "No hay presentación de plan activa para retirar.",
    "Approvers label": "Aprobador(es)",
    "Some approvers need access": "Algunos aprobadores no pueden acceder al plan",
    "Some approvers need access info": "{reviewersWithoutPlanAccessCount} de {totalReviewerCount} aprobadores que está agregando no tienen acceso al plan. Otórgueles acceso de visualización ahora, o puede agregarlos más tarde antes de que comiencen su revisión.",
    "Select approvers for this plan": "Seleccionar aprobador(es) para este plan",
    "Maximum approvers": "Máximo de {approverLimit} aprobadores",
    "Refresh Formula Info": "¿Desea forzar el recálculo de todas las fórmulas para este organigrama? Esto actualizará los valores calculados sin actualizar todo el organigrama.",
    "Force calculate formulas question": "¿Forzar cálculo de fórmulas?",
    "This plan is awaiting approval": "Este plan está esperando aprobación de {reviewerNames}.",
    "This plan is locked and cannot be edited.": "Este plan está {status} y no se puede editar.",
    "Plan owners can unlock the plan in the Plan Explorer by hovering over the plan": "Los propietarios del plan pueden desbloquear el plan en el explorador de planes pasando el cursor sobre el plan y luego haciendo clic en el icono ⋮.",
    "You have already approved this plan": "Ya ha aprobado este plan.",
    "You have already rejected this plan": "Ya ha rechazado este plan.",
    "LocalizationSettingsDesc": "Agregue la capacidad para que sus usuarios vean los datos de su organigrama en su idioma preferido. Agregue los mapeos de campos deseados que controlarán las traducciones mostradas.",
    "NoLocalizationData": "Aún no se han agregado configuraciones de idioma.",
    "Closed positions remain in your chart and table view, but can be filtered out": "Los puestos cerrados permanecen en su organigrama y vista de tabla, pero se pueden filtrar.",
    "Cannot move record": "No se puede mover el registro",
    "You cannot move employees to closed positions.": "No puede mover empleados a puestos cerrados.",
    "You cannot move this record under a closed position.": "No puede mover este registro bajo un puesto cerrado.",
    "supportContactGeneric": "su equipo de soporte o servicio",
    "genericAccessGroupLimit": "Ha alcanzado el límite para agregar grupos de acceso. Comuníquese con su equipo de soporte o servicio para obtener ayuda.",
    "genericFormulasLimit": "Ha alcanzado el límite para agregar fórmulas personalizadas. Comuníquese con su equipo de soporte o servicio para obtener ayuda.",
    "genericAddSourcesLimit": "Ha alcanzado el límite para agregar fuentes de datos adicionales. Comuníquese con su equipo de soporte o servicio para obtener ayuda.",
    "genericBoxLimit": "El alcance de la exportación excede el límite de cuadros de su cuenta. Reduzca el alcance de la exportación o comuníquese con su equipo de soporte o servicio para aumentar su límite.",
    "genericUnknownError": "Sistema no configurado. Comuníquese con su equipo de soporte o servicio.",
    "genericSharePointErr": "Error al configurar SharePoint. Comuníquese con su equipo de soporte o servicio.",
    "genericSupportMsg": "Si el problema persiste, comuníquese con su equipo de soporte o servicio.",
    "genericSalesMsg": "Para más información, comuníquese con su equipo de soporte o servicio.",
    "genericSupportDeskHelp": "Si el problema persiste, puede comunicarse con su equipo de soporte o servicio.",
    "Immediate days": "Días inmediatos",
    "Preview not available": "Vista previa no disponible. \\n actualice su organigrama e inténtelo de nuevo.",
    "Withdraw plan info message": "Retirar este plan eliminará todas las aprobaciones y devolverá el estado del plan a borrador. Luego podrá realizar cambios.",
    "blsNavigationRestricted": "Este registro está fuera de su ámbito de seguridad a nivel de rama. Solo puede navegar a registros dentro de su rama.",
    "Import Filters": "Filtros de importación",
    "Allowed legacy filters": "Filtros guardados permitidos (heredados)",
    "Allowed legacy highlights": "Destacados guardados permitidos (heredados)",
    "Now available: IF/IH": "Disponible ahora: Filtros y destacados interactivos en cualquier tipo de organigrama",
    "Now available: IF/IH detail": "Utilice el panel lateral derecho del organigrama para crear, gestionar y compartir filtros y destacados interactivos. Sus filtros guardados existentes siguen siendo accesibles. Obtenga más información sobre el uso de {link} en nuestra documentación de ayuda.",
    "Interactive filters and highlights": "filtros y destacados interactivos",
    "Choose a base chart:": "Elegir un organigrama base:",
    "A to Z": "A a Z",
    "Applied to views": "Aplicado a vistas",
    "Applied to:": "Aplicado a:",
    "Apply to new view": "Aplicar a nueva vista",
    "Back to box styles": "Volver a estilos de cuadro",
    "Box style library": "Biblioteca de estilos de cuadro",
    "Box style name": "Nombre del estilo de cuadro",
    "Box style type": "Tipo de estilo de cuadro",
    "Copy box style": "Copiar estilo de cuadro",
    "Revert box style": "Revertir estilo de cuadro",
    "Create and manage box styles for this chart. Apply box styles with a View.": "Cree y gestione estilos de cuadro para este organigrama. Aplique estilos de cuadro con una vista.",
    "Create box style": "Crear estilo de cuadro",
    "Delete box style": "Eliminar estilo de cuadro",
    "Delete box style confirmation": "Esta acción eliminará permanentemente el estilo de cuadro de su biblioteca. Las vistas que utilicen este estilo revertirán al predeterminado del sistema y deberá volver a aplicar un estilo de cuadro a esas reglas de vista.",
    "Edit box style": "Editar estilo de cuadro",
    "Employee box styles first": "Estilos de cuadro de empleado primero",
    "Go to a view:": "Ir a una vista:",
    "Group box styles first": "Estilos de cuadro de grupo primero",
    "Least used": "Menos utilizado",
    "Looking to create a strategic future plan?": "¿Desea crear un plan estratégico para el futuro?",
    "Most used": "Más utilizado",
    "No view rules reference this box style.": "Ninguna regla de vista hace referencia a este estilo de cuadro.",
    "Not applied to views": "No aplicado a vistas",
    "Position box styles first": "Estilos de cuadro de puesto primero",
    "Reset filters": "Restablecer filtros",
    "Search box styles": "Buscar estilos de cuadro",
    "Shared box styles first": "Estilos de cuadro compartidos primero",
    "System box styles first": "Estilos de cuadro del sistema primero",
    "The box style could not be copied": "No se pudo copiar el estilo de cuadro. Inténtelo de nuevo.",
    "The box style could not be deleted": "No se pudo eliminar el estilo de cuadro. Inténtelo de nuevo.",
    "The box style is applied to the following views. Click on the view to preview.": "El estilo de cuadro se aplica a las vistas siguientes. Haga clic en la vista para obtener una vista previa.",
    "Upgrade to add views": "Actualice para agregar vistas",
    "Z to A": "Z a A",
    "box style changes saved": "Cambios en el estilo de cuadro {box style name} guardados.",
    "box style created": "Estilo de cuadro {box style name} creado.",
    "edited": "editado",
    "box layout editor pending changes banner":
      "Los cambios como cambiar el nombre, copiar y eliminar en el editor de diseño de cuadro quedan pendientes hasta que los guarde o los descarte.",
    "1 box style with unsaved changes": "1 estilo de cuadro con cambios sin guardar.",
    "{n} box styles with unsaved changes": "{n} estilos de cuadro con cambios sin guardar.",
    "1 box style deleted": "1 estilo de cuadro eliminado.",
    "{n} box styles deleted": "{n} estilos de cuadro eliminados.",
    "{n} box styles updated": "{n} estilos de cuadro actualizados.",
    "{n} box styles saved": "{n} estilos de cuadro guardados.",
    "Keep editing": "Continuar editando",
    "box style save failed": "No se pudieron guardar los estilos de cuadro. Inténtelo de nuevo.",
    "box style deleted": "Estilo de cuadro {box style name} eliminado.",
    "copied to box style library": "{box style name} copiado a la biblioteca de estilos de cuadro.",
    "interactive filters": "filtros interactivos",
    "interactive highlights": "resaltados interactivos",
    "views unavailable to access": "{viewCount} vistas no disponibles",
    "Box style name must be unique": "El nombre del estilo de cuadro debe ser único",
    "Box style name cannot be empty": "El nombre del estilo de cuadro no puede estar vacío",
    "Employee is unassigned from entity": "{employee} no está asignado a {entity}.",
    "Employee is released from entity": "{employee} fue liberado de {entity}.",
    "planning upgrade template": "{Looking to create a strategic future plan?} Consúltenos sobre la actualización a nuestro {workforce planning module}.",
    "authorBlockedFieldTip": "El usuario que realizó este cambio no tenía acceso para ver el valor real de {fieldName}.",
    "view library upgrade message": "Actualice para crear un número ilimitado de vistas personalizadas de organigrama y obtener mayor información sobre su organización. Agregue campos como la antigüedad, el salario y el rendimiento de los empleados en sus cuadros, mejore sus organigramas con los colores de su marca y la codificación de colores de los campos, e incluso señale las vacantes de puestos.",
    "view library upgrade template": "Actualice para crear un {unlimited number of custom org chart views} y obtener mayor información sobre su organización. Agregue campos como la antigüedad, el salario y el rendimiento de los empleados en sus cuadros, mejore sus organigramas con los colores de su marca y la codificación de colores de los campos, e incluso señale las vacantes de puestos.",
    "unlimited number of custom org chart views": "número ilimitado de vistas personalizadas de organigrama",
    "filters upgrade message": "Actualice para utilizar filtros interactivos en su organigrama y mejorar la visibilidad. Con los filtros, puede elegir mostrar solo ciertos registros en su organigrama, como los de ciertos departamentos, ubicaciones y más.",
    "filters upgrade template": "Actualice para utilizar {interactive filters} en su organigrama y mejorar la visibilidad. Con los filtros, puede elegir mostrar solo ciertos registros en su organigrama, como los de ciertos departamentos, ubicaciones y más.",
    "highlights upgrade message": "Actualice para utilizar resaltados interactivos en su organigrama e iluminar instantáneamente a los empleados de departamentos, ubicaciones y más específicos.",
    "highlights upgrade template": "Actualice para utilizar {interactive highlights} en su organigrama e iluminar instantáneamente a los empleados de departamentos, ubicaciones y más específicos.",
    "Upgrade to export": "Actualice para exportar",
    "export upgrade message": "Actualice para exportar su organigrama a los formatos PDF, PPT, PNG, SVG, JPEG y XLSX. Obtenga instantáneamente organigramas listos para presentación con control sobre el tamaño de página, la orientación, el alcance del gráfico y más.",
    "export upgrade template": "Actualice para exportar su organigrama a {PDF, PPT, PNG, SVG, JPEG, and XLSX formats}. Obtenga instantáneamente organigramas listos para presentación con control sobre el tamaño de página, la orientación, el alcance del gráfico y más.",
    "PDF, PPT, PNG, SVG, JPEG, and XLSX formats": "los formatos PDF, PPT, PNG, SVG, JPEG y XLSX",
    "Merge duplicates": "Fusionar duplicados",
    "Merge by field": "Fusionar por campo",
    "The \"{fieldName}\" field is currently excluded from the profile. If you map this field, it will be included in the profile.": "El campo «{fieldName}» está actualmente excluido del perfil. Si asigna este campo, se incluirá en el perfil.",
    "This box layout type is applied to position boxes.": "Este tipo de diseño de casilla se aplica a las casillas de puesto.",
    "Create and manage box styles for your charts. Apply box styles with a View.": "Cree y administre estilos de casilla para sus organigramas. Aplique estilos de casilla con una vista.",
    "Delete box style?": "¿Eliminar el estilo de casilla?",
    "Back to groups": "Volver a la agrupación",
    "Delete group": "Eliminar el grupo",
    "Delete group?": "¿Eliminar el grupo?",
    "Delete group confirm": "Eliminar este grupo lo quitará de su lista de grupos.",
    "autoExportUpgradeMessage": "Actualice para configurar OrgChart y exportar automáticamente los organigramas base. Configure OrgChart para enviar los organigramas base en PDF, PPT o Excel directamente a las bandejas de entrada de las partes interesadas.",
    "autoExportUpgradeTemplate": "Actualice para configurar OrgChart y {automatically export} los organigramas base. Configure OrgChart para enviar los organigramas base en PDF, PPT o Excel directamente a las bandejas de entrada de las partes interesadas.",
    "automatically export": "exportar automáticamente",
    "SharePoint": "SharePoint",
    "Test Connection": "Probar conexión",
    "sharepoint_test_in_progress": "Probando…",
    "sharepoint_test_ok": "Conexión correcta",
    "sharepoint_test_auth_failed": "Error de autenticación — verifique Tenant ID, Client ID y Client Secret",
    "sharepoint_test_folder_failed": "Conectado, pero la biblioteca «Documentos compartidos» no es accesible",
    "sharepoint_test_unreachable": "No se puede acceder a SharePoint — verifique el dominio y la red",
    "sharepoint_test_unknown": "Error en la prueba de conexión",
    "Audit log": "Registro de administrador",
    "admin log upgrade message":
      "Manténgase preparado para auditorías durante todo el año. El registro de administrador captura los cambios de usuarios, permisos y accesos en un registro con marca de tiempo que sus auditores pueden consultar cuando lo necesiten.",
    "admin log upgrade template":
      "Manténgase {preparado para auditorías} durante todo el año. El registro de administrador captura los cambios de usuarios, permisos y accesos en un {registro con marca de tiempo} que sus auditores pueden consultar cuando lo necesiten.",
    "audit-ready": "preparado para auditorías",
    "timestamped record": "registro con marca de tiempo",
    "auditLog.title": "Registro de administrador",
    "auditLog.totalRecords": "Total de registros",
    "auditLog.error.loadFailed": "No se pudieron cargar los registros de administrador.",
    "auditLog.error.exportFailed": "Error al exportar el registro de administrador.",
    "auditLog.error.snapshotFailed": "Error al generar la instantánea de seguridad.",
    "auditLog.filter.startDate": "Fecha de inicio",
    "auditLog.filter.endDate": "Fecha de fin",
    "auditLog.filter.eventType": "Tipo de evento",
    "auditLog.filter.source": "Origen",
    "auditLog.filter.outcome": "Resultado",
    "auditLog.filter.actorId": "ID o correo de usuario",
    "auditLog.filter.targetId": "ID o correo del objetivo",
    "auditLog.action.apply": "Aplicar",
    "auditLog.action.reset": "Restablecer",
    "auditLog.action.exportCsv": "Exportar CSV",
    "auditLog.action.exportXlsx": "Exportar informe Excel",
    "auditLog.action.generateSnapshot": "Generar instantánea",
    "auditLog.pagination.previous": "Anterior",
    "auditLog.pagination.next": "Siguiente",
    "auditLog.pagination.page": "Página",
    "auditLog.column.timestamp": "Marca de tiempo (GMT)",
    "auditLog.column.eventType": "Evento",
    "auditLog.column.outcome": "Resultado",
    "auditLog.column.source": "Origen",
    "auditLog.column.actor": "Actor",
    "auditLog.column.target": "Objetivo",
    "auditLog.column.diffKeys": "Campos modificados",
    "auditLog.column.message": "Mensaje",
    "auditLog.event.userCreate": "Usuario creado",
    "auditLog.event.userDelete": "Usuario eliminado",
    "auditLog.event.userDeleteRequest": "Eliminación de usuario solicitada",
    "auditLog.event.userRoleChange": "Rol de usuario modificado",
    "auditLog.event.userPrivChange": "Grupo de acceso o acceso a organigramas modificado",
    "auditLog.event.userRlsAssign": "Perfil RLS asignado al usuario",
    "auditLog.event.securityGroupUpdate": "Configuración de grupo de acceso modificada",
    "auditLog.event.securityRlsProfileUpdate": "Perfil de seguridad por fila modificado",
    "auditLog.event.securityBlsProfileUpdate": "Perfil de seguridad por rama modificado",
    "auditLog.event.securityImpersonationToggle": "Configuración de suplantación modificada",
    "auditLog.event.securityDirectSigninToggle": "Configuración de inicio directo modificada",
    "auditLog.event.securityAutoAssignmentChange": "Configuración de asignación automática modificada",
    "auditLog.event.securitySsoConfigChange": "Configuración de SSO modificada",
    "auditLog.event.securityAuthorizationDenied": "Autorización denegada",
    "auditLog.event.securityUiProfileUpdate": "Perfil de interfaz modificado",
    "auditLog.event.authLoginImpersonation": "Inicio de sesión por suplantación",
    "auditLog.event.auditReportViewed": "Registro de administrador consultado",
    "auditLog.event.auditReportExported": "Registro de administrador exportado",
    "auditLog.event.auditReportExportedXlsx": "Informe Excel de administrador exportado",
    "auditLog.event.auditSnapshotGenerated": "Instantánea de seguridad generada",
    "auditLog.outcome.success": "Éxito",
    "auditLog.outcome.denied": "Denegado",
    "auditLog.outcome.failed": "Error",
    "auditLog.source.manageUsersUi": "Gestionar usuarios",
    "auditLog.source.authorizationUi": "Autorización",
    "auditLog.source.rlsUi": "Seguridad por fila",
    "auditLog.source.blsUi": "Seguridad por rama",
    "auditLog.source.accessGroupsUi": "Grupos de acceso",
    "auditLog.source.uiProfilesUi": "Perfiles de interfaz",
    "auditLog.source.ssoConfigUi": "Configuración de SSO",
    "auditLog.source.auditLogUi": "Registro de administrador",
    "auditLog.source.bulkImport": "Importación masiva",
    "auditLog.source.api": "API",
    "auditLog.source.system": "Sistema",
    "auditLog.source.unknown": "Desconocido",
    "Welcome to OrgChart!": "¡Bienvenido a OrgChart!",
    "In two quick steps, we'll customize your org chart with your logo and brand colors.": "En dos sencillos pasos, personalizaremos su organigrama con su logotipo y colores de marca.",
    "Upload your logo": "1. Cargar su logotipo",
    "Auto-generates a branded background.": "Genera automáticamente un fondo de marca.",
    "Set brand colors": "2. Establecer colores de marca",
    "Applied to all org chart system boxes.": "Aplicado a todos los cuadros del sistema del organigrama.",
    "Skip setup": "Omitir configuración",
    "Brand setup": "Configuración de marca",
    "Step {current} of {total}": "Paso {current} de {total}",
    "help document": "documento de ayuda",
    "Drag and drop your file here, or click to browse": "Arrastre y suelte su archivo aquí, o haga clic para explorar",
    "file formats": "Formato {formats} – máx. {size} MB",
    "Choose colors for your org chart boxes. They will be applied to all default system boxes and views. You can skip this step and edit later in the Box Layout Editor.": "Elija colores para los cuadros de su organigrama. Se aplicarán a todos los cuadros y vistas del sistema predeterminado. Puede omitir este paso y editarlos más tarde en el Editor de diseño de cuadros.",
    "Box fill color:": "Color de relleno:",
    "Box border color:": "Color de borde:",
    "Preview employee box styles": "Vista previa de estilos de cuadro de empleado",
    "Finish setup": "Finalizar configuración",
    "Go to chart": "Ir al organigrama",
    "You're all set!": "¡Todo listo!",
    "Your brand is applied.": "Su marca ha sido aplicada.",
    "Failed to delete file. Please try again.": "No se pudo eliminar el archivo. Inténtelo de nuevo.",
    "Copy to clipboard": "Copiar al portapapeles",
    "Paste from clipboard": "Pegar desde el portapapeles",
    "Paste views and box styles from clipboard": "Pegar vistas y estilos de cuadro desde el portapapeles",
    "Use the ctrl/cmd V shortcut key to paste your views and box styles from your clipboard.": "Utilice el atajo de teclado ctrl/cmd V para pegar sus vistas y estilos de cuadro desde el portapapeles.",
    "Failed to import views. Please try again.": "Error al importar las vistas. Inténtelo de nuevo.",
    "Paste from your clipboard.": "Pegar desde su portapapeles.",
    "Import views": "Importar vistas",
    "Failed to paste views. Please copy views and box styles and try again.": "Error al pegar las vistas. Copie las vistas y estilos de cuadro e inténtelo de nuevo.",
    "Views and box styles pasted from clipboard.": "Vistas y estilos de cuadro pegados desde el portapapeles.",
    "Export views and box styles": "Exportar vistas y estilos de cuadro",
    "Views and box styles copied to your clipboard.": "Vistas y estilos de cuadro copiados en su portapapeles.",
    "Views and box styles imported successfully.": "Vistas y estilos de cuadro importados correctamente.",
    "No filters created yet": "Aún no se han creado filtros.",
    "Grouping tab description": "Agrupe las casillas por categoría para organizar el organigrama y facilitar su lectura.",
    "No groups created yet": "Aún no se han creado grupos",
    "No sort keys added yet": "Aún no se han agregado claves de ordenación",
    "No disconnected records found": "No se encontraron registros desconectados.",
    "No changes have been made yet.": "Aún no se han realizado cambios.",
    "Staging info": "Staging almacena temporalmente los registros desconectados. Arrastre registros desde Staging al organigrama para establecer relaciones de dependencia. Arrastre registros a Staging para desconectarlos (las ramas se desplazan juntas).",
    "exportFilenameInvalidChars": "El nombre del archivo no puede contener: \\ / : * ? \" < > |",
    "Shared filter update error": "Error al actualizar",
    "Shared filter delete error": "Error al eliminar",
    "Dismiss": "Ignorar",
    "Got it": "Entendido",
    "Let's go": "¡Vamos!",
    "Welcome to Your Charts, Powered by OrgChart!": "¡Bienvenido a sus organigramas, con tecnología de OrgChart!",
    "Take the tour to get started and learn more!": "¡Realice el recorrido para comenzar y obtener más información!",
    "21 days": "21 días",
    "premium org chart features": "funciones premium de organigrama",
    "isolvedFreeTrialMessage": "Durante los próximos 21 días, tendrá acceso gratuito a funciones premium de organigrama exclusivas de isolved, incluida la exportación de organigramas, el resaltado de información y múltiples vistas de gráficos.",
    "isolvedFreeTrialTemplate": "Durante los próximos {21 days}, tendrá acceso gratuito a {premium org chart features} exclusivas de isolved, incluida la exportación de organigramas, el resaltado de información y múltiples vistas de gráficos.",
    "Click on the view switcher to change the information that is displayed on the chart. Your chart comes with three pre-installed views.": "Haga clic en el selector de vista para cambiar la información que se muestra en el organigrama. Su organigrama incluye tres vistas preinstaladas.",
    "Use the levels control to increase or decrease the amount of organizational levels displayed on a single page.": "Utilice el control de niveles para aumentar o disminuir la cantidad de niveles organizativos que se muestran en una sola página.",
    "Create filters to show specific records. For example, filter your chart to just see Full Time employees. Create highlights to illuminate specific records. For example, quickly highlight employees who work in New York.": "Cree filtros para mostrar registros específicos. Por ejemplo, filtre su organigrama para ver solo los empleados a tiempo completo. Cree resaltados para iluminar registros específicos. Por ejemplo, resalte rápidamente a los empleados que trabajan en Nueva York.",
    "Instantly get presentation-ready org charts. Export your chart to PPT, PDF, SVG, and additional formats.": "Obtenga instantáneamente organigramas listos para presentaciones. Exporte su organigrama a PPT, PDF, SVG y formatos adicionales.",
    "brandedBackgroundMessage": "Su logo generará un fondo personalizado para su organigrama. OrgChart le permite tener varios logotipos. Consulte este documento de ayuda para obtener más información. Haga clic en « Continuar » para omitir este paso.",
    "brandedBackgroundTemplate": "Su logo generará un fondo personalizado para su organigrama. OrgChart le permite tener varios logotipos. Consulte {help document} para obtener más información. Haga clic en « Continuar » para omitir este paso.",
    "Brand colors could not be saved. Please try again or skip setup.": "Los colores de marca no se pudieron guardar. Vuelva a intentarlo u omita la configuración.",
    "Logo could not be saved. Please try again or skip setup.": "El logo no se pudo guardar. Vuelva a intentarlo u omita la configuración.",
    "Resource center": "Centro de recursos",
    "Help documentation": "Documentación de ayuda",
    "Learn about specific topics": "Más información sobre temas específicos",
    "Submit a support ticket": "Enviar un ticket de soporte",
    "Onboarding": "Incorporación",
    "Take a tour of our core features": "Descubra nuestras funciones principales",
    "Entity filter created": "Filtro {entity} creado.",
    "Entity highlight created": "Resaltado {entity} creado.",
    "Entity group created": "Grupo {entity} creado.",
    "View rule saved": "Regla de vista guardada.",
    "Chart scope changes saved": "Cambios en el alcance del gráfico guardados.",
    "Entity rule renamed": "{entity} renombrado.",
    "Enter rule definition": "Introducir la definición de la regla",
    "<blank>": "<blank>",
    "SCIMSectionTitle": "Aprovisionamiento SCIM",
    "SCIMUpgradeBody": "Mejore su plan para activar SCIM y gestionar el aprovisionamiento de usuarios, la asignación de grupos y la desactivación directamente desde su IdP.",
    "SCIMUpgradeTemplate": "Mejore su plan para {bold1} y gestionar el aprovisionamiento de usuarios, la asignación de grupos y la desactivación {bold2}.",
    "SCIMUpgradeBold1": "activar SCIM",
    "SCIMUpgradeBold2": "directamente desde su IdP",
    "SCIMTokenPanelIntro": "Emita un token bearer para su proveedor de identidad (por ejemplo, Okta) para que pueda aprovisionar, actualizar y desaprovisionar usuarios mediante SCIM 2.0. Los tokens se muestran una sola vez al crearlos y no se pueden recuperar después.",
    "SCIMTokenGenerate": "Generar token",
    "SCIMTokenCopy": "Copiar",
    "SCIMTokenDismiss": "Cerrar",
    "SCIMTokenNewTitle": "Token creado",
    "SCIMTokenNewWarning": "Copie este token ahora. No se podrá volver a mostrar.",
    "SCIMTokenNoneActive": "No se ha emitido ningún token SCIM para esta cuenta.",
    "SCIMTokenCreatedBy": "Creado por",
    "SCIMTokenCreatedAt": "Creado",
    "SCIMTokenLastUsed": "Último uso",
    "SCIMTokenListError": "No se pudieron cargar los tokens SCIM.",
    "SCIMTokenCreateError": "No se pudo crear el token SCIM.",
    "SCIMTokenDeleteError": "No se pudo eliminar el token SCIM.",
    "SCIMSAMLConflictTitle": "El aprovisionamiento automático SCIM y SAML están ambos activados",
    "SCIMSAMLConflictBody": "Ambos sistemas pueden escribir en los mismos registros de usuario. Los atributos SAML prevalecen sobre los valores SCIM al iniciar sesión. Para evitar inconsistencias, desactive el aprovisionamiento automático en la configuración SSO o elimine el token SCIM.",
    "No functional statement": "Sin enunciado funcional",
    "Functional Statement": "Enunciado funcional",
    "Chart Navigator": "Navegador de organigrama",
    "Navigator": "Navegador",
    "Point in Time": "Punto en el tiempo",
    "No results": "Sin resultados",
    "PDF Export Only": "Solo exportación a PDF",
    "Include Functional Statements": "Incluir enunciados funcionales",
    "includeFunctionalStatementsHelper": "Añadir al final de la exportación una página con el enunciado funcional de cada unidad",
    "disableFunctionalStatementsSwitch": "Los enunciados funcionales solo están disponibles para exportaciones de organigrama completo. Vaya a la pestaña general y actualice el alcance a organigrama completo.",
    "includeExcelFunctionalStatementsHelper": "Añadir una columna con el enunciado funcional de cada unidad",
    "isolvedMissingJobDataErrTitle": "Datos de puesto incompletos o faltantes",
    "isolvedMissingJobDataErrAdmin": "Los datos de puesto están incompletos o faltan. Confirme que los empleados tengan gerentes y títulos asignados; el organigrama se actualizará en una hora.",
    "isolvedMissingJobDataErrUser": "Los datos de puesto están incompletos o faltan. Póngase en contacto con su administrador de isolved para verificar que los empleados tengan gerentes y títulos asignados.",
    "isolvedMappingMissingManagerTitle": "Relaciones jerárquicas de gerente no detectadas",
    "isolvedMappingMissingManagerAdmin": "No hemos detectado ninguna relación jerárquica en su asignación de supervisor actual. Existen relaciones jerárquicas con assigned supervisor ID. ¿Desea actualizar la asignación de supervisor para utilizar assigned supervisor ID en su lugar?",
    "isolvedMappingMissingManagerUser": "No se detectaron relaciones jerárquicas en isolved para la asignación de supervisor actual de su organigrama. Póngase en contacto con su administrador de isolved para actualizar la asignación de supervisor.",
    "isolvedMappingIncompleteManagerTitle": "Relaciones jerárquicas de gerente incompletas",
    "isolvedMappingIncompleteManagerAdmin": "A algunos empleados les falta una relación jerárquica en su asignación de supervisor actual. Hemos detectado que las relaciones jerárquicas creadas con assigned supervisor ID están más completas. ¿Desea actualizar la asignación de supervisor para utilizar assigned supervisor ID? Si prefiere conservar su asignación actual, asegúrese de que todos los empleados tengan un valor en isolved.",
    "isolvedMappingIncompleteManagerUser": "A algunos empleados les falta una relación jerárquica en isolved para la asignación de supervisor actual de su organigrama. Póngase en contacto con su administrador de isolved para revisar la asignación de supervisor.",
    "isolvedMappingMissingSupervisorTitle": "Relaciones jerárquicas de supervisor no detectadas",
    "isolvedMappingMissingSupervisorAdmin": "No hemos detectado ninguna relación jerárquica en su asignación de supervisor actual. Existen relaciones jerárquicas con assigned manager ID. ¿Desea actualizar la asignación de supervisor para utilizar assigned manager ID en su lugar?",
    "isolvedMappingMissingSupervisorUser": "No se detectaron relaciones jerárquicas en isolved para la asignación de supervisor actual de su organigrama. Póngase en contacto con su administrador de isolved para actualizar la asignación de supervisor.",
    "isolvedMappingIncompleteSupervisorTitle": "Relaciones jerárquicas de supervisor incompletas",
    "isolvedMappingIncompleteSupervisorAdmin": "A algunos empleados les falta una relación jerárquica en su asignación de supervisor actual. Hemos detectado que las relaciones jerárquicas creadas con assigned manager ID están más completas. ¿Desea actualizar la asignación de supervisor para utilizar assigned manager ID? Si prefiere conservar su asignación actual, asegúrese de que todos los empleados tengan un valor en isolved.",
    "isolvedMappingIncompleteSupervisorUser": "A algunos empleados les falta una relación jerárquica en isolved para la asignación de supervisor actual de su organigrama. Póngase en contacto con su administrador de isolved para revisar la asignación de supervisor.",
    "isolvedMappingNoneDetectedTitle": "No se detectaron relaciones jerárquicas",
    "isolvedMappingNoneDetectedAdmin": "No se puede crear un organigrama porque no se detectaron relaciones jerárquicas. Asegúrese de que los empleados tengan un gerente o supervisor asignado en isolved; el organigrama se actualizará en una hora.",
    "isolvedMappingNoneDetectedUser": "No se puede crear un organigrama porque no se detectaron relaciones jerárquicas en isolved. Póngase en contacto con su administrador de isolved para asegurarse de que los empleados tengan un gerente o supervisor asignado.",
    "isolvedMissingJobIdErrTitle": "Falta la asignación de puesto",
    "isolvedMissingJobIdErrAdmin": "Ninguno de sus empleados de isolved tiene una asignación de puesto en su instancia laboral. Asigne un puesto a cada empleado en isolved y el organigrama se actualizará en una hora.",
    "isolvedMissingJobIdErrUser": "Ningún empleado de su organización en isolved tiene una asignación de puesto. Póngase en contacto con su administrador de isolved para completar estos puestos.",
    "Unlock": "Desbloquear",
    "Unlock advanced security": "Desbloquee la seguridad avanzada",
    "Unlock plan approvals": "Desbloquee las aprobaciones de planes",
    "Unlock planning": "Desbloquee la planificación",
    "Unlock point in time": "Desbloquee Punto en el tiempo",
    "access groups upgrade message": "Cree grupos de acceso personalizados para controlar exactamente quién puede ver, editar y administrar organigramas, carpetas y datos específicos en su organización.",
    "access groups upgrade template": "Cree {grupos de acceso personalizados} para controlar exactamente quién puede ver, editar y administrar organigramas, carpetas y datos específicos en su organización.",
    "custom access groups": "grupos de acceso personalizados",
    "ui profiles upgrade message": "Controle el acceso a determinados elementos de la interfaz, de modo que los usuarios vean exactamente lo que necesitan.",
    "ui profiles upgrade template": "Controle el acceso a {determinados elementos de la interfaz}, de modo que los usuarios vean exactamente lo que necesitan.",
    "certain UI elements": "determinados elementos de la interfaz",
    "Unlock access groups": "Desbloquee los grupos de acceso",
    "Unlock UI profiles": "Desbloquee los Perfiles de UI",
    "Unlock Admin Log": "Desbloquee el registro de administrador",
    "Agent profile": "Perfil del agente",
    "Agent profile card": "Tarjeta de perfil del agente",
    "Agent profile desc": "Elija los datos que se mostrarán en las tarjetas de perfil del agente.",
    "Card header information": "Información del encabezado de la tarjeta",
    "About me": "Acerca de mí",
    "Lifecycle and governance details": "Detalles del ciclo de vida y gobernanza",
    "Lifecycle and governance": "Ciclo de vida y gobernanza",
    "Adoption & activity": "Adopción y actividad",
    "Adoption and activity": "Adopción y actividad",
    "Additional details": "Detalles adicionales",
    "view here": "ver aquí",
    "Agent audit log": "Registro de auditoría",
    "last ran {n} days ago": "última ejecución hace {n} días",
    "Identity": "Identidad",
    "Technical": "Técnico",
    "Cost": "Costo",
    "Alerts": "Alertas",
    "Action breakdown": "Desglose de acciones",
    "1 employee affected": "1 empleado afectado",
    "{n} employees affected": "{n} empleados afectados",
    "Open alert details": "Abrir los detalles de la alerta",
    "Agent name": "Nombre del agente",
    "Agent type": "Tipo de agente",
    "About": "Acerca de",
    "Detail link": "Enlace de detalles",
    "Last updated": "Última actualización",
    "Model used": "Modelo utilizado",
    "Models used": "Modelos utilizados",
    "Platform": "Plataforma",
    "Review frequency": "Frecuencia de revisión",
    "Access scope": "Alcance de acceso",
    "Audit log link": "Enlace al registro de auditoría",
    "Date created": "Fecha de creación",
    "Date deployed": "Fecha de implementación",
    "Errors prevented": "Errores evitados",
    "Auto-corrections": "Correcciones automáticas",
    "Items reviewed": "Elementos revisados",
    "Items reviewed (last pay cycle)": "Elementos revisados (último ciclo de pago)",
    "Time saved": "Tiempo ahorrado",
    "Time saved (this month)": "Tiempo ahorrado (este mes)",
    "Active users": "Usuarios activos",
    "Approval rate": "Tasa de aprobación",
    "Days since last use": "Días desde el último uso",
    "Requests made": "Solicitudes realizadas",
    "Sessions": "Sesiones",
    "Sessions (this month)": "Sesiones (este mes)",
    "Agent spend": "Gasto del agente",
    "Token spend": "Consumo de tokens",
    "Token spend (this month)": "Consumo de tokens (este mes)",
    "Critical alerts": "Alertas críticas",
    "Open alerts": "Alertas abiertas",
    "Top alerts": "Alertas principales",
    "Auto-applied": "Aplicado automáticamente",
    "Resolved": "Resuelto",
    "Dismissed": "Descartado",
    "Full name (Title)": "Nombre completo (Título)",
    "Agent View": "Vista de agente",
    "Add to library": "Añadir a la biblioteca",
    "Edit record details": "Editar detalles del registro",
    "exportFailedTitle": "Exportación fallida",
    "exportFailedMsg": "No se pudo crear la exportación. Inténtelo de nuevo. Si el problema persiste, contacte a soporte técnico.",
    "Drill down available": "Desglose hacia abajo disponible",
    "Drill up available": "Desglose hacia arriba disponible",
    "Drill down": "Desglosar hacia abajo",
    "Drill up": "Desglosar hacia arriba",
    "Chart keyboard help": "Organigrama. Utilice las teclas de flecha para moverse entre los recuadros, Intro para abrir las acciones del recuadro, y Alt más flecha arriba o abajo para desglosar. Pulse Tab para salir del organigrama."
}
